import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TimepickerConfig } from 'ngx-bootstrap/timepicker';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { FormCanDeactivate, PatientService, User, UserService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';

declare function showMarkerArea(): any;

export function getTimepickerConfig(): TimepickerConfig {
  return Object.assign(new TimepickerConfig(), {
    hourStep: 1,
    minuteStep: 10,
    showMeridian: true,
    readonlyInput: false,
    mousewheel: true,
    showMinutes: true,
    showSeconds: false,
    showSpinners: false
  });
}

@Component({
  selector: 'app-viewsummary',
  templateUrl: './viewsummary.component.html',
  styleUrls: ['./viewsummary.component.css'],
  providers: [{ provide: TimepickerConfig, useFactory: getTimepickerConfig }]
})
export class ViewsummaryComponent extends FormCanDeactivate {
  pr: NgForm;
  bundleStatus: boolean;
  bundleEndDateStatus: boolean;
  paramsdos: any;
  dosstatus: any;
  dayinterval: any;
  setmask3: any;
  setmask2: any;
  setmask: any;
  mask2: any;
  item: any;
  maxlen3: any;
  setlength3: any;
  maxlen2: any;
  setlength2: any;
  maxlen: any;
  setlength: any;
  getbmi: any[];
  savebmi: any;
  contactSaveBtn: boolean = false;
  enddate: string;
  startdate: string;
  showdatenew: any;
  tempobj1: string;
  tempobj: any;
  pdfUrl: any;
  payorType: string;
  isfcn: boolean;
  isccn: boolean;
  plannadmin: boolean = false;
  gcpnew: boolean;
  maxdate18: boolean;
  reass: boolean = false;
  selpat: string = 'Reassign To';
  patient: any;
  lengthcn: any;
  careList: any;
  selCare: string;
  modalRef1: BsModalRef;
  public caremap: any = environment.practiceid;
  configuredate: number = 5;
  aother: any;
  pother: any;
  descriptionchange: any = '';
  dueStatus: string;
  custchange: string = this.userService.translateText('patient_portal.assessment.complete.label');
  mintododata: Date = new Date();
  cusstatus: any;
  patientpacmasterid: any = '';
  mytodostatus: any = "Current";
  pacstatus: any = 'Current';
  planned: string;
  otherpac: [any];
  public reassign = {}
  dateform = environment.dateForm
  dateFormat = {
    date: {
      pipe: this.dateform
    }
  };
  tempphone: any;
  menu: any = "N";
  status: any;
  surdis: boolean;
  mintimeset: number;
  public patientAppoinmentList = [];
  checkDos: Date;
  modaldata: any;
  patname: string;
  gcpbeyond: any;
  tempdate: any;
  textenable: boolean;
  maxpdate12: boolean;
  maxpActualDate: boolean;
  showinvaild21: boolean;
  maxdate11: boolean;
  showinvaild11: boolean;
  enabledisid: boolean;
  admitdate: Date;
  planneddis: boolean = false;
  totpac: number = 91.5;
  lineheight: number = 91.5;
  ModelRef125: BsModalRef;
  ModelRef124: BsModalRef;
  ModelRef41: BsModalRef
  setmin: Date;
  length: number;
  mindate: Date;
  ind: number;
  enableagency: boolean = true;
  counttwo3: number = 0;
  counttwo2: number = 0;
  ModelRef123: BsModalRef;
  ModelRef12: BsModalRef;
  update: boolean = false;
  save: boolean = false;
  public showwelcom: any = [{
  }];
  selectedItemKeys: any[] = [];
  alert: boolean = false;
  i: any;
  emp: any;
  showdatd: string;
  public delid: any;
  public pacdata: any = {

  };
  public tractionlist: any;
  public traction: any;
  maxasdate: boolean;
  maxpsdate: boolean;
  maxActualEnd: boolean;
  maxpdate: boolean;
  actualMaxDate: boolean;
  maxdate: boolean = false;
  mindos: Date;
  hospitalid: string;
  temp: any = [];
  temp1: any = [];
  public bobMaxDate = new Date();
  public dosMaxDate = new Date(this.bobMaxDate.getTime())
  public dateformat = environment.dateFormat;
  public bsConfig: any
  showinvaild: boolean = false;
  dosvalue = ''
  plannedvalue = ''
  messages: any = 'Notes';
  mesg: any = 'Trigger Message';
  @ViewChild('carePlanForm')
  form: NgForm;
  @ViewChild('scrollMe')
  private myScrollContainer: ElementRef;
  ennable: number;
  ennablepat: number;
  surr: any;
  enablepatient: boolean = false;
  public timealert = environment.timelimit;
  showloader: boolean = false;
  public showend: boolean = false;
  catgoryid: any;
  public apiurl: any = environment.api_url;
  public ModelRef: BsModalRef;
  public ModelRef1: BsModalRef;
  public modalRef: BsModalRef;
  tempvar: boolean;
  temp_var: any;
  details: any;
  userId: any;
  uid: any
  user: any = {};
  patdisqualifi: any = {};
  currentUser: User;
  public carePath: any = {
    selCare: '',
    dischargeTypeList: [],
    dischargehospitalList: [],
    dcode: '+1,USA',
    name: 'Community Hospital'
  };
  public careSPath: any = {
    dischargeTypeList: [],
    dischargehospitalList: [],
    dcode: '+1,USA'
  };
  public pac: any = {

  };
  public showdata: any = {

  }
  public timeArray = [
    {
      value: '07:00 AM',
      name: '07:00 AM',
      check: 7
    },
    {
      value: '07:30 AM',
      name: '07:30 AM',
      check: 7.5
    },
    {
      value: '08:00 AM',
      name: '08:00 AM',
      check: 8
    },
    {
      value: '08:30 AM',
      name: '08:30 AM',
      check: 8.5
    },
    {
      value: '09:00 AM',
      name: '09:00 AM',
      check: 9
    },
    {
      value: '09:30 AM',
      name: '09:30 AM',
      check: 9.5
    },
    {
      value: '10:00 AM',
      name: '10:00 AM',
      check: 10
    },
    {
      value: '10:30 AM',
      name: '10:30 AM',
      check: 10.5
    },
    {
      value: '11:00 AM',
      name: '11:00 AM',
      check: 11
    },
    {
      value: '11:30 AM',
      name: '11:30 AM',
      check: 11.5
    },
    {
      value: '12:00 PM',
      name: '12:00 PM',
      check: 12
    },
    {
      value: '12:30 PM',
      name: '12:30 PM',
      check: 12.5
    },
    {
      value: '01:00 PM',
      name: '01:00 PM',
      check: 13
    },
    {
      value: '01:30 PM',
      name: '01:30 PM',
      check: 13.5
    },
    {
      value: '02:00 PM',
      name: '02:00 PM',
      check: 14
    },
    {
      value: '02:30 PM',
      name: '02:30 PM',
      check: 14.5
    },
    {
      value: '03:00 PM',
      name: '03:00 PM',
      check: 15
    },
    {
      value: '03:30 PM',
      name: '03:30 PM',
      check: 15.5
    },
    {
      value: '04:00 AM',
      name: '04:00 PM',
      check: 16
    },
    {
      value: '04:30 PM',
      name: '04:30 PM',
      check: 16.5
    },
    {
      value: '05:00 PM',
      name: '05:00 PM',
      check: 17
    },
    {
      value: '05:30 PM',
      name: '05:30 PM',
      check: 17.5
    },
    {
      value: '06:00 PM',
      name: '06:00 PM',
      check: 18
    },
    {
      value: '06:30 PM',
      name: '06:30 PM',
      check: 18.5
    },
    {
      value: '07:00 PM',
      name: '07:00 PM',
      check: 19
    }
  ]

  myTodos: any = [];
  myTodosLast: any;
  public description: string;
  public description1: string;
  public description2: string;
  public imageURL: string = environment.cloudeImageURL;
  public actualDateAvailable: boolean = false;
  contacts: any = [];
  trigger: any = [];
  firstmsg: any = [];
  firsttime: any = [];
  firstdate: any = [];
  notes: any = [];
  cpnotes: any = [];
  assessments: any = [];
  Sassessments: any = [];
  public codes = [];
  public params: any;
  public dispalnid: string;
  public actid: string;
  public data: Object;
  public countone = 0;
  public counttwo = 0;
  public planneddisabled: boolean = false;
  public showpac: boolean = false
  public showthd: boolean = false;
  public planndisabled: boolean = false;
  public disabled: boolean;
  dataimg: any;
  survey: any;
  public userIdStr: string;
  public dosStatus: string = 'notSelected';
  public plannedStatus: string = 'notSelected';
  public actualStatus: string = 'notSelected';
  public makeAllDisable: boolean = false;
  public planDisable: boolean = true;
  public makeActualDate: boolean = false;
  public dosstatusdate: boolean = false;
  public enabledPlanned: boolean = false;
  public enabledActual: boolean = false;
  public actualCategory: boolean = false;
  public maxActualDate = new Date();
  public minActualDate: any;
  public pacmapid: any;
  mytodo: any;
  public downloadUrl: any = environment.downloadUrl;
  partnerdetail: any = {}
  public sentdata: any = {}
  dischargeDispositionPlanId: number;
  lastmsg: any = [];
  lastmg: any;
  dsdate: boolean;
  showinvaild1: boolean = false;
  showinvaild2: boolean = false;
  showinvaild3: boolean = false;
  showinvaild4: boolean = false;
  showinvaild5: boolean = false;
  schedule: boolean = false;
  schedule1: boolean = false;
  myTodosLastpat: any;
  postacut: boolean = false;
  enabletext: boolean = true;
  enabletextpac: boolean = false;
  enabletextpacedit: boolean = false;
  enabledischarge: boolean = false;
  dischargetype: any;
  enableactual: boolean = false;
  numberofactualvisits: any;
  actualvisits: string;
  newreq: boolean;
  Download: boolean;
  view: boolean;
  edit: boolean;
  ModelRef4: BsModalRef;
  visit: any;
  ennableactualvisit: boolean = true;
  otherevent: boolean = false;
  commercial: any;
  Qnote: any;
  qualification: any;
  reason: any;
  bundleid: any;
  newAttribute: any = {};
  patientlength: any[];
  patlength: number;
  surgerydate: Date;
  minsurgerydate: Date
  scheduledate: boolean = false;
  dischargedate: Date;
  currentdata: Date;
  currentdate: Date = new Date();
  showbutton: any;
  addnew: boolean = false;
  disableAddNew: boolean = false;
  defaultpatlist: any[];
  disableSubmit: boolean = false;
  disresult: any;
  selectedUserId: any;
  constructor(
    private modalService: BsModalService,
    private patientservice: PatientService,
    private router: ActivatedRoute,
    private nav: Router,
    private Datepipe: DatePipe,
    private Modalservice: BsModalService,
    private toast: ToastrService,
    private localeService: BsLocaleService,
    private userService: UserService,
    private translate: TranslateService
  ) {
    super();
    this.translate.setDefaultLang(userService.defaultLang);
    enGbLocale.invalidDate = '';
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
  }
  ngOnDestroy() {
    if (this.ModelRef)
      this.ModelRef.hide()
    if (this.ModelRef125)
      this.ModelRef125.hide()
    if (this.ModelRef124)
      this.ModelRef124.hide()
    if (this.ModelRef41)
      this.ModelRef41.hide()
    if (this.ModelRef123)
      this.ModelRef123.hide()
    if (this.ModelRef1)
      this.ModelRef1.hide()
    if (this.ModelRef4)
      this.ModelRef4.hide()
    if (this.ModelRef124)
      this.ModelRef124.hide()
    window.localStorage.removeItem('activepswfid')

  }

  ngOnInit() {
    this.userService.tempVar.subscribe(data => {
      if (data.patSWFId) {
        this.userId = data.patSWFId
        this.params = data
        this.dosstatus = data.status
        this.paramsdos = data.dos
        window.localStorage['patSWFId'] = btoa(JSON.stringify(data))
      }
      else if (window.localStorage['patSWFId']) {
        this.params = JSON.parse(atob(window.localStorage['patSWFId']))
        this.userId = this.params.patSWFId
        this.dosstatus = this.params.status
        this.paramsdos = this.params.dos
      }
    })
    this.user.patEmailValid = true;
    this.user.patPhoneValid = true;
    this.initFunction();
    this.currentdate.setDate(this.currentdate.getDate());
    this.fetchDischargeList();
    this.getAllEventList();
    const obj = {
      "loginUaId": this.currentUser.item.userAccountId,
      "selectedCnUaId": this.patientservice.CN_id,
      "patientSwfId": '',
      "startDateRange": 'N',
      "endDateRange": 'N',
      "pracOrHsp": '',
      "todoViewMode": "",
      "loginHspOrPracId": '',
      "todoCategoryId": '',
      'raHospitalIsOverlap': "",
      'raSurgeonIsOverlap': "",
      "raSurgeonIds": '',
      "raHospitalIds": '',
    }
    this.patientservice.getCountDetailsRaTodoOverLapFilter(obj).subscribe(
      data => {
        this.currentUser.item.mytodolength = data.todoCount
        this.currentUser.item.msgcount = data.messageCount;
      }
    );
  }


  initFunction() {
    this.dosMaxDate.setDate(this.dosMaxDate.getUTCDate() + 365);
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (this.currentUser.item) {
          this.bundleStatus = this.currentUser.item.bundleStatus;
          this.bundleEndDateStatus = this.currentUser.item.bundleEndDateStatus
          this.selectedUserId = this.currentUser.item.userAccountId;
          this.mask2 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          this.setmask2 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          this.setmask3 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          if (this.currentUser.item.language != 'en_uk') {
            this.carePath.dcode = '+1,USA'

          } else if (this.currentUser.item.language == 'en_uk') {
            this.carePath.dcode = '+44,UK'
          }
          if (this.currentUser.item.clientTeleCode)
            this.carePath.dcode = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode

          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
            this.dateform = environment.dateForm
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
            this.dateform = 'dd/MM/yyyy'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        }
      }
    );

    this.configureEventTypeFetch();
    this.hospitalid = this.currentUser.item.userAccountKey;
    this.uid = this.currentUser.item.userAccountId;
    let self = this;
    self.plannadmin = false;
    self.configuredate = 5;
    self.aother = "";
    self.pother = "";
    self.carePath = "";
    self.careSPath = "";
    self.descriptionchange = '';
    self.dueStatus = '';
    self.mintododata = new Date();
    self.custchange = this.userService.translateText('patient_portal.assessment.complete.label');
    self.pacstatus = 'Current';
    self.mytodostatus = 'Current';
    self.countone = 0;
    self.counttwo = 0;
    self.counttwo3 = 0;
    self.counttwo2 = 0;
    self.planneddisabled = false;
    self.showpac = false
    self.planndisabled = false;
    self.planneddis = false;
    self.dosStatus = 'notSelected';
    self.plannedStatus = 'notSelected';
    self.actualStatus = 'notSelected';
    self.makeAllDisable = false;
    self.planDisable = true;
    self.makeActualDate = false;
    self.dosstatusdate = false;
    self.enabledPlanned = false;
    self.enabledActual = false;
    self.actualCategory = false;
    self.enabledisid = false;
    self.showinvaild1 = false;
    self.showinvaild2 = false;
    self.showinvaild3 = false;
    self.showinvaild4 = false;
    self.showinvaild5 = false;

    self.postacut = false;
    self.enabletext = true;
    self.enabletextpac = false;
    self.enabletextpacedit = false;
    self.enabledischarge = false;

    self.enableactual = false;

    self.ennableactualvisit = true;
    self.getmenu()
    self.getselect()
    self.checkconfiguredate();
    self.logginDetails()
    this.getPlannedInterval()
    self.getUserDetails()

    self.getCareplanAssesment()
    self.getContactHistory()
    self.getNotesHistory()
    self.getreadmissionavaliable()
    //self.getCpNotesHistory()

    /*** Need */
    self.getMytodos()

    self.getContacttrigger()
    self.getdescription()
    //self.pacview();
    self.GcpBeyond();
    self.loadCareList();
    self.getAppoinmentsList(this.userId)
    self.qstage()

    self.reasonstage()

  }
  readmin: any;
  getreadmissionavaliable() {
    this.userService.getReadmission(this.userId).subscribe(
      data => {
        if (data) {
          this.readmin = data
        }
      }
    )
  }
  date: any = {
    'dos': "05/02/2018",
    'planned': "04/12/2018",
    'actual': "05/05/2018",
    'agencyplanned': "04/17/2018",
    'agencyactual': "04/17/2018",
    'plannedlos': "8",
    'actuallos': "8",
    'dischargeplanned': "SNF",
    // 'format':"MM/DD/YYYY",
    'facilityplanned': "Danube Senior Living",
  }
  updatedetils(id, swfid, patientName) {
    this.nav.navigate([`care/patsummary/${id}/${swfid}/${patientName}`])
  }

  logginDetails() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;

        // this.userIdStr = `&userId=1${this.currentUser.item.userAccountId}`;

      }
    )
  }
  changeTab(e) {
    this.messages = e;
  }
  changeTabs(e) {
    this.mesg = e;
  }



  changeTime(event, i) {

    this.allstatus()

    var result = this.find_duplicate_in_array(this.patientAppoinmentList)
    if (result.length > 0) {
      if (i >= this.patlength) {
        let applist = this.patientAppoinmentList.slice(0, -1);
        let index = _.findIndex(applist, (o: any): any => {
          return (o.appointmentTitle == event.appointmentTitle && o.appointmentDate.setHours(0, 0, 0, 0) == event.appointmentDate.setHours(0, 0, 0, 0) && o.appointmentTime == event.appointmentTime)
        })


        if (index != -1) {
          if (i >= this.patlength) {
            this.scheduledate = true
            this.disableAddNew = true

            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
          else if (i < this.patlength) {
            this.scheduledate = true
            this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentTitle = ''
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
        }
        else {
          this.scheduledate = false
          this.patientAppoinmentList[i].appmntModified = true
          if (i < this.patlength) {
            this.getAppoinmentsListwitSWFid(this.userId, i)
          } else {
            this.patientAppoinmentList[i].appmntStatus = 'New'
          }
        }
      }
      else if (i < this.patlength) {
        // let applist = this.patientAppoinmentList.slice(0, -1);
        const filteredItems = this.patientAppoinmentList.slice(0, i).concat(this.patientAppoinmentList.slice(i + 1, this.patientAppoinmentList.length))
        let index = _.findIndex(filteredItems, (o: any): any => {
          return (o.appointmentTitle == event.appointmentTitle && o.appointmentDate.setHours(0, 0, 0, 0) == event.appointmentDate.setHours(0, 0, 0, 0) && o.appointmentTime == event.appointmentTime)
        })


        if (index != -1) {
          ////console.log(i,this.patlength)
          if (i >= this.patlength) {
            this.scheduledate = true
            this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentTitle = ''
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
          else if (i < this.patlength) {
            this.scheduledate = true
            this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
        }
        else {
          this.scheduledate = false
          this.patientAppoinmentList[i].appmntModified = true
          if (i < this.patlength) {
            this.getAppoinmentsListwitSWFid(this.userId, i)
          } else {
            this.patientAppoinmentList[i].appmntStatus = 'New'
          }
        }
      }
    }

  }
  getAppoinmentsListwitSWFid(userid, i) {
    this.patientservice.getAppoinmentsListwitSWFid(this.userId)
      .subscribe(
        data => {
          if (this.carePath.Dos) {
            this.checkDos = new Date(this.modaldata.dos)
          }
          this.tempappmnt = data;
          if (this.tempappmnt[i].appointmentTitle && this.tempappmnt[i].appointmentDate) {
            this.patientAppoinmentList[i].appmntStatus = 'Modify'
          } else {
            this.patientAppoinmentList[i].appmntStatus = 'New'
          }
        })
  }
  find_duplicate_in_array(arra1) {
    var object = {};
    var result = [];

    arra1.forEach(function (item) {
      if (!object[item.appointmentTitle])
        object[item.appointmentTitle] = 0;
      object[item.appointmentTitle] += 1;
    })

    for (var prop in object) {
      if (object[prop] >= 2) {
        result.push(prop);
      }
    }

    return result;

  }
  checkempty(id) {
    var d = new Date(id);
    var timeDiff = Math.ceil(d.getTime() - this.dosMaxDate.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    if ((this.dosvalue != '' && id == '') || id == null || id == 'Invalid Date') {
      this.showinvaild = true
      ////console.log("true")
    } else if ((this.dosvalue == '' || id != '') && id != null) {
      this.showinvaild = false
      ////console.log("false")
    }

    if (diffDays > 0) {

      this.carePath.dos = '';
      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.invalid_date.error'), '', {
        timeOut: this.timealert
      })
      return;

    }

  }

  checkempty1(id) {

    let date = this.Datepipe.transform(id, 'yyyy/MM/dd');
    let curentdate = this.Datepipe.transform(this.carePath.dos, 'yyyy/MM/dd');
    if ((this.plannedvalue != '' && id == '') || id == null || id == 'Invalid Date') {
      this.showinvaild1 = true
      this.maxdate = false;
      ////console.log("true")
    } else if ((this.plannedvalue == '' || id != '') && id != null && date > curentdate) {
      this.showinvaild1 = false
      this.maxdate = false
      ////console.log("false")
    } else if (id != '' && id != null && date < curentdate) {
      this.maxdate = true;
      this.showinvaild1 = false;

    }

  }


  //Max Date Set SNF discharge Date
  checkempty12(id, item) {
    let date
    if (id != 'Invalid Date')
      date = this.changeStringFormat2(id);
    if (id == '' || id == null || id == 'Invalid Date') {
      item.anonymousSnfDischargeDate = null
      item.anonymousenddateRedAlert = false;
    } else if (id != '' && id != null && (date <= "1800-01-01" || item.anonymousSnfDischargeDatemaxdate > item.anonymousSnfDischargeDate)) {
      item.anonymousSnfDischargeDate = null
      item.anonymousenddateRedAlert = true;
      item.trackActualEmptyEndDate = true
    } else {
      item.anonymousenddateRedAlert = false;
    }
  }


  checkempty11(id) {
    ////console.log(id)
    let date = this.Datepipe.transform(id, 'yyyy/MM/dd');
    let curentdate = this.Datepipe.transform(this.carePath.plannedDischargeDate, 'yyyy/MM/dd');
    if ((this.plannedvalue != '' && id == '') || id == null || id == 'Invalid Date') {
      this.showinvaild11 = true
      this.maxdate11 = false;
      ////console.log("true")
    } else if ((this.plannedvalue == '' || id != '') && id != null && date >= curentdate) {
      this.showinvaild11 = false
      this.maxdate11 = false
      ////console.log("false")
    } else if (id != '' && id != null && date < curentdate) {
      this.maxdate11 = true;
      this.showinvaild11 = false;

    }

  }
  checkempty112(id, cusstatus) {
    let today = new Date();
    let curentdate = new Date(this.carePath.duedate)
    today.setDate(today.getDate());
    if (today.setHours(0, 0, 0, 0) <= curentdate.setHours(0, 0, 0, 0)) {
      this.maxdate18 = false;
    }
    if (today.setHours(0, 0, 0, 0) > curentdate.setHours(0, 0, 0, 0)) {
      this.carePath.duedate = '';
      this.maxdate18 = true;
    } else {
      this.maxdate18 = false;
    }

    if (this.mintododata != id && cusstatus == 'edit') {
      this.custchange = "Snooze"
    }
    else if (this.mintododata != id && cusstatus == 'new') {
      this.custchange = this.userService.translateText('patient_portal.constants.submit.label');
    } else {
      this.custchange = this.userService.translateText('patient_portal.assessment.complete.label');
    }



  }
  checkchange(event, dueStatus) {

    this.descriptionchange = 'Y'

  }
  checkempty2(id) {
    ////console.log(id)
    let date = this.Datepipe.transform(id, 'yyyy/MM/dd');
    let curentdate = this.Datepipe.transform(this.carePath.dos, 'yyyy/MM/dd');
    let today = this.Datepipe.transform(new Date(), 'yyyy/MM/dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild2 = true
      this.maxpdate = false;
      this.actualMaxDate = false;
      ////console.log("true")
    } else if (id != '' && id != null && date > curentdate && date <= today) {
      this.showinvaild2 = false
      this.maxpdate = false;
      this.actualMaxDate = false;
      ////console.log("false")
    } else if (id != '' && id != null && date < curentdate) {
      this.maxpdate = true;
      this.showinvaild1 = false;
      this.actualMaxDate = false;

    }
    if (id != '' && id != null && date > curentdate && date > today) {
      this.actualMaxDate = true;
      this.maxpdate = false;
      this.showinvaild1 = false;
    }

  }
  checkempty21(id) {
    ////console.log(id)
    this.maxpActualDate = false;
    let date = this.Datepipe.transform(id, 'yyyy/MM/dd');
    let curentdate = this.Datepipe.transform(this.carePath.actualDischargeDate, 'yyyy/MM/dd');
    let today = this.Datepipe.transform(new Date(), 'yyyy/MM/dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild21 = true
      this.maxpdate12 = false;
      this.maxpActualDate = false;
      ////console.log("true")
    } else if (id != '' && id != null && date > curentdate && date <= today) {
      this.showinvaild21 = false
      this.maxpdate12 = false;
      this.maxpActualDate = false;
      ////console.log("false")
    } else if (id != '' && id != null && date < curentdate) {
      this.maxpdate12 = true;
      this.showinvaild21 = false;
      this.maxpActualDate = false;

    }
    if (id != '' && id != null && date > curentdate && date > today) {
      this.maxpActualDate = true;
      this.maxpdate12 = false;
      this.showinvaild21 = false;
    }

  }
  checkempty2_1(id) {
    ////console.log(id)
    let date = this.Datepipe.transform(id, 'yyyy/MM/dd');
    let curentdate = this.Datepipe.transform(this.carePath.dos, 'yyyy/MM/dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild2 = true
      this.maxpdate = false;
      ////console.log("true")
    } else if (id != '' && id != null && date > curentdate) {
      this.showinvaild2 = false
      this.maxpdate = false;
      ////console.log("false")
    } else if (id != '' && id != null && date < curentdate) {
      this.maxpdate = true;
      this.showinvaild1 = false;

    }

  }
  checkempty3(id) {
    ////console.log("11", id)
    let date = this.Datepipe.transform(id, 'yyyy/MM/dd');
    let curentdate = this.Datepipe.transform(this.carePath.plannedAdmissionDate, 'yyyy/MM/dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild3 = true
      this.maxasdate = false;
      ////console.log("true")
    } else if (id != '' && id != null && date >= curentdate) {
      this.showinvaild3 = false
      this.maxasdate = false;
      ////console.log("false")
    } else if (id != '' && id != null && date < curentdate) {
      this.maxasdate = true;
      this.showinvaild3 = false;

    }
  }

  checkempty4(id) {
    this.maxpsdate = false;
    ////console.log(id)
    let date = this.Datepipe.transform(id, 'yyyy/MM/dd');
    let curentdate = this.Datepipe.transform(this.carePath.actualAdmissionDate, 'yyyy/MM/dd');
    let today = this.Datepipe.transform(new Date(), 'yyyy/MM/dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild4 = true
      this.maxActualEnd = false;
      this.maxpsdate = false;
      ////console.log("true")
    } else if (id != '' && id != null && date > curentdate && date >= today) {
      this.showinvaild4 = false
      this.maxpsdate = false;
      this.maxActualEnd = false;
      ////console.log("false")
    } else if (id != '' && id != null && date < curentdate) {
      this.maxpsdate = true;
      this.showinvaild1 = false;
      this.maxActualEnd = false;

    }
    if (id != '' && id != null && date > curentdate && date > today) {
      this.maxActualEnd = true;
      this.maxpsdate = false;
      this.showinvaild1 = false;
    }

  }
  checkempty5(id) {
    ////console.log(id)
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild5 = true
      ////console.log("true")
    } else if (id != '' && id != null) {
      this.showinvaild5 = false
      ////console.log("false")
    }

  }




  checkplannedDisabled(event) {
    let self = this;
    let dos = new Date(event);
    let today = new Date();
    var timeDiff = Math.abs(dos.getTime() - today.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    if (diffDays == -1) {
      self.planneddisabled = true;
    } else {
      self.planneddisabled = false;
    }
  }
  checkplannDisabled(event) {
    let self = this;
    let date = this.Datepipe.transform(event, 'yyyy/MM/dd');
    if (date) {
      let toDate = new Date();
      toDate.setDate(toDate.getDate() + 1);
      let Dos = new Date(date);
      if (self.myTodos) {
        let enable = _.findIndex(self.myTodos, (o: any): any => {
          return o.categoryId == "6"
        })
        if (toDate.getTime() <= Dos.getTime() && enable == -1) {
          self.plannedStatus = "future"
          self.checkplannedDisabled(Dos);
        }
        if (toDate.getTime() > Dos.getTime() || enable != -1) {
          self.plannedStatus = "past"
        }

      } else {
        self.plannedStatus = 'notSelected'
      }
    }
    let dos = new Date(event);
    let today = new Date();
    var timeDiff = Math.abs(dos.getTime() - today.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    if (diffDays == 1) {
      self.planndisabled = true;
    } else {
      self.planndisabled = false;
    }

    if (!self.actualCategory) {
      self.enableactualTom(event)
    }

  }

  hide() {
    this.carePath.plannedDischargeTypeForOther = ""
    this.carePath.plannedDischargeHospitalId = ""
    this.ModelRef.hide()
  }
  // submitplannedother() {

  //   this.patientservice.showpopother(this.currentUser.item.userAccountKey, this.carePath.plannedDischargeId, this.carePath.plannedDischargeTypeForOther)
  //     .subscribe(data => {
  //       if (data == true) {

  //         this.patientservice.getCarePlanDetails(this.userId, this.uid)
  //           .subscribe(data => {
  //             if (Array.isArray(data) && data.length) {
  //               this.carePath.dischargehospitalList = data[0].dischargehospitalList;
  //             }

  //             let index = _.findIndex(this.carePath.dischargehospitalList, (o: any): any => {
  //               return o.dischargeTo == this.carePath.plannedDischargeTypeForOther
  //             })
  //             if (index != -1) {
  //               this.carePath.plannedDischargeHospitalId = this.carePath.dischargehospitalList[index].dischargeId
  //             }
  //             this.carePath.plannedDischargeTypeForOther = ""
  //             this.ModelRef.hide()

  //           });
  //       }
  //       else {
  //         this.carePath.plannedDischargeTypeForOther = ""
  //       }
  //     });

  // }
  hide1() {
    this.carePath.dname = ""
    this.carePath.dPhone = ""
    this.carePath.dContact = ""
    this.carePath.actualDischargeHospitalId = ""
    this.ModelRef4.hide()
  }

  hideother() {
    this.carePath.other = ''
    this.carePath.dname = ""
    this.carePath.dPhone = ""
    this.carePath.dContact = ""
    this.carePath.otherplannedDischargeId = ""
    this.carePath.otherPacMasterId = ""
    this.carePath.disablepac = ""

    if (this.selectionEventType.anonymousDischargeId == '5' && !this.carePath.pother) {
      this.selectionEventType.anonymousDischargeId = ""
      this.selectionEventType.plannedDdCpDetails.plannedDischargeId = ""
    }
    else if (this.selectionEventType.anonymousDischargeId == '5' && this.carePath.pother) {
      this.selectionEventType.anonymousDischargeId = this.carePath.pother;
      this.selectionEventType.plannedDdCpDetails.plannedDischargeId = this.carePath.pother;
    }

    /*  if (this.carePath.actualDischargeId == '5' && !this.aother)
       this.carePath.actualDischargeId = ""
     else if (this.carePath.actualDischargeId == '5' && this.aother) {
       this.carePath.actualDischargeId = this.aother
     } */

    this.showdata.plannedDischargeId = ""
    this.ModelRef.hide()
  }

  hidetodo() {
    this.carePath.subject = ""
    this.carePath.duedate = ""
    this.carePath.description = ""
    this.cusstatus = ""
    this.dueStatus = ''
    let date = new Date()
    this.mintododata = new Date(date.setHours(0, 0, 0, 0))
    this.ModelRef.hide()
  }
  checklist(other) {
    ////console.log(other, "other")
    let index = _.findIndex(this.otherpac, (o: any): any => {
      return o.hospitalOtherPacMapId == other
    })
    this.carePath.otherPacMasterId = this.otherpac[index].otherPacMasterId
    this.carePath.dname = this.carePath.otherPacMasterId == 4 ?
      '' : this.otherpac[index].hospitalOtherPacMapName
  }

  onetabenable: boolean = false
  othertodo(carepath, custchange, cusstatus) {
    let isSnoozed, success, descChange;
    this.onetabenable = true
    if (custchange == this.userService.translateText('patient_portal.assessment.complete.label') && cusstatus == 'edit') {
      isSnoozed = 'C'
      if (!this.descriptionchange) {
        this.descriptionchange = 'N'
      }
      descChange = this.descriptionchange
      success = this.userService.translateText('patient_portal.display_messages.custom_todo_completed.success');

    } else if (custchange == 'Snooze' && cusstatus == 'edit') {
      isSnoozed = 'Y'
      if (!this.descriptionchange) {
        this.descriptionchange = 'N'
      }
      descChange = this.descriptionchange
      success = this.userService.translateText('patient_portal.display_messages.custom_todo_updated.success');
    } else if (cusstatus == 'delete') {
      this.patientservice.deleteothertodo(this.userId, this.carePath.todoCarePlanSurveyId, 12)
        .subscribe(data => {
          if (data) {
            this.toast.success(this.userService.translateText('patient_portal.display_messages.custom_todo_deleted.success'), '', {
              timeOut: this.timealert
            })
          }
          this.userService.logAudit('DeleteCustomtodo', 0).subscribe(data => { })
          this.hidetodo()
        })

    } else if (cusstatus == 'modify') {
      isSnoozed = 'N'
      if (!this.descriptionchange) {
        this.descriptionchange = 'N'
      }
      descChange = this.descriptionchange
      success = this.userService.translateText('patient_portal.display_messages.custom_todo_updated.success');
    } else {
      isSnoozed = ''
      this.carePath.todoCarePlanSurveyId = 0
      descChange = ''
      success = this.userService.translateText('patient_portal.display_messages.custom_todo_added.success');
    }
    if (cusstatus != 'delete') {
      let assignBy = this.currentUser.item.userAccountId
      if (window.localStorage['superClientId'])
        assignBy = window.localStorage['superClientId']
      else if (window.localStorage['ccdetails']) {
        let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
        assignBy = ccdetails.cnuseraccid
      }
      let data = {
        description: this.carePath.description,
        dueDate: this.changeStringFormat2(this.carePath.duedate),
        isSnoozed: isSnoozed,
        patientSwfId: this.userId,
        todoCarePlanSurveyId: this.carePath.todoCarePlanSurveyId,
        todoCarePlanSurveyName: this.carePath.subject,
        todoCategoryId: 12,
        descChange: descChange,
        todoTransactionId: 0,
        assignBy: assignBy
      }
      this.patientservice.saveothertodo(data)
        .subscribe(data => {
          if (data[0].status == 'success') {
            this.toast.success(success, '', {
              timeOut: this.timealert
            })
            this.userService.logAudit('saveOrSnoozeCustomTodo', 0).subscribe(data => { })
            this.cusstatus = 'new'
            this.getMytodos();
            this.getNotesHistory();

            this.carePath.subject = ""
            this.carePath.duedate = ""
            this.carePath.description = ""
            this.mintododata = new Date()
            this.cusstatus = ""
            this.dueStatus = ''
            this.descriptionchange = ''
            this.getNotesHistory();
            this.getMytodos()
            this.ModelRef.hide()
            this.onetabenable = false
          } else {
            this.toast.error(data[0].message, '', {
              timeOut: this.timealert
            })
          }
        })
    } else {
      this.carePath.subject = ""
      this.carePath.duedate = ""
      this.carePath.description = ""
      this.mintododata = new Date()
      this.cusstatus = ""
      this.dueStatus = ''
      this.descriptionchange = ''
      this.statuschange('Current')
      this.ModelRef.hide()
    }
  }
  getmodifyenable(duedate) {
    let Dos = new Date(this.changeStringFormat2(duedate));
    let todate = new Date()
    if (todate.setHours(0, 0, 0, 0) < Dos.setHours(0, 0, 0, 0)) {
      this.dueStatus = "future"
    }
    if (todate.setHours(0, 0, 0, 0) >= Dos.setHours(0, 0, 0, 0)) {
      this.dueStatus = "past"
    }
  }
  hide12() {
    this.showdata.plannedDischargeTypeForOther = ""
    this.showdata.plannedDischargeHospitalId = ""
    this.ModelRef12.hide()
  }
  hide123() {
    this.pacdata.plannedDischargeTypeForOther = ""
    this.pacdata.plannedDischargeHospitalId = ""
    this.ModelRef123.hide()
  }
  hide125() {
    this.alert = false
    this.ModelRef125.hide()
  }
  hide124() {
    this.alert = false
    this.ModelRef124.hide()
  }
  checkname() {
    ////console.log(this.carePath.plannedDischargeTypeForOther)

    let index = _.findIndex(this.temp, (o: any): any => {
      return o.dischargeTo == this.carePath.plannedDischargeTypeForOther
    })

    if (index != -1 || this.carePath.plannedDischargeTypeForOther == 'other' || this.carePath.plannedDischargeTypeForOther == 'Other') {
      this.carePath.plannedDischargeTypeForOther = ""
      this.toast.error(this.userService.translateText('patient_portal.display_messages.facility_name_has_exist.error'), '', {
        timeOut: this.timealert
      })
    }


    // self.toast.error("This email has already been registered")
  }

  checkname1() {

    ////console.log(this.carePath.dname)

    let index = _.findIndex(this.otherpac, (o: any): any => {

      return o.hospitalOtherPacMapName == this.carePath.dname
    })

    if (index != -1 || this.carePath.dname.toLowerCase() == 'other') {
      this.carePath.dname = ""
      this.toast.error("This Other PSC Event Type has already been exists", '', {
        timeOut: this.timealert
      })
    }


    // self.toast.error("This email has already been registered")
  }

  checkname3() {
    ////console.log(this.showdata.dname)

    let index = _.findIndex(this.temp, (o: any): any => {
      return o.dischargeTo == this.showdata.dname
    })

    if (index != -1 || this.showdata.dname.toLowerCase() == 'other') {
      this.showdata.dname = ""
      this.toast.error("This Facility Name has already been exists", '', {
        timeOut: this.timealert
      })
    }


    // self.toast.error("This email has already been registered")
  }



  getCarepathDetails() {
    let self = this;
    self.patientservice.getCarePlanDetails(self.userId, self.uid).subscribe(data => {
      if (Array.isArray(data) && data.length) {
        self.carePath = data[0];
        setTimeout(() => {
          if (this.currentUser.item.userrole == 'Care Navigator' || this.currentUser.item.userrole == 'Care Coordinator' || this.currentUser.item.userrole == 'Hospital Care Navigator' || this.currentUser.item.userrole == 'Commercial Care Navigator' || this.currentUser.item.userrole == 'Surgeon' || this.currentUser.item.userGroupId == 32 || this.currentUser.item.userGroupId == 33) {
            if (this.currentUser.item.userrole == 'Surgeon') {
              this.surdis = true
              this.disabled = false
              this.patientEnrollEnable = false;
              this.makeAllDisable = true
            }
            else if (self.user && !self.user.pswIsActive) {
              self.surdis = true
              self.disabled = true
              self.patientEnrollEnable = false;
              self.makeAllDisable = true
            }

            else {
              this.surdis = false
              this.patientEnrollEnable = false;
              this.disabled = false
              this.makeAllDisable = false
            }
          }
          else if (this.currentUser.item.userrole == 'Patient Enroller' || this.currentUser.item.userGroupId == 31 || this.currentUser.item.userGroupId == 30) {
            this.surdis = true;
            this.disabled = true;
            this.patientEnrollEnable = false;
            this.makeAllDisable = true;
          }
          else if (!self.user.pswIsActive) {
            self.surdis = true
            self.disabled = true
            self.patientEnrollEnable = false;
            self.makeAllDisable = true
          }
          else {
            this.surdis = false;
            this.disabled = true;
            this.patientEnrollEnable = true;
            this.makeAllDisable = true;
          }
          if (this.currentUser.item.userrole == 'Commercial Care Navigator') {
            this.isccn = true
          }
          else if (this.currentUser.item.userrole == 'Financial Care Navigator') {
            this.isfcn = true
          }
        }, 100);
        if (self.carePath.dischargeTeleCode || self.carePath.dischargeTeleCode != '') {
          self.carePath.code = self.carePath.dischargeTeleCode + ',' + self.carePath.dischargeTeleCountryCode;
        }
        else {
          if (this.currentUser.item.language != 'en_uk') {
            this.carePath.dcode = '+1,USA'
          }
          else if (this.currentUser.item.language == 'en_uk') {
            this.carePath.dcode = '+44,UK'
          }
          if (this.currentUser.item.clientTeleCode)
            this.carePath.dcode = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
        }
        this.checkphonlength(self.carePath.code);
        if (self.carePath.actualDischargeId == "0") {
          self.carePath.actualDischargeId = ""
          self.carePath.actualDischargeHospitalId = ""
        }
        if (self.carePath.dos) {
          this.dosvalue = self.carePath.dos
          self.carePath.dos = new Date(self.carePath.dos)
          let dosDate = new Date(self.carePath.dos);
          self.SetDosStatus(dosDate)
          if (this.dosStatus == 'past') {
            self.dosstatusdate = true;
          }
        }
        if (self.carePath.plannedVisit) {
          self.enabletext = false
        }
        if (self.carePath.actualVisit) {
          this.ennableactualvisit = false
        }
        if (self.carePath.plannedDischargeDate) {
          this.plannedvalue = self.carePath.plannedDischargeDate
          self.carePath.plannedDischargeDate = new Date(self.carePath.plannedDischargeDate)
        }
        if (self.carePath.plannedAdmissionDate) {
          self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedAdmissionDate)
          self.checkempty11(self.carePath.plannedAdmissionDate);
          if (!self.carePath.plannedSnfDischargeDate) {
            self.checkForPlanedDate(self.carePath.plannedAdmissionDate)
          }
        }
        if (self.carePath.actualAdmissionDate) {
          self.carePath.actualAdmissionDate = new Date(self.carePath.actualAdmissionDate)
        }
        if (self.carePath.actualDischargeDate) {
          self.carePath.actualDischargeDate = new Date(self.carePath.actualDischargeDate)
          if (self.carePath.actualAdmissionDate) {
            //self.makeAllDisable = true
            this.planneddis = true
            self.carePath.actualAdmissionDate = new Date(self.carePath.actualAdmissionDate)
            self.admitdate = new Date(self.carePath.actualAdmissionDate)
          }
          else {
            self.carePath.actualAdmissionDate = new Date(self.carePath.actualDischargeDate)
          }
          self.actualDateAvailable = true;
          self.changeMaxdate(self.carePath.actualDischargeDate)
          self.SetActualStatus(self.carePath.actualAdmissionDate)
        }
        if (self.carePath.plannedSnfDischargeDate) {
          //self.makeAllDisable = true
          self.carePath.plannedSnfDischargeDate = new Date(self.carePath.plannedSnfDischargeDate)
        }
        if (self.carePath.actualSnfDischargeDate) {
          self.makeAllDisable = true
          self.carePath.actualSnfDischargeDate = new Date(self.carePath.actualSnfDischargeDate)
        }
        if (self.carePath.plannedDischargeId == "3")
          self.calculatePlanedLos(self.carePath.plannedSnfDischargeDate, self.carePath.plannedAdmissionDate);
        if (self.carePath.plannedDischargeId == "2" || self.carePath.plannedDischargeId == "1") {
          this.enabletext = false
        }
        if (self.carePath.actualDischargeId) {
          self.enabledisid = true
        }
        if (self.carePath.actualOtherSelectedName && this.carePath.actualAdmissionDate) {
          this.aother = self.carePath.actualOtherSelectedName
          self.carePath.actualDischargeId = this.aother
        }
        if (self.carePath.plannedOtherSelectedName && self.carePath.plannedDischargeHospitalId) {
          self.carePath.pother = self.carePath.plannedOtherSelectedName
          self.carePath.plannedDischargeId = self.carePath.pother
        }
        /* if(self.carePath.actualDischargeId == "1" || self.carePath.actualDischargeId == "4" || self.carePath.actualDischargeId == "5"){
          self.carePath.actualDischargeHospitalId = ''
        }
        if(self.carePath.plannedDischargeId == "1" || self.carePath.plannedDischargeId == "4" || self.carePath.plannedDischargeId == "5"){
         self.carePath.plannedDischargeHospitalId = ''
       }  */

        self.calculateActualLos(self.carePath.actualSnfDischargeDate, self.carePath.actualAdmissionDate);
        if (self.actualStatus == 'notSelected') {
          self.planDisable = false
          self.calculatePlanedLos(self.carePath.plannedSnfDischargeDate, self.carePath.plannedAdmissionDate);
        }
      }
      else {
        self.carePath = {
          dos: ''
        }
      }
    })
    self.patientservice.getCarePlanDetails(self.userId, self.uid).subscribe(data => {
      if (Array.isArray(data) && data.length) {
        self.careSPath = data[0]
        if (self.careSPath.dischargeTeleCode || self.carePath.dischargeTeleCode != '') {
          self.careSPath.code = self.carePath.dischargeTeleCode + ',' + self.carePath.dischargeTeleCountryCode;
        }
        else {
          if (this.currentUser.item.language != 'en_uk') {
            this.careSPath.dcode = '+1,USA'
          }
          else if (this.currentUser.item.language == 'en_uk') {
            this.careSPath.dcode = '+44,UK'
          }
          if (this.currentUser.item.clientTeleCode)
            this.careSPath.dcode = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
        }
        if (self.careSPath.dischargePhone) {
          this.tempphone = self.careSPath.dischargePhone
          let x = self.careSPath.dischargePhone.split("");
          let y = []
          let k = []
          let m = []
          for (var i = 0; i < 3; i++) {
            y[i] = x[i]
          }
          for (var j = 3; j < 6; j++) {
            k[j] = x[j]
          }
          for (var l = 6; l < x.length; l++) {
            m[l] = x[l]
          }
          self.careSPath.dischargePhone = '(' + y.join('') + ') ' + k.join('') + '-' + m.join('')
        }
        if (self.careSPath.actualDischargeId == "0") {
          self.careSPath.actualDischargeId = ""
          self.careSPath.actualDischargeHospitalId = ""
        }
        if (self.careSPath.actualAdmissionDate) {
          /* self.makeAllDisable = true */
          self.carePath.actualAdmissionDate = new Date(self.carePath.actualAdmissionDate)
        }
        if (self.careSPath.plannedAdmissionDate) {
          //self.makeAllDisable = true
          self.carePath.plannedAdmissionDate = new Date(self.careSPath.plannedAdmissionDate)
        }
        if (self.careSPath.dos) {
          self.careSPath.dos = new Date(self.careSPath.dos)
          if (this.dosStatus == 'past') {
            self.dosstatusdate = true;
          }
        }
        if (self.careSPath.plannedDischargeDate) {
          // this.plannedvalue = self.careSPath.plannedDischargeDate
          self.careSPath.plannedDischargeDate = new Date(self.careSPath.plannedDischargeDate)
          if (!self.careSPath.plannedSnfDischargeDate) {
            self.checkForSPlanedDate(self.careSPath.plannedDischargeDate)
          }
        }

        if (self.careSPath.actualDischargeDate) {
          self.careSPath.actualDischargeDate = new Date(self.careSPath.actualDischargeDate)
          self.actualDateAvailable = true;
          self.changeMaxdate(self.careSPath.actualDischargeDate)
          self.SetActualStatus(self.careSPath.actualAdmissionDate)
        }
        if (self.careSPath.plannedSnfDischargeDate) {
          //self.makeAllDisable = true
          self.careSPath.plannedSnfDischargeDate = new Date(self.careSPath.plannedSnfDischargeDate)
        }
        if (self.careSPath.actualSnfDischargeDate) {
          self.makeAllDisable = true
          self.careSPath.actualSnfDischargeDate = new Date(self.careSPath.actualSnfDischargeDate)
        }
        if (self.careSPath.plannedDischargeId == "3")
          self.calculateSPlanedLos(self.careSPath.plannedSnfDischargeDate, self.careSPath.plannedAdmissionDate);
        if (self.careSPath.actualDischargeId == "1" || self.careSPath.actualDischargeId == "4" || self.careSPath.actualDischargeId == "5") {
          self.careSPath.actualDischargeHospitalId = ''
        }
        if (self.careSPath.plannedDischargeId == "1" || self.careSPath.plannedDischargeId == "4" || self.careSPath.plannedDischargeId == "5") {
          self.careSPath.plannedDischargeHospitalId = ''
        }
        if (self.careSPath.actualAdmissionDate) {
          /* self.makeAllDisable = true */
          self.carePath.actualAdmissionDate = new Date(self.carePath.actualAdmissionDate);
          self.SetActualStatus(self.careSPath.actualAdmissionDate);
        }
        if (self.careSPath.plannedAdmissionDate) {
          //self.makeAllDisable = true
          self.carePath.plannedAdmissionDate = new Date(self.careSPath.plannedAdmissionDate)

        }
        if (self.careSPath.plannedDischargeDate) {
          //self.makeAllDisable = true
          self.carePath.plannedDischargeDate = new Date(self.careSPath.plannedDischargeDate)
        }
        if (self.careSPath.plannedSnfDischargeDate) {
          //self.makeAllDisable = true
          self.carePath.plannedSnfDischargeDate = new Date(self.careSPath.plannedSnfDischargeDate)
        }

        self.calculateSActualLos(self.careSPath.actualSnfDischargeDate, self.careSPath.actualAdmissionDate);
        if (self.careSPath.actualOtherSelectedName) {
          self.careSPath.aother = self.carePath.actualOtherSelectedName
        }
        if (self.careSPath.plannedOtherSelectedName) {
          self.careSPath.pother = self.carePath.plannedOtherSelectedName
        }
      }
      else {
        self.careSPath = {
          dos: ''
        }
      }
    })
    this.reass = false
  }

  patientEnrollEnable: any = false;


  getmenu() {

    this.userService.menuuserinfo(this.currentUser.item.userGroupId, this.currentUser.item.userAccountId)
      .subscribe(
        data1 => {
          if (data1) {
            for (var i = 0; i < data1.length; i++) {
              if (data1[i].refName == 'CC_APPOINTMENT' && data1[i].status) {
                return this.menu = 'Y';
              } else {
                this.menu = 'N'
              }
            }
          }
        })
  }
  // SetDosStatus(event) {
  //   if (event) {
  //     let self = this;
  //     let date = this.Datepipe.transform(event, this.dateform);
  //     if (date) {
  //       let toDate = new Date();
  //       toDate.setDate(toDate.getDate() - 1);
  //       this.patientservice
  //         .getpatientdetails(self.user.patientId, self.uid)
  //         .subscribe(
  //           data => {
  //             this.mindos = new Date(data[0].dob)
  //             let dob = this.mindos.getTime();
  //             let bDos = new Date(date);
  //             bDos.setDate(bDos.getDate() + 1)
  //             if (dob > bDos.getTime()) {
  //               self.toast.error('Date of Surgery should not be less than Date of Birth', '', {
  //                 timeOut: this.timealert
  //               });
  //               return;
  //             }
  //           })
  //       let Dos = new Date(date);
  //       if (toDate.getTime() <= Dos.getTime()) {
  //         self.dosStatus = "future"
  //         //self.carePath.actualDischargeId = ""
  //         self.checkplannedDisabled(Dos);
  //       }
  //       if (toDate.getTime() > Dos.getTime()) {
  //         self.dosStatus = "past"
  //         //self.carePath.plannedDischargeId = ""
  //       }
  //       if (self.countone > 2 || !self.carePath.plannedDischargeDate) {
  //         if (self.carePath.dos != self.careSPath.dos) {
  //           self.counttwo2 = 1
  //         }
  //         self.setPlannedDate(event)

  //       }
  //       self.countone++;

  //     } else {
  //       self.dosStatus = 'notSelected'
  //     }

  //   }
  //   /* if(!self.actualCategory){
  //     self.enableactualTom(event)
  //   } */
  // }






  SetActualStatus(event) {
    let self = this;
    let date = this.Datepipe.transform(event, 'yyyy/MM/dd');
    if (date) {
      let toDate = new Date();
      toDate.setDate(toDate.getDate() - 1);
      let Dos = new Date(date);
      if (toDate.getTime() <= Dos.getTime()) {
        self.actualStatus = "future"
      }
      if (toDate.getTime() > Dos.getTime()) {
        self.actualStatus = "past"
        // self.makeActualDate = true;
      }
      self.makeActualDate = true;

    } else {
      self.actualStatus = 'notSelected'
    }

  }



  enableactualTom(event) {
    let self = this;
    if (event) {
      let dos = new Date(self.carePath.dos);
      let today = new Date();
      var timeDiff = dos.getTime() - today.getTime();
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (self.dosStatus == "past" || diffDays == 0) {

        self.enabledActual = true;

      }
      else {
        if (self.carePath.actualAdmissionDate) {
          self.enabledActual = true;
        }
        else
          self.enabledActual = false;


      }
    }

  }

  changeMaxdate(date) {
    let self = this;
    let today = new Date();
    var timeDiff = Math.abs(today.getTime() - date.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    self.minActualDate = new Date(date.getTime());
    if (diffDays > 5 && diffDays <= 10) {
      self.maxActualDate = new Date(date.getTime())
      self.maxActualDate.setDate(self.maxActualDate.getDate() + 5)
      self.minActualDate = new Date(date.getTime())
      return;
    }
    if (diffDays > 10 && diffDays < 15) {
      self.maxActualDate = new Date(date.getTime());
      self.minActualDate = new Date(date.getTime())
      self.maxActualDate.setDate(self.maxActualDate.getDate() + 10)
      self.minActualDate.setDate(self.minActualDate.getDate() + 5)
      return;
    }
    return;
  }

  setDOSPlannedDate(event, template15) {
    let self = this;
    if (event) {
      if (self.countone > 3 || !self.carePath.plannedDischargeDate) {
        let configuredate: any = 3
        self.patientservice.getPlannedDischargeDate(self.userId)
          .subscribe(data => {
            if (data.confPlannedDischargeDate)
              configuredate = data.confPlannedDischargeDate
            //let date = this.Datepipe.transform(event,'yyyy/MM/dd');
            let dosDate = new Date(event)
            let changeDate = dosDate.setDate(dosDate.getDate() + parseInt(configuredate))
            try {
              self.carePath.plannedDischargeDate = new Date(changeDate);
            } catch (Exception) { }

            //self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)

            if (self.counttwo2 || (!self.carePath.plannedAdmissionDate)) {
              var date1 = new Date(self.carePath.dos);
              var date2 = new Date(self.careSPath.dos);
              var timeDiff = Math.abs(date2.getTime() - date1.getTime());
              var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
              if (diffDays != 0) {
                self.ModelRef41 = self.modalService.show(template15, { class: 'modal-sm' })
                this.movable()
                if (self.careSPath.plannedDischargeId) {
                  if (self.careSPath.plannedAdmissionDate) {
                    if (self.careSPath.dos != self.carePath.dos) {
                      this.tempdate = self.carePath.plannedAdmissionDate
                      self.checkForPlanedDate(this.tempdate)
                      try {
                        self.carePath.plannedAdmissionDate = new Date()
                      } catch (Exception) { }
                    }
                  } else {
                    try {
                      self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)
                    } catch (Exception) { }
                    self.checkForPlanedDate(self.carePath.plannedAdmissionDate)

                  }
                }
                else {
                  try {
                    self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)
                  } catch (Exception) { }
                }
                /* self.checkempty11(self.carePath.plannedAdmissionDate);
                self.checkempty3(self.carePath.plannedDischargeDate); */
                /* self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)
                self.carePath.plannedDischargeId = ''
                self.carePath.plannedDischargeHospitalId = ''
                self.carePath.actualDischargeDate = ''
                self.carePath.actualAdmissionDate = ''
                self.carePath.actualDischargeId = ''
                self.carePath.actualDischargeHospitalId = ''
                self.carePath.dischargeContact = ''
                self.carePath.dischargePhone = '' */
              } else {
                if (!self.careSPath.plannedAdmissionDate) {
                  try {
                    self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)
                  } catch (Exception) { }

                }
              }
            }

          })

      }
    }

  }
  hide41(autoAdjust, deleteEmpty) {
    let self = this;
    if (this.tempdate) {
      self.carePath.plannedAdmissionDate = new Date(this.tempdate);
      self.checkempty11(self.carePath.plannedAdmissionDate);
    }
    self.ModelRef41.hide();
    if (this.textTemplate15) {
      this.ngOnInit();

    }
    else {
      this.preSavePACKEvent(autoAdjust, deleteEmpty, this.endDateEmptyTemplate)
    }

  }
  setPlannedDate(event) {
    let self = this;
    if (event) {
      let configuredate: any = 3
      self.patientservice.getPlannedDischargeDate(self.userId)
        .subscribe(data => {
          if (data.confPlannedDischargeDate)
            configuredate = data.confPlannedDischargeDate
          //let date = this.Datepipe.transform(event,'yyyy/MM/dd');
          let dosDate = new Date(event)
          let changeDate = dosDate.setDate(dosDate.getDate() + parseInt(configuredate))
          self.carePath.plannedDischargeDate = new Date(changeDate);

          //self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)

          if (self.counttwo2 || (!self.carePath.plannedAdmissionDate)) {
            var date1 = new Date(self.carePath.dos);
            var date2 = new Date(self.careSPath.dos);
            var timeDiff = Math.abs(date2.getDate() - date1.getDate());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            if (diffDays != 0) {
              /* self.ModelRef41 = self.modalService.show(template15,{class:'modal-sm'}) */
              /* self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)
              self.carePath.plannedDischargeId = ''
              self.carePath.plannedDischargeHospitalId = ''
              self.carePath.actualDischargeDate = ''
              self.carePath.actualAdmissionDate = ''
              self.carePath.actualDischargeId = ''
              self.carePath.actualDischargeHospitalId = ''
              self.carePath.dischargeContact = ''
              self.carePath.dischargePhone = '' */
            } else {
              if (!self.careSPath.plannedAdmissionDate)
                self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)
            }
          }

        })

    }

  }
  setSPlannedDate(event) {
    let self = this;
    if (event) {
      let configuredate: any = 3
      self.patientservice.getPlannedDischargeDate(self.userId)
        .subscribe(data => {
          if (data.confPlannedDischargeDate)
            configuredate = data.confPlannedDischargeDate
          let date = this.Datepipe.transform(event, 'yyyy/MM/dd');
          let dosDate = new Date(date)
          let changeDate = dosDate.setDate(dosDate.getDate() + parseInt(configuredate))
          self.careSPath.plannedDischargeDate = new Date(changeDate);
        })

    }
    if (self.counttwo || !self.careSPath.plannedSnfDischargeDate)
      self.checkForSPlanedDate(self.careSPath.plannedDischargeDate)
  }

  // checkActualDate(){
  //   let self= this;
  //     if(self.dosStatus == 'future'){
  //       self.toast.warning(`Patient cannot be discharged from Hospital before Surgery`)
  //       return;
  //     }
  // }
  checkForADate(event) {
    let self = this;
    if (event) {
      if (!self.carePath.actualAdmissionDate) {
        self.carePath.actualAdmissionDate = new Date(event)
      }
    }

  }
  checkForActualDate(event) {
    let self = this;
    if (event) {

      self.actualDateAvailable = true;
      let snfdate = new Date(event);
      self.changeMaxdate(snfdate)
      // self.minActualDate = new Date (event);
      // self.carePath.actualSnfDischargeDate = new Date(snfdate.setDate(snfdate.getDate() + 5))
    } else {
      self.actualDateAvailable = false;
      // self.carePath.actualSnfDischargeDate = '';
    }
    if (self.carePath.actualSnfDischargeDate && event) {
      self.calculateActualLos(self.carePath.actualSnfDischargeDate, event);
    }
    // self.SetActualStatus(event);
  }
  // checkconfiguredate() {
  //   let self = this
  //   this.configuredate = 5
  //   self.patientservice.getPlannedDischargeDate(self.userId)
  //     .subscribe(data => {
  //       if (data.confPlannedFacilityDischargeDate) {
  //         this.configuredate = parseInt(data.confPlannedFacilityDischargeDate)
  //         //SOL          self.carePath.plannedLos = parseInt(data.confPlannedFacilityDischargeDate)
  //       }
  //     })
  //   ////console.log(this.configuredate)
  // }
  checkForPlanedDate(event) {
    let self = this;
    this.checkplannDisabled(event)
    if (event) {
      self.checkempty11(self.carePath.plannedAdmissionDate)
      if (!self.careSPath.plannedDischargeId) {
        self.carePath.plannedAdmissionDate = new Date(event)
      }
      if (event == self.carePath.plannedAdmissionDate) {
        let snfdate = new Date(event);
        if (self.counttwo > 2 || !self.carePath.plannedSnfDischargeDate) {

          self.carePath.plannedSnfDischargeDate = new Date(snfdate.setDate(snfdate.getDate() + this.configuredate))

        }
        self.counttwo++;
      }
      if (event != this.careSPath.plannedDischargeDate) {
        if (!self.careSPath.plannedDischargeId) {
          self.carePath.plannedAdmissionDate = new Date(event);
          let snfdate = new Date(event);
          self.carePath.plannedSnfDischargeDate = new Date(snfdate.setDate(snfdate.getDate() + this.configuredate))
        }
      }
    } else {
      if (self.counttwo > 1)
        self.carePath.plannedSnfDischargeDate = '';
    }
    //self.calculatePlanedLos(self.carePath.plannedSnfDischargeDate,event);
  }
  checkForAPlanedDate(event) {
    let self = this;
    this.plannadmin = true
    this.checkplannDisabled(event)
    if (event) {
      let snfdate = new Date(event);
      if (self.counttwo > 1 || !self.carePath.plannedSnfDischargeDate) {
        self.carePath.plannedSnfDischargeDate = new Date(snfdate.setDate(snfdate.getDate() + this.configuredate))
        self.calculatePlanedLos(self.carePath.plannedAdmissionDate, self.carePath.plannedSnfDischargeDate)

      }
      self.counttwo++;
      if (this.carePath.plannedDischargeId) {
        this.patientservice.getvisitdetails(this.hospitalid)
          .subscribe(data => {
            this.visit = data.hospitalplannedvisitmastertable
            let index = _.findIndex(this.visit, (o: any): any => {
              return o.dischargetypeId == this.carePath.plannedDischargeId
            })
            if (index != -1 && this.visit[index].plannedVisit) {
              this.calculateplanedvisit(this.visit[index].plannedVisit)
            } else {
              this.carePath.plannedVisit = ''
              this.enableactual = true
            }
          })
      }

    } else {
      if (self.counttwo > 1)
        self.carePath.plannedSnfDischargeDate = '';
    }
    //self.calculatePlanedLos(self.carePath.plannedSnfDischargeDate,event);
  }
  checkForPPlanedDate(event) {
    let self = this;
    if (event) {
      let snfdate = new Date(event);
      if (self.counttwo2 > 1 || !self.pacdata.plannedSnfDischargeDate) {
        self.pacdata.plannedSnfDischargeDate = new Date(snfdate.setDate(snfdate.getDate() + this.configuredate))

      }
      self.counttwo2++;
      this.pacsavedata(this.pacdata.plannedDischargeId);
    } else {
      if (self.counttwo2 > 1)
        self.pacdata.plannedSnfDischargeDate = '';
    }


    //self.calculatePlanedLos(self.carePath.plannedSnfDischargeDate,event);
  }
  checkForEPlanedDate(event) {
    let self = this;
    if (event) {
      let snfdate = new Date(event);
      if (this.counttwo3 > 0 || !self.showdata.plannedDate) {
        self.showdata.plannedDate = new Date(snfdate.setDate(snfdate.getDate() + this.configuredate))

      }
      self.counttwo3++;
      this.editpacsavedata(this.showdata.plannedDischargeId)
    } else {
      if (self.counttwo3 > 1)
        self.showdata.plannedDate = '';
    }


    //self.calculatePlanedLos(self.carePath.plannedSnfDischargeDate,event);
  }
  checkForSPlanedDate(event) {
    let self = this;
    this.checkplannDisabled(event)

    if (event) {
      let snfdate = new Date(event);
      if (self.counttwo > 1 || !self.careSPath.plannedSnfDischargeDate) {
        self.careSPath.plannedSnfDischargeDate = new Date(snfdate.setDate(snfdate.getDate() + this.configuredate))
      }
      self.counttwo++;
    } else {
      if (self.counttwo > 1)
        self.careSPath.plannedSnfDischargeDate = '';
    }
    //self.calculatePlanedLos(self.carePath.plannedSnfDischargeDate,event);
  }

  calculatePlanedLos(event1, event2) {
    let self = this;
    if (event1 && event2) {
      var date1 = new Date(event2);
      var date2 = new Date(event1);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      self.carePath.plannedLos = diffDays;
      if (this.carePath.plannedDischargeId) {
        this.patientservice.getvisitdetails(this.hospitalid)
          .subscribe(data => {
            this.visit = data.hospitalplannedvisitmastertable
            let index = _.findIndex(this.visit, (o: any): any => {
              return o.dischargetypeId == this.carePath.plannedDischargeId
            })
            if (index != -1 && this.visit[index].plannedVisit) {
              this.calculateplanedvisit(this.visit[index].plannedVisit)
            } else {
              this.enableactual = false
              this.carePath.plannedVisit = ''
            }
          })
      }
    } else {
      self.carePath.plannedLos = ''
    }
    this.showend = true
  }
  calculateSPlanedLos(event1, event2) {
    let self = this;
    if (event1 && event2) {
      var date1 = new Date(event2);
      var date2 = new Date(event1);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      self.careSPath.plannedLos = diffDays;
    } else {
      self.careSPath.plannedLos = ''
    }
  }
  calculateActualLos(event1, event2) {
    let self = this;
    if (event2 && event1) {
      var date1 = new Date(event2);
      var date2 = new Date(event1);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      self.carePath.actualLos = diffDays;
    } else {
      self.carePath.actualLos = '';
    }
  }
  calculateSActualLos(event1, event2) {
    let self = this;
    if (event2 && event1) {
      var date1 = new Date(event2);
      var date2 = new Date(event1);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      self.careSPath.actualLos = diffDays;
    } else {
      self.careSPath.actualLos = '';
    }
  }
  getdescription() {
    let self = this;
    self.patientservice.getdescription(self.userId)
      .subscribe(data => {
        self.lastmg = data.DashboardLatestCpNote;
        //this.scrollToBottom();
      })
  }

  getContactHistory() {
    let self = this;
    self.patientservice.getContactHistory(self.userId, this.currentUser.item.userAccountId)
      .subscribe(data => {
        self.contacts = data;


      })
  }


  getContacttrigger() {
    let self = this;
    self.patientservice.getContacttrigger(self.userId, this.currentUser.item.userAccountId)
      .subscribe(data => {
        self.trigger = data;


      })
  }
  getNotesHistory() {
    let self = this;
    self.patientservice.getNotesHistory(self.userId, this.currentUser.item.userAccountId)
      .subscribe(data => {
        self.notes = data;
      })
  }
  // getCpNotesHistory(){
  //   let self= this;
  //   self.patientservice.getCpNotesHistory(self.userId,this.currentUser.item.userAccountId)
  //   .subscribe(data=>{
  //    self.cpnotes = data;
  //   })
  //   }
  statuschange(status) {
    if (status == 'Current') {
      this.mytodostatus = "All"
      this.getMytodos()
    }
    else {
      this.mytodostatus = "Current"
      this.getMytodos()
    }
  }




  getexpiry(completed, expirydate) {
    if (!completed) {
      if (expirydate) {
        expirydate = expirydate.split('-').join('/')
        var date1 = new Date(expirydate);
        var date2 = new Date();
        var timeDiff = date1.getTime() - date2.getTime();
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (diffDays >= 0 || diffDays == -0) {
          return false
        }
        else {
          return true
        }
      }
      else
        return false
    }
    else {
      return true
    }
  }
  checkplanedActual(data) {
    let self = this;
    let actual = _.findIndex(data, (o: any): any => {
      return o.categoryId == "6"
    })
    if (!this.carePath.actualDischargeDate) {
      self.enabledPlanned = true
    }

    if (actual != -1) {
      //self.actualCategory = true;
      self.enabledActual = true;
    }

  }



  getCareplanAssesment() {
    let self = this;
    self.patientservice.getCarePlanAssessments(self.userId)
      .subscribe(data => {
        if (Array.isArray(data) && data.length) {
          self.assessments = data
        }
      })
    self.patientservice.getCarePlanAssessments(self.userId).subscribe(data => {
      if (Array.isArray(data) && data.length) {
        self.Sassessments = data
        this.getbmi = data
        var bmi = self.getbmi[0].questionList.filter(item => item.questionName == 'BMI')
        ////console.log(bmi)
        this.savebmi = bmi[0].bmi
      }
    })
  }

  submitContact(msg, f: NgForm) {

    let self = this;
    let stykeradmin = window.localStorage['superClientId']
    let data = {
      title: "ContactHistory",
      ccUserAccountId: stykeradmin ? stykeradmin : this.currentUser.item.userAccountId,
      description: msg,
      patientSwfId: self.userId,
      // strSentDate:self.Datepipe.transform(new Date(),'MM/dd/yyyy'),
      // strSentTime:self.Datepipe.transform(new Date(),' h:mm a')
    }

    self.patientservice.addContactHistory(data)
      .subscribe(data => {
        f.reset();
        self.getContactHistory();
        self.toast.success(this.userService.translateText('hospital_portal.disp_messages.msg_sent.success'), '', {
          timeOut: this.timealert
        });
        this.userService.logAudit('ContactHistory', 0).subscribe(data => { })
        this.description1 = "";
        this.scrollToBottom();
      })
  }
  submitNote(msg, f: NgForm, Notes) {

    let self = this;
    let stykeradmin = window.localStorage['superClientId']
    let data = {
      title: Notes,
      ccUserAccountId: stykeradmin ? stykeradmin : this.currentUser.item.userAccountId,
      description: msg,
      patientSwfId: self.userId,
      // strSentDate:self.Datepipe.transform(new Date(),'MM/dd/yyyy'),
      // strSentTime:self.Datepipe.transform(new Date(),' h:mm a')
    }
    this.showloader = false
    self.patientservice.addContactHistory(data)
      .subscribe(data => {
        f.reset();
        self.getNotesHistory();
        // self.getCpNotesHistory()
        this.description2 = "";
        self.toast.success(this.userService.translateText('hospital_portal.disp_messages.notes_added.success'), '', {
          timeOut: this.timealert
        });
        this.form.resetForm()
        this.ngOnInit();
        this.scrollToBottom();
        this.userService.logAudit(Notes, 0).subscribe(data => { })
      })
  }

  openSelect(template: TemplateRef<any>, hospital: any) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.movable()
  }

  addpop(id, todo) {
    this.survey = todo.todoCarePlanSurveyCode;
    if (todo.todoCarePlanSurveyCode == "") {
      this.survey = "0";
    }
    let startdate, enddate;
    startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
    this.startdate = startdate
    this.enddate = enddate
    this.patientservice.markAsReadtodo(this.userId, todo.todoCategoryId, this.survey, todo.hpsmId, todo.todoCarePlanSurveyId, startdate, enddate).subscribe(
      data => {
        this.userService.logAudit('updateDashboardCarePlanTodo', 0).subscribe(data => { })
        todo.isTxnCompleted = true;
        this.getMytodos();
        this.ModelRef.hide();
      }
    )
  }

  addprop(e, id, todo) {
    if (e.target.checked) {
      this.survey = todo.todoCarePlanSurveyCode;
      if (todo.todoCarePlanSurveyCode == "") {
        this.survey = "0";
      }
      let startdate, enddate;
      startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
      enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
      this.startdate = startdate
      this.enddate = enddate
      this.patientservice.markAsReadtodo(this.userId, todo.todoCategoryId, this.survey, todo.hpsmId, todo.todoCarePlanSurveyId, startdate, enddate).subscribe(
        data => {
          this.userService.logAudit('updateDashboardCarePlanTodo', 0).subscribe(data => { })
        }
      )
    }
  }

  markAsRead(id, todo, sur) {
    let self = this;
    this.survey = todo.todoCarePlanSurveyCode;
    if (todo.todoCarePlanSurveyCode == "") {
      this.survey = "0";
    }
    var surveyName;
    let status;
    let ccview = todo.isCcViewed
    switch (todo.todoCarePlanSurveyCode) {
      case "RC1046 || RCUK1046":
        surveyName = 'Tell Us About Your Home'
        break;
      case "RCS1046 || RCSUK1046":
        surveyName = 'Tell Us About You'
        break;
      case "RC1045 || RCUK1045":
        surveyName = 'Tell Us About Your Health'
        break;
      default:
        surveyName = todo.todoCarePlanSurveyName;
    }
    if (todo.patCompletedOn) {
      status = true
      let startdate, enddate;
      startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
      enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
      this.startdate = startdate
      this.enddate = enddate
      self.patientservice.updateccreviewd(self.userId, todo.hpsmId, this.survey, todo.todoCategoryId, todo.todoCarePlanSurveyId, startdate, enddate).subscribe(data => {
        this.userService.logAudit('updateDashboardCarePlanTodoAfterCcReviewed', 0).subscribe();
      })
      let viewsurveyData = {
        'patId': self.user.patientId,
        'patSwfId': self.userId,
        'surveyId': todo.hpsmId,
        'surveyName': surveyName,
        'status': status,
        'patstatus': self.user.patientStatus,
        'todocategoryid': todo.todoCategoryId,
        'survey': this.survey,
        'careplansurveyid': todo.todoCarePlanSurveyId,
        'todoCpAssigned': todo.todoCpAssignedOnStr,
        'todoOverallCompleted': todo.todoCpCompletedOnStr,
        'ccreview': ccview
      }
      window.localStorage['viewsurveyData'] = btoa(JSON.stringify(viewsurveyData))
      //console.log("viewsurveydata",JSON.parse(atob(window.localStorage['viewsurveyData'])))
      self.nav.navigate([`/care/newsymptom`])
    }
    else {
      if (!this.disabled && !this.surdis && !this.getexpiry(todo.todoCpCompletedOn, todo.todoCpExpiredOnStr) && todo.todoCategoryId != 21) {
        let surveyData = {
          'name': todo.hpsmId,
          'title': surveyName,
          'swfid': self.userId,
          'patstatus': self.user.patientStatus,
          'patid': self.user.patientId,
          'surveyname': this.survey,
          'todocategoryid': todo.todoCategoryId,
          'careplansurveyid': todo.todoCarePlanSurveyId,
          'patedit': 'new',
          'type': 1,
          'patact': this.showwelcom[0].WelcomeFlag
        }
        window.localStorage['surveyData'] = btoa(JSON.stringify(surveyData))
        self.nav.navigate([`/care/survey`])
      }
      else {
        status = true
        self.nav.navigate([`/care/newsymptom/${self.user.patientId}/${self.userId}/${todo.hpsmId}/${surveyName}/${status}/${self.user.patientStatus}/${todo.todoCategoryId}/${this.survey}/${todo.todoCarePlanSurveyId}/${todo.todoCpAssignedOnStr ? todo.todoCpAssignedOnStr : 0}/${todo.todoCpCompletedOnStr ? todo.todoCpCompletedOnStr : 0}/${ccview}`])
      }
    }
  }

  fetchdatas(datas) {
    let self = this
    this.carePath.dischargePhone = datas.dPhone
    if (self.carePath.dischargePhone) {
      let x = self.carePath.dischargePhone.split("");
      let y = []
      let k = []
      let m = []
      for (var i = 0; i < 3; i++) {
        y[i] = x[i]
      }
      for (var j = 3; j < 6; j++) {
        k[j] = x[j]
      }
      for (var l = 6; l < x.length; l++) {
        m[l] = x[l]
      }
      self.carePath.dischargePhone = '(' + y.join('') + ') ' + k.join('') + '-' + m.join('')
    }
    this.carePath.dischargeContact = datas.dContact
    this.carePath.actualDischargeTypeForOther = datas.dname
    this.carePath.code = datas.dcode;
    datas.dPhone = ""
    datas.dContact = ""
    datas.dname = ""
    datas.dcode = ""
    this.ModelRef.hide();
    ////console.log("ph", this.carePath.dischargePhone, "co", this.carePath.code)
  }

  saveCareplan(mytodostatus) {
    if (!this.careSPath.dos) {
      this.mytodostatus = 'Current'
    }
    // this.submitCpNote(lastmg,contactNotes);
    let self = this;
    this.enablepatient = false;
    self.arrangData().then((data) => {
      if (data) {
        self.patientservice.saveCarePlan(self.userId, data, "normal", "", this.selectedUserId).subscribe(
          data => {
            if (data[0].status == 'Success') {
              self.toast.success(this.userService.translateText('hospital_portal.disp_messages.date_updated.success'), '', {
                timeOut: this.timealert
              })
              this.userService.logAudit('saveDashboardCarePlan', 0).subscribe(data => { })
              this.enablepatient = true;
              // this.patientservice
              //   .getmytodolist(this.currentUser.item.userAccountId)
              //   .subscribe(
              //     data => {
              //       //this.temp_var=true;
              //       this.mytodo = data;
              //       this.currentUser.item.mytodolength = this.mytodo.length

              //     }
              //   );
              const obj = {
                "loginUaId": this.currentUser.item.userAccountId,
                "selectedCnUaId": this.patientservice.CN_id,
                "patientSwfId": '',
                "startDateRange": 'N',
                "endDateRange": 'N',
                "pracOrHsp": '',
                "todoViewMode": "",
                "loginHspOrPracId": '',
                "todoCategoryId": '',
                'raHospitalIsOverlap': "",
                'raSurgeonIsOverlap': "",
                "raSurgeonIds": '',
                "raHospitalIds": '',
              }

              this.patientservice.getCountDetailsRaTodoOverLapFilter(obj)
                .subscribe(
                  data => {
                    this.currentUser.item.mytodolength = data.todoCount
                    this.currentUser.item.msgcount = data.messageCount;
                  }
                );
              /* self.nav.navigate(['/care/mytodo'],) */
              this.initFunction();
              this.ModelRef.hide();
              this.showloader = false;
            }
            else {
              self.toast.error(data[0].message, '', {
                timeOut: this.timealert
              })
              this.ModelRef.hide();
              this.showloader = false;
            }
          }
        )
      }
    })
  }

  saveCarePlanChanges(mytodostatus, autoadjust, deleteEmpty, endDateEmpty) {
    this.saveModelPopUp.hide();
    this.preSavePACKEvent(autoadjust, deleteEmpty, endDateEmpty);
  }

  arrangData() {
    let self = this;
    let promise = new Promise((resolve, reject) => {
      let data: any = {
        actualDischargeDate: '',
        actualDischargeHospitalMasterId: '',
        plannedDischargeDate: '',
        plannedDischargeHospitalMasterId: '',
        plannedAdmissionDate: '',
        actualAdmissionDate: '',
        plannedDischargeId: '',
        actualDischargeId: '',
        actualVisit: '',
        plannedVisit: '',
        actualLos: '',
        plannedLos: '',
        actualSnfDischargeDate: '',
        plannedSnfDischargeDate: '',
        dischargeContact: '',
        dischargeTeleCode: '',
        dischargeTeleCountryCode: '',
        dischargePhone: '',
        plannedDischargeTypeForOther: '',
        actualDischargeTypeForOther: '',
        dos: ''
      }
      if (self.carePath.actualVisit) {
        data.actualVisit = self.carePath.actualVisit
      }
      if (self.carePath.plannedVisit) {
        data.plannedVisit = self.carePath.plannedVisit
      }
      if (self.carePath.actualDischargeDate) {
        data.actualDischargeDate = self.changeStringFormat2(self.carePath.actualDischargeDate)
      }
      if (self.carePath.plannedDischargeDate) {
        data.plannedDischargeDate = self.changeStringFormat2(self.carePath.plannedDischargeDate)
      }
      if (self.carePath.plannedAdmissionDate) {
        data.plannedAdmissionDate = self.changeStringFormat2(self.carePath.plannedAdmissionDate)
      }
      if (self.carePath.actualAdmissionDate) {
        data.actualAdmissionDate = self.changeStringFormat2(self.carePath.actualAdmissionDate)
      }
      if (self.carePath.actualDischargeId == this.aother) {
        let enable = _.findIndex(self.carePath.dischargehospitalList, (o: any): any => {
          return o.dischargeType == 5
        })
        if (enable != -1)
          self.carePath.actualDischargeHospitalId = self.carePath.dischargehospitalList[enable].dischargeId
      }

      if (self.carePath.plannedDischargeId == this.carePath.pother) {
        let enable = _.findIndex(self.carePath.dischargehospitalList, (o: any): any => {
          return o.dischargeType == 5
        })
        if (enable != -1)
          self.carePath.plannedDischargeHospitalId = self.carePath.dischargehospitalList[enable].dischargeId
      }
      if (self.carePath.actualDischargeHospitalId) {
        data.actualDischargeHospitalMasterId = parseInt(self.carePath.actualDischargeHospitalId);
      }
      if (self.carePath.plannedDischargeHospitalId) {
        data.plannedDischargeHospitalMasterId = parseInt(self.carePath.plannedDischargeHospitalId);
      }
      if (self.carePath.plannedDischargeId) {
        data.plannedDischargeId = parseInt(self.carePath.plannedDischargeId)
      }
      if (self.carePath.actualDischargeId) {
        data.actualDischargeId = parseInt(self.carePath.actualDischargeId)
      }
      if (self.carePath.pother) {
        data.plannedDischargeId = parseInt('5')
      }
      if (self.aother) {
        data.actualDischargeId = parseInt('5')
      }
      if (self.carePath.actualLos) {
        data.actualLos = parseInt(self.carePath.actualLos)
      }
      if (self.carePath.plannedLos) {
        data.plannedLos = parseInt(self.carePath.plannedLos)
      }
      if (self.carePath.actualSnfDischargeDate) {
        data.actualSnfDischargeDate = self.changeStringFormat2(self.carePath.actualSnfDischargeDate)
      }
      if (self.carePath.plannedSnfDischargeDate) {
        data.plannedSnfDischargeDate = self.changeStringFormat2(self.carePath.plannedSnfDischargeDate)
      }
      if (self.carePath.dischargeContact) {
        data.dischargeContact = self.carePath.dischargeContact
      }
      if (self.carePath.dischargePhone) {
        let telecode = self.carePath.code.split(',');
        if (this.tempphone) {
          self.carePath.dischargePhone = this.tempphone
        }
        data.dischargePhone = self.carePath.dischargePhone;
        data.dischargeTeleCode = telecode[0];
        data.dischargeTeleCountryCode = telecode[1];

      }
      // if(self.carePath.code){
      //   data.dischargeTeleCode = self.carePath.dischargePhone
      // }
      if (self.carePath.actualDischargeTypeForOther) {
        data.actualDischargeTypeForOther = self.carePath.actualDischargeTypeForOther
        data.plannedDischargeTypeForOther = ''
        data.hospitalId = this.currentUser.item.userAccountKey
      }
      if (self.carePath.plannedDischargeTypeForOther) {
        data.plannedDischargeTypeForOther = self.carePath.plannedDischargeTypeForOther
        data.actualDischargeTypeForOther = ''
        data.hospitalId = this.currentUser.item.userAccountKey
      }
      if (self.carePath.plannedDischargeTypeForOther && self.carePath.actualDischargeTypeForOther) {
        data.actualDischargeTypeForOther = self.carePath.actualDischargeTypeForOther
        data.plannedDischargeTypeForOther = self.carePath.plannedDischargeTypeForOther
        data.hospitalId = this.currentUser.item.userAccountKey
      }
      if (self.carePath.dos) {
        data.dos = self.changeStringFormat2(self.carePath.dos)
      }
      let postData = self.assessments;
      postData[0]['patientSwfDetails'] = data
      resolve(postData)
    })
    return promise
  }

  openModel(template: TemplateRef<any>) {
    this.ModelRef = this.Modalservice.show(template, { class: 'modal-lg', backdrop: 'static' })
    this.movable()
  }

  openModelprint(template: TemplateRef<any>) {
    let data: any = {
      'dataMode': 'real',
      'preview': true,
      'docType': 'PDF',
      'vtype': 'design',
      'formType': 'inprogress',
      'watermark': false,
      'assignedId': '',
      'productId': this.userId,
      'userId': this.currentUser.item.userAccountId, 
      lang: this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    this.pdfUrl = this.downloadUrl + data
    this.ModelRef = this.Modalservice.show(template, { class: 'modal-lg', backdrop: 'static' })
    this.movable()
  }

  openOtherModal(id) {
    ////console.log(id);
    if (id == 57 && this.dischargeDispositionPlanId == 3) {
      // let template:TemplateRef<any> = 'viewtemplate';
      //template ='viewtemplate';
      this.ModelRef = this.Modalservice.show('viewtemplate', { class: 'modal-lg', backdrop: 'static' })
      this.movable()

    }
  }

  openModel3(selection: TemplateRef<any>, catid, sur, event) {
    let self = this;
    if (event.target.checked) {
      self.catgoryid = catid
      self.surr = sur
      this.ModelRef = self.Modalservice.show(selection, { class: 'modal-sm', backdrop: 'static' })
      this.movable()
    }
  }
  public deleteapp: any = true
  openModel4(template17: TemplateRef<any>) {
    if (!this.disabled && !this.surdis) {
      let self = this;
      this.patname = this.user.patientName;
      self.getAppoinmentsList(this.userId)
      this.user
      self.getEpisodeAppointmenthospitallist(this.userId);
      self.deleteapp = true
      this.modalRef = this.modalService.show(template17, { class: 'modal-lg', backdrop: 'static' });
      this.movable()
      this.disableSubmit = false

    }
    this.showapp()
  }

  //get appoinments list by patient stage workflow id
  /**
   *
   * @param id patient stage workflow id
   */
  tempappmnt: any = [];
  getAppoinmentsList(id) {
    let self = this;
    var tst
    self.patientservice.getAppoinmentsListwitSWFid(id)
      .subscribe(
        data => {
          if (self.carePath.Dos) {
            this.checkDos = new Date(self.carePath.Dos)
            ////console.log(this.checkDos)
          }

          data.forEach(element => {
            if (element.appointmentTime) {

              var hms = element.appointmentTime;   // your input string
              var a = hms.split(' '); // split it at the space
              // let dateString = '1968-11-16' + element.appointmentTime;
              //element.appointmentTime =new Date(dateString)

              if (a[1] == "PM") {
                tst = a[0].split(':')
                if (Number(tst[0]) != 12)
                  tst[0] = Number(tst[0]) + 12;

                a[0] = tst[0] + ':' + tst[1]
              }
              else {
                tst = a[0].split(':')
                // if(Number(tst[0])!=12)
                tst[0] = Number(tst[0]) == 12 ? "00" : tst[0]
                a[0] = tst[0] + ':' + tst[1]
              }

              a = a[0] + ':00'  //+ a[1]
              let appdate = element.appointmentDate.split(' ');
              let dateString = appdate[0] + ' ' + a;
              let datesTimes = new Date(dateString);
              element.appointmentTime = datesTimes




            }

            if (element.hospitalId && element.appointmentDate)
              element.selectHospital = element.hospitalName;
            else if (element.otherAppmntHspMasterId && element.appointmentDate)
              element.selectHospital = element.otherAppmntHspMasterName;

            element.selectOtherHospital = ""
            element.validTime = true;
            element.appointmenttimechange = false;

          });


          //console.log("Appointment", data);

          this.patientAppoinmentList = _.map(data, self.changeDateFormat)
          self.defaultpatlist = _.map(data, self.changeDateFormat)
          this.patlength = this.patientAppoinmentList.length
          var filterlist = this.patientAppoinmentList.filter(item => item.appointmentTitle == 'Surgery' && (String(item.appointmentId).length >= 5))
          var filterdischarge = this.patientAppoinmentList.filter(item => item.appointmentTitle == 'Discharge' && (String(item.appointmentId).length >= 5))
          ////console.log(filterlist)
          for (var item of this.patientAppoinmentList) {
            if (item.appointmentTitle == 'Surgery') {
              if (this.setstage(item.appointmentDate)) {
                item.completedDate = new Date(item.appointmentDate)
              }
            }
          }
          this.surgerydate = new Date(filterlist[0].appointmentDate)
          this.minsurgerydate = new Date(filterlist[0].appointmentDate)
          this.minsurgerydate.setDate(this.minsurgerydate.getDate() - 1)

          this.dischargedate = new Date(filterdischarge[0].appointmentDate)
          ////console.log(this.surgerydate, this.dischargedate)
          this.deleteapp = true
          for (var i = 0; i < this.patientAppoinmentList.length; i++) {
            this.patientAppoinmentList[i].appmntModified = false
            this.patientAppoinmentList[i].appmntStatus = "Exist"
          }
        }
      )
  }
  setstage(event) {
    if (event) {
      let toDate = new Date();
      if (event.setHours(0, 0, 0, 0) == toDate.setHours(0, 0, 0, 0)) {
        return true
      } else {
        return false
      }

    }
    return false
  }
  addFieldValue() {
    //this.addnew = true
    this.patientAppoinmentList.push({
      'appointmentTitle': "",
      'appointmentDate': "",
      'appointmentTime': "",
      'otherAppmntHspMasterId': 0,
      "selectHospital": ""
    });

    // this.disableAddNew = true
    this.allstatus()
  }


  allstatus() {

    //var allstatus = this.patientAppoinmentList.filter(item => item.appointmentTitle == '')
    // let index = _.findIndex(this.patientAppoinmentList, (o: any): any => {
    //   return o.appointmentTitle == ''
    // })

    let index1 = this.patientAppoinmentList.filter(it => it.appointmentTitle && !it.appointmentDate
      && (it.appointmentMode == "custom" || !it.appointmentMode))

    // if (index != -1 || index1.length!=0) {
    if (index1.length != 0) {
      //this.disableAddNew = true;
      return true
    }
    let index = this.patientAppoinmentList.filter(it => !it.appointmentTitle)
    if (index.length != 0) {
      //this.disableAddNew = true;
      return true
    }

    //this.disableAddNew = false;


  }

  textvalue(event, i) {

    ////console.log(event,i)
    let applist = []
    this.patientAppoinmentList.forEach((element, index) => {
      if (index != i)
        applist.push(element)
    });
    if (event.appointmentDate) {
      let index = _.findIndex(applist, (o: any): any => {
        return (o.appointmentTitle == event.appointmentTitle && o.appointmentDate.setHours(0, 0, 0, 0) == event.appointmentDate.setHours(0, 0, 0, 0) && o.appointmentTime == event.appointmentTime)
      })


      if (index != -1) {
        this.scheduledate = true
        //this.addnew = true
        this.patientAppoinmentList[i].appointmentTitle = ''
        this.patientAppoinmentList[i].appointmentDate = ''
        this.patientAppoinmentList[i].appointmentTime = ''
        this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
          timeOut: this.timealert
        })
      }
      else {
        this.scheduledate = false
      }
    }
    else {

      let index = _.findIndex(applist, (o: any): any => {
        return (o.appointmentTitle == event.appointmentTitle && o.appointmentDate == event.appointmentDate && o.appointmentTime == event.appointmentTime)
      })


      if (index != -1) {
        this.scheduledate = true
        //this.addnew = true
        this.patientAppoinmentList[i].appointmentTitle = ''
        this.patientAppoinmentList[i].appointmentDate = ''
        this.patientAppoinmentList[i].appointmentTime = ''
        this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
          timeOut: this.timealert
        })
      }
      else {
        this.scheduledate = false
      }
    }

  }
  changeDateFormat(n) {
    if (n.appointmentDate) {
      n.appointmentDate = new Date(n.appointmentDate)
    }
    if (n.completedDate) {
      n.completedDate = new Date(n.completedDate);
    }
    return n
  }
  checkAppoinment(i) {
    let self = this;
    var booleanArray = [];
    for (let j = i; j < this.patlength; j++) {
      if (self.patientAppoinmentList[j].completedDate) {
        booleanArray.push(true)
      }
    }

    //   self.patientAppoinmentList.forEach(it =>{
    //     if(it.completedDate){
    //       booleanArray.push(true)
    //     }
    // })


    if (booleanArray.length) {
      return booleanArray.includes(true)
    }
    else {
      return false;
    }
  }
  //change date format for save
  /**
   *
   * @param n appoinments array
   */
  changeDateFormatarray(n) {
    let self = this;
    for (let i = 0; i < n.length; i++) {
      if (n[i].appointmentDate) {
        n[i].appointmentDate = self.changeStringFormat2(n[i].appointmentDate);
      }
      if (n.completedDate) {
        n[i].completedDate = self.changeStringFormat2(n[i].completedDate);
      }
    }
  }

  deleteEmptyAppoinment() {

    _.remove(this.patientAppoinmentList, (n: any): any => {
      return (!n.appointmentTitle
        && (n.appointmentMode == "custom" || !n.appointmentMode))
    });
  }


  //save edited appoinmets;
  saveAppoinments() {
    let self = this;
    this.disableSubmit = true
    let loginHospitalId: any;
    this.deleteEmptyAppoinment()
    loginHospitalId = this.currentUser ? this.currentUser.item ? this.currentUser.item.userAccountKey : 0 : "";
    self.arrangaData(self.patientAppoinmentList).then(
      data => {
        self.patientservice.saveAppoinments(data, loginHospitalId, this.userId)
          .subscribe(
            data => {
              self.toast.success(this.userService.translateText('hospital_portal.appointments.appointment_updated.success'), '', {
                timeOut: this.timealert
              });
              this.addnew = false;
              this.userService.logAudit('savePatientAppointment', 0).subscribe(data => { })
              self.ngOnInit();
              self.modalRef.hide()
            }
          )
      }, err => {

      }
    )
  }

  //filter time incase appoinment set to today
  /**
  *
  * @param event selected date
  * @param i index
  */
  checkTime(event, i) {
    this.allstatus()
    let self = this;
    if (event) {
      if (self.patientAppoinmentList[i].appointmentDate) {
        let today = new Date();
        let timeNow = new Date().getHours();
        let min = new Date().getMinutes();
        let appointmentDate = new Date(self.patientAppoinmentList[i].appointmentDate)
        if (today.setHours(0, 0, 0, 0) == appointmentDate.setHours(0, 0, 0, 0)) {
          if (min > 30) {
            this.mintimeset = timeNow + 1;
          } else {
            this.mintimeset = timeNow + 0.5;
          }
        } else {
          this.mintimeset = 0;
        }
      }
    }

  }



  checkDate(event, i) {
    this.allstatus()
    ////console.log(event,i)
    if (event.appointmentDate < new Date(this.user.dob)) {
      //this.disableAddNew = true
      let self = this
      this.patientAppoinmentList[i].appointmentDate = null
      this.patientAppoinmentList[i].appointmentTime = ''
      this.patientAppoinmentList[i].appmntModified = false
      self.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_cannot_before_dob.error'), '', {
        timeOut: this.timealert
      })

      // this.disableSubmit = true
      return
    }

    var result = this.find_duplicate_in_array(this.patientAppoinmentList)
    if (result.length > 0) {

      if (i >= this.patlength) {
        let applist = []
        this.patientAppoinmentList.forEach((element, index) => {
          if (index != i)
            applist.push(element)
        });
        let index = _.findIndex(applist, (o: any): any => {
          return (o.appointmentTitle == event.appointmentTitle && o.appointmentDate.setHours(0, 0, 0, 0) == event.appointmentDate.setHours(0, 0, 0, 0) && o.appointmentTime == event.appointmentTime)
        })


        if (index != -1 && index != i) {
          ////console.log(i,this.patlength)
          if (i >= this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true

            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
          else if (i < this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentTitle = ''
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
        }
        else {
          this.scheduledate = false
          this.patientAppoinmentList[i].appmntModified = true
          if (i < this.patlength) {
            this.getAppoinmentsListwitSWFid(this.userId, i)
          } else {
            this.patientAppoinmentList[i].appmntStatus = 'New'
          }
        }
      }
      else if (i < this.patlength) {
        //  let applist = this.patientAppoinmentList.slice(i, -i);

        const filteredItems = this.patientAppoinmentList.slice(0, i).concat(this.patientAppoinmentList.slice(i + 1, this.patientAppoinmentList.length))
        let index = _.findIndex(filteredItems, (o: any): any => {
          return (o.appointmentTitle == event.appointmentTitle && o.appointmentDate.setHours(0, 0, 0, 0) == event.appointmentDate.setHours(0, 0, 0, 0) && o.appointmentTime == event.appointmentTime)
        })


        if (index != -1 && index != i) {
          ////console.log(i,this.patlength)
          if (i >= this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentTitle = ''
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
          else if (i < this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })

          }
        }
        else {
          this.scheduledate = false
          this.patientAppoinmentList[i].appmntModified = true
          if (i < this.patlength) {
            this.getAppoinmentsListwitSWFid(this.userId, i)
          } else {
            this.patientAppoinmentList[i].appmntStatus = 'New'
          }
        }
      }
    }
    this.patientAppoinmentList[i].appmntModified = true
    if (i < this.patlength) {
      this.getAppoinmentsListwitSWFid(this.userId, i)
    } else {
      this.patientAppoinmentList[i].appmntStatus = 'New'
    }

    //////console.log(this.patientAppoinmentList[2].appointmentDate)
    let self = this;
    let date

    if (event.appointmentDate == '' || event.appointmentDate == null || event.appointmentDate == 'Invalid Date') {



      this.patientAppoinmentList[i].appointmentDate = null


      ////console.log(this.scheduledate)
      self.toast.error(this.userService.translateText('hospital_portal.disp_messages.please_enter.error') + ` ${this.dateformat} `+ this.userService.translateText('patient_portal.validations.format.error_label'), '', {
        timeOut: this.timealert
      })
      ////console.log(this.scheduledate,"status")
    } else {
      //this.scheduledate = false
    }


    if (event.appointmentDate && (this.patientAppoinmentList[i].appointmentTitle == 'Pre-Operative Testing' || this.patientAppoinmentList[i].appointmentTitle == 'Pre-Operative Class' || this.patientAppoinmentList[i].appointmentTitle == 'CT scan')) {

      if (self.surgerydate) {

        let todayplus = new Date();
        todayplus.setDate(todayplus.getDate() - 1);
        let eventdate = new Date(event.appointmentDate.setHours(0, 0, 0, 0))
        if (eventdate >= self.surgerydate) {

          this.patientAppoinmentList[i].appointmentDate = null

          ////console.log( this.patientAppoinmentList[0].appointmentDate)

          this.scheduledate = true
          self.toast.error(this.userService.translateText('patient_portal.display_messages.please_select_date.error')+`  ${self.Datepipe.transform(self.surgerydate, this.dateform)}`, '', {
            timeOut: this.timealert
          })


        }
        /*   else if (eventdate < todaydate) {

            this.patientAppoinmentList[i].appointmentDate = null

            ////console.log( this.patientAppoinmentList[0].appointmentDate)

           this.scheduledate = true
            self.toast.error(`Please Select the date after  ${date = self.Datepipe.transform(todayplus, this.dateform)}`, '', {
              timeOut: this.timealert
            })


          } */
        else {
          this.scheduledate = false
        }
      }
    }
    /*  else if (event && i == 1) {
       if (self.surgerydate) {
         if (event > self.surgerydate) {

         this.scheduledate = true
           self.toast.error(`Please Select the date before ${date = self.DatePipe.transform(self.surgerydate, this.dateform)}`, '', {
             timeOut: this.timealert
           })
         }
         else{
           this.scheduledate = false
         }
       }
     } */
    /*  else if (event.appointmentDate && i >= this.patlength) {
       let today = new Date();
       let todayplus = new Date();
       todayplus.setDate(todayplus.getDate()-1);
       ////console.log(today)
       ////console.log(todayplus)
       if (self.surgerydate && self.dischargedate) {
         let todaydate = new Date(today.setHours(0,0,0,0))
         let eventdate = new Date(event.appointmentDate.setHours(0,0,0,0))
         if(self.dischargedate < today){

         if(eventdate < todaydate){
          self.patientAppoinmentList[i].appointmentDate = null
          this.scheduledate = true
           self.toast.error(`Please Select the date after  ${date = self.Datepipe.transform(todayplus, this.dateform)}`, '', {
             timeOut: this.timealert
           })

         }

         else if(eventdate > todaydate){
           this.scheduledate = false
         }
       }
       else if(self.dischargedate > today){

         if(eventdate < todaydate){
           this.scheduledate = true
           self.patientAppoinmentList[i].appointmentDate = null
           self.toast.error(`Please Select the date after  ${date = self.Datepipe.transform(todayplus, this.dateform)}`, '', {
             timeOut: this.timealert
           })
         }
         else if(eventdate > todaydate){
           this.scheduledate = false
         }

       }
     }
     } */
    /*  else if (event.appointmentDate && i < this.patlength) {
       let today = new Date();
       let todayplus = new Date();
       todayplus.setDate(todayplus.getDate()-1);
       ////console.log(today)
       ////console.log(self.dischargedate)
       if (self.surgerydate && self.dischargedate) {
         let todaydate = new Date(today.setHours(0,0,0,0))
         let eventdate = new Date(event.appointmentDate.setHours(0,0,0,0))
         if(self.dischargedate < today){

         if(eventdate < todaydate){
          self.patientAppoinmentList[i].appointmentDate = null
          this.scheduledate = true
           self.toast.error(`Please Select the date after  ${date = self.Datepipe.transform(todayplus, this.dateform)}`, '', {
             timeOut: this.timealert
           })

         }
         else if(eventdate > todaydate){
           this.scheduledate = false
         }
       }
       else if(self.dischargedate > today){
         let todaydate = new Date(today.setHours(0,0,0,0))
         let eventdate = new Date(event.appointmentDate.setHours(0,0,0,0))
         if(eventdate < todaydate){
           this.scheduledate = true
           self.patientAppoinmentList[i].appointmentDate = null
           self.toast.error(`Please Select the date after  ${date = self.Datepipe.transform(todayplus, this.dateform)}`, '', {
             timeOut: this.timealert
           })
         }
         else if(eventdate > todaydate){
           this.scheduledate = false
         }

       }
     }
     } */
  }
  //rearrange the date before save it
  /**
  *
  * @param dataArray appoinments array
  */
  arrangaData(dataArray) {
    ////console.log(dataArray)
    let self = this;
    let data = [];
    //  let appoinmets$ =
    let promise = new Promise((resolve, reject) => {
      for (let i = 0; i < dataArray.length; i++) {

        let sampleObj = Object.assign({}, dataArray[i])

        if (sampleObj.hospitalId == -2) {
          sampleObj.hospitalId = "";
        }
        sampleObj.superClientId = window.localStorage['superClientId'] ? window.localStorage['superClientId'] : this.currentUser.item.userAccountId
        if (sampleObj.appointmentDate) {
          sampleObj.appoinmentWithId = this.patientAppoinmentList[i].patientSurgeonId;
          if (!sampleObj.appoinmentWithId && i < this.patlength) {
            self.toast.error(this.userService.translateText('hospital_portal.disp_messages.select_surgeon_name.error')+` ${sampleObj.appointmentTitle}`, '', {
              timeOut: this.timealert
            })
            reject("Error");
          }
        }
        ////console.log(i,"i")


        if (!sampleObj.appoinmentWithId && i >= this.patlength) {
          sampleObj.appoinmentWithId = '';
          sampleObj.patientSurgeonId = '';
          sampleObj.patientSurgeonName = '';
          sampleObj.appoinmentWith = '';
          sampleObj.appointmentId = '';
          sampleObj.patientId = self.user.patientId;
          sampleObj.patientSwfId = self.user.patientSWFId;
          sampleObj.appointmentMode = "custom";
          ////console.log(self.patientId,self.patientSWId)
        }
        if (!sampleObj.appointmentDate) {
          sampleObj.appointmentDate = null;
        }
        if (!sampleObj.appointmentTime) {
          sampleObj.appointmentTime = null
        }
        else {
          sampleObj.appointmentTime = self.Datepipe.transform(sampleObj.appointmentTime, 'hh:mm a');
        }
        if (sampleObj.appointmentDate) {
          sampleObj.appointmentDate = self.Datepipe.transform(sampleObj.appointmentDate, 'yyyy-MM-dd');
        }
        if (sampleObj.completedDate) {
          sampleObj.completedDate = self.Datepipe.transform(sampleObj.completedDate, 'yyyy-MM-dd');
        }
        else if (!sampleObj.completedDate) {
          sampleObj.completedDate = null;
        }

        if (!sampleObj.selectHospital) {
          sampleObj.hospitalId = "";
          sampleObj.hospitalName = "";
        }


        ////console.log(sampleObj,"sampleObj")
        data.push(sampleObj)
        ////console.log(data,"data")
      }
      resolve(data)
    })
    return promise
  }
  //cancel a single appoinment
  /**
  *
  * @param index index
  * @param data appoinment data
  */
  cancelAppointment(index, data) {
    this.deleteapp = false
    ////console.log(index)
    ////console.log(data)
    let self = this;
    if (data.appointmentDate && data.appoinmentWithId) {
      self.patientservice.cancelAppoinments(data).subscribe(
        res => {
          // var str = new String(data.appointmentId);
          // if (index && str.length >= 5) {
          //   self.patientAppoinmentList[index].appointmentTime = 0;
          //   self.patientAppoinmentList[index].appointmentTime = '';
          //   self.patientAppoinmentList[index].appointmentDate = '';
          //   self.patientAppoinmentList[index].appoinmentWithId = '';

          // }else{
          //   this.patientAppoinmentList.splice(index, 1);
          //   this.patlength = this.patientAppoinmentList.length
          // }
          this.getAppoinmentsList(self.user.patientSWFId)
          self.toast.success(this.userService.translateText('hospital_portal.appointments.appointment_was_cancelled.error'), '', {
            timeOut: this.timealert
          });
          this.userService.logAudit('cancelPatientAppointment', 0).subscribe(data => { })
        }
      )
    }
    else if (data.appointmentDate && !data.appoinmentWithId) {
      self.patientAppoinmentList[index].appointmentTime = void 0;
      self.patientAppoinmentList[index].appointmentDate = '';
      self.patientAppoinmentList[index].selectHospital = '';
      this.deleteapp = true
    }
    else {
      self.toast.error(this.userService.translateText('hospital_portal.appointments.appointment_cannot_be_empty.error'), '', {
        timeOut: this.timealert
      })
      this.deleteapp = true
    }

    /*else  if(data.appointmentDate == '' || data.appoinmentWithId == '' || data.appointmentTime == ''){
      this.patientAppoinmentList.splice(index, 1);
    }*/
  }
  cancelAppointmentcustom(index, data) {
    ////console.log(index)
    this.patientAppoinmentList.splice(index, 1);
    this.addnew = false
    this.disableAddNew = false
  }
  checkMinDate(index, ...arg) {
    let date = arg;
    let temArray = []
    if (index == 2) {
      if (date[0]) {
        return date[0]
      }
    }
    let todateTime = new Date().getTime();
    for (let i = 0; i < date.length; i++) {
      if (date[i]) {
        let temtime = new Date(date[i]).getTime()
        if (temtime > todateTime) {
          return new Date(temtime)
        }
      }

    }
    return new Date();
  }
  checkMaxDate(...arg) {

  }
  novalue(id, todo) {
    // let self= this;
    // todo.isTxnCompleted=false
    // self.surr.isTxnCompleted = false
    // this.ModelRef.hide()





    todo.isTxnCompleted = false;
    this.getMytodos();
    this.ModelRef.hide();
    //self.nav.navigate([`/care/newsymptom/${self.user.patientId}/${self.userId}/${todo.hpsmId}/${surveyName}/${status}/${self.user.patientStatus}`])
    //return todo.isTxnCompleted == true;

  }

  getDischaretypeVale(id, status) {
    let self = this;
    if (id) {
      let index = _.findIndex(self.carePath.dischargeTypeList, ['dischargeTypeId', parseInt(id)])
      if (index != -1) {
        if (self.carePath.dischargeTypeList[index].dischargeTypeName.toLowerCase() == 'other' && status == 'planned') {
          return self.carePath.plannedOtherSelectedName;
        } else if (self.carePath.dischargeTypeList[index].dischargeTypeName.toLowerCase() == 'other' && status == 'actual') {
          return self.carePath.actualOtherSelectedName;
        } else {
          return self.carePath.dischargeTypeList[index].dischargeTypeName;
        }

      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  getselect() {
    let self = this;
    self.patientservice.getselcode(this.hospitalid)
      .subscribe(data => {
        self.codes = data
        ////console.log(self.codes)

      })
  }










  onChangevalue(event, templateother, planned, status) {
    ////console.log(event)
    this.planned = planned
    this.pacstatus = status
    if (event != this.pacdata.plannedDischargeId) {
      this.pacdata.plannedDischargeHospitalId = ""
    }
    this.pacsavedata(event)
    if (event == 5) {
      this.openModelpop1(templateother, null)
      this.otherevent = true
    }
    if (event == '1' || event == '4') {
      let index = _.findIndex(this.carePath.dischargehospitalList, (o: any): any => {
        return (o.dischargeTo == "*Unspecified" && o.dischargeType == event)
      })
      this.pacdata.plannedDischargeHospitalId = this.carePath.dischargehospitalList[index].dischargeId
    }
  }
  onChangevalue1(event, templateother, planned, status) {

    this.planned = planned
    this.pacstatus = status.status
    this.patientpacmasterid = status.patientPacMasterMapId
    if (event != this.showdata.plannedDischargeId) {
      this.showdata.plannedDischargeHospitalMasterId = ""
    }

    this.editpacsavedata(event)
    if (event == 5) {
      this.openModelpop1(templateother, null)

    }
    if (event == '1' || event == '4') {
      let index = _.findIndex(this.carePath.dischargehospitalList, (o: any): any => {
        return (o.dischargeTo == "*Unspecified" && o.dischargeType == event)
      })
      this.showdata.plannedDischargeHospitalMasterId = this.carePath.dischargehospitalList[index].dischargeId
    }

  }
  openModelpop(showpopup: TemplateRef<any>, item) {
    let self = this;
    this.tempobj = item
    this.ModelRef = self.Modalservice.show(showpopup, { class: 'modal-md', backdrop: 'static' })
    this.movable()
  }
  selectionEventType: any;



  eventOtherTembItem: any;
  openModelpop1(template: TemplateRef<any>, item: any) {
    this.eventOtherTembItem = item;
    let self = this;
    this.ModelRef = self.Modalservice.show(template, { class: 'modal-md', backdrop: 'static', keyboard: false })
    this.movable()
    this.carePath.otherplannedDischargeId = ""
    if (this.currentUser.item.language != 'en_uk') {
      this.carePath.dcode = '+1,USA'

    } else if (this.currentUser.item.language == 'en_uk') {
      this.carePath.dcode = '+44,UK'
    }
    if (this.currentUser.item.clientTeleCode)
      this.carePath.dcode = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
    this.carePath.disablepac = undefined;
    self.patientservice.otherpac(self.currentUser.item.userAccountKey)
      .subscribe(data => {
        this.otherpac = data
        ////console.log(this.otherpac, "Others");
      });

    this.selectionEventType = item;

  }


  openModelpop6(template: TemplateRef<any>, cusstatus, todo) {
    let self = this;

    this.cusstatus = cusstatus
    if (cusstatus == 'edit') {
      this.custchange = this.userService.translateText('patient_portal.assessment.complete.label')
      this.patientservice.getcustomtodo(this.userId, todo.todoCarePlanSurveyId, todo.todoCategoryId)
        .subscribe(data => {
          if (data) {
            self.carePath.subject = data[0].todoCarePlanSurveyName
            self.carePath.todoCarePlanSurveyId = todo.todoCarePlanSurveyId
            self.carePath.duedate = this.Datepipe.transform(data[0].dueDate, this.dateform)
            self.carePath.description = data[0].description
            let date = new Date()
            this.mintododata = new Date(date.setHours(0, 0, 0, 0))
            this.getmodifyenable(self.carePath.duedate)
          }
        })
    }
    else {
      let date = new Date()
      this.mintododata = new Date(date.setHours(0, 0, 0, 0))
      this.custchange = this.userService.translateText('patient_portal.constants.submit.label');
    }
    this.ModelRef = self.Modalservice.show(template, { class: 'modal-md', backdrop: 'static' })
    this.movable()
  }
  openModelpops(showpopup4: TemplateRef<any>) {
    let self = this;
    this.ModelRef12 = self.Modalservice.show(showpopup4, { class: 'modal-md', backdrop: 'static' })
    this.movable()
  }
  openModelpops2(showpopup3: TemplateRef<any>) {
    let self = this;
    this.ModelRef123 = self.Modalservice.show(showpopup3, { class: 'modal-md', backdrop: 'static' })
    this.movable()
  }

  onChangeObj1(id, template, planned, status) {
    this.planned = planned
    this.pacstatus = status
    ////console.log(id)
    if (id != 5) {
      this.aother = ''
    }
    this.patientservice.getvisitdetails(this.hospitalid)
      .subscribe(data => {
        this.visit = data.hospitalplannedvisitmastertable
        let index = _.findIndex(this.visit, (o: any): any => {
          return o.dischargetypeId == id
        })
        if (index != -1 && this.visit[index].plannedVisit) {
          this.ennableactualvisit = false;
        } else {
          this.ennableactualvisit = true
          this.carePath.actualVisit = ''
          this.enableactual = false
        }
      })
    this.carePath.actualDischargeHospitalId = ""
    this.actid = id;
    // this.carePath.code = '+1,USA'
    if (this.currentUser.item.language != 'en_uk') {
      this.carePath.dcode = '+1,USA'

    } else if (this.currentUser.item.language == 'en_uk') {
      this.carePath.dcode = '+44,UK'
    }
    if (this.currentUser.item.clientTeleCode)
      this.carePath.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
    this.carePath.dischargePhone = ''
    this.carePath.dischargeContact = ''
    if (id == '5') {
      this.openModelpop1(template, null)
    }
    if (id == '1' || id == '4') {
      let index = _.findIndex(this.carePath.dischargehospitalList, (o: any): any => {
        return (o.dischargeTo == "*Unspecified" && o.dischargeType == id)
      })
      this.carePath.actualDischargeHospitalId = this.carePath.dischargehospitalList[index].dischargeId
    }
  }


  onChangeOl(id, showpopup2, temp1) {
    ////console.log(temp1)
    this.temp1 = temp1
    // ////console.log(this.dispalnid)
    let index = _.findIndex(this.temp1, (o: any): any => {
      return o.dischargeId == id
    })
    if (index != -1) {
      if (this.temp1[index].dischargeTo == "*Other" || this.temp1[index].dischargeTo == "Other") {
        if (this.carePath.dischargeTeleCode) {
          this.carePath.dcode = this.carePath.dischargeTeleCode + ',' + this.carePath.dischargeTeleCountryCode;
        }
        else {
          if (this.currentUser.item.language != 'en_uk') {
            this.carePath.dcode = '+1,USA'

          } else if (this.currentUser.item.language == 'en_uk') {
            this.carePath.dcode = '+44,UK'
          }
          if (this.currentUser.item.clientTeleCode)
            this.carePath.dcode = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
        }
        //this.openModelpop2(showpopup2,null)
      }
    }
  }

  showpop(showpat: TemplateRef<any>, id) {
    this.pacdata = Object.assign({}, id)

    if (this.pacdata.plannedAdmissionDate) {
      let date = this.changeStringFormat2(this.pacdata.plannedAdmissionDate);
      let dosDate = new Date(date)
      let changeDate = dosDate.setDate(dosDate.getDate() + this.configuredate)
      this.pacdata.plannedSnfDischargeDate = new Date(changeDate);
      this.showplanneddate();
    }
    let self = this;
    this.ModelRef1 = self.Modalservice.show(showpat, { class: 'modal-lg', backdrop: 'static' })
    this.movable()
    this.down();
  }

  bindDischargeType(dischargeTo) {
    if(dischargeTo.includes('Unspecified')) 
      return this.userService.translateText('hospital_portal.mytodos.unspecified.option')
    else if(dischargeTo.includes('Other'))
      return this.userService.translateText('patient_portal.constants.other.label')

    return dischargeTo;
  }


  getHospitalName(id) {
    let self = this;
    if (id) {
      let index = _.findIndex(self.carePath.dischargehospitalList, ['dischargeId', parseInt(id)])
      if (index != -1) {
        return self.carePath.dischargehospitalList[index].dischargeTo;
      } else {
        return "";
      }
    } else {
      return "";
    }
  }


  disablenotes(data) {
    let index = _.findIndex(data, (o: any): any => {
      return o.choicetypeId == 10
    })
    if (index != -1) {
      return !data[index].selected
    } else {
      return true;
    }
  }

  /* checkNew(index){
    let self = this;
    if(self.myTodos.length){
     if( self.myTodos[index].toDoCarePlanSurveyList.length){
     return !self.myTodos[index].toDoCarePlanSurveyList[0].isTxnCompleted
     }
     else{
       return false
     }
    }else{
      return false
    }
  } */


  printpage(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
        <meta name="viewport" content="width=1000,height=auto"/>
<meta charset="UTF-8"/>


          <title>Print tab</title>
          <style type="text/css">


          body {
              font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
              font-size: 0.9rem;
              font-weight: 400;
              line-height: 1.5;
              color: #212529;
          }

            .container
            {
              width: 861px;
              height: 1024px;
              background-color: #ffffff;
              position: absolute;
              z-index: 0;
            }

            .img
            {
              position: absolute;
              top: 3%;
              left: 3%;
              z-index: 1
            }
            .bio
            {
              font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
              position: absolute;
              top: 2%;
              left: 20%;
              z-index: 1
            }
            .logo
            {
              position: absolute;
              top: 3%;
              left: 64%;
              z-index: 1;
              border-radius: none;
            }

            input
            {
            border: 0;
              border-bottom-width: 0px;
              border-bottom-style: none;
              border-bottom-color: currentcolor;
          outline: 0;
          background: transparent;
          border-bottom: 1px solid black;
          }
              .pos
              {
          font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
                position: absolute;
                z-index: 2;

              }

          /*hr {
              box-sizing: content-box;
              height: 0;
              overflow: hidden;
          }
          */
          .h6, h6 {
              font-size: 1rem;
          }

          .form-control {
              display: block;
              width: 100%;
              padding: .5rem .75rem;
              font-size: 1rem;
              line-height: 1.25;
              color: #495057;
              background-color: #fff;
              background-image: none;
              background-clip: padding-box;
              border: 1px solid rgba(0,0,0,.15);
              border-radius: .25rem;
              transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
          }

          .checkbox label {
              display: inline-block;
              padding-left: 5px;
              position: relative;
          }

          .checkbox label::after {
              color: #2b3d51;
              display: inline-block;
              font-size: 15px;
              height: 16px;
              left: 2px;
              margin-left: -20px;
              padding-left: 3px;
              padding-top: 1px;
              position: absolute;
              top: 0px;
              width: 16px;
          }
          .checkbox label::before {
              -o-transition: 0.3s ease-in-out;
              -webkit-transition: 0.3s ease-in-out;
              background-color: transparent;
              border-radius: 3px;
              border: 2px solid rgba(43, 61, 81, 0.5);
              content: "";
              display: inline-block;
              height: 17px;
              left: 0;
              margin-left: -20px;
              position: absolute;
              transition: 0.3s ease-in-out;
              width: 17px;
              outline: none !important;
              margin-top: 2px;
          }
          .checkbox input[type="checkbox"] {
              cursor: pointer;
              opacity: 0;
              z-index: 1;
              outline: none !important;
          }


          .checkbox-primary input[type="checkbox"]:checked + label::before {
              background-color: #039cfd;
              border-color: #039cfd;
          }

          .checkbox-primary input[type="checkbox"]:checked + label::after {
              color: #ffffff;
          }

          .checkbox input[type="checkbox"]:checked + label::after {
              content:  '?';
              font-weight: 900;
              color: #fff;
              display: inline-block;
              font-size: 15px;
              height: 16px;
              left: 2px;
              margin-left: -20px;
              padding-left: 3px;
              padding-top: 1px;
              position: absolute;
              top: 0px;
              width: 16px;
          }


          div.input-top div
          {
            margin-top: 5%;
          }

          div.input-top1 div
          {
            margin-top: 2.5%;
          }
          .angularvalue{
            border: 0;
            border-bottom-width: 0px;
            border-bottom-style: none;
            border-bottom-color: currentcolor;
            outline: 0;
            background: transparent;
            border-bottom: 1px solid black;
          }

          .item0{
            left: 10%;

          }
          .item1{
            left: 55%;

          }
          .item2{
            left: 10%;

          }

          @media print {
            body, html, #wrapper {
                width: 100%;
            }
      }

            </style>

        </head>

        <body onload="window.print();window.close();" style="overflow: hidden;" >${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  makeNull(event, ans, id) {

    if (id < 5) {
      ans[3].selected = false

    }
    if (id == 5 || id == 38) {
      for (let i = 0; i < ans.length; i++) {
        if (ans[i].choicetypeId != 5) {
          ans[i].selected = false;
        }
      }

    }
    if ((id < 8 && id > 5) || (id == 9 || id == 42)) {
      ans[2].selected = false

    }
    if (id == 8 || id == 40) {
      if (event) {
        for (let i = 0; i < ans.length; i++) {
          if (ans[i].choicetypeId != 8) {
            ans[i].selected = false;
          }
        }
        ans[3].textBoxValue = "0"
      }

    }
    if (id == 10) {
      for (let i = 0; i < ans.length; i++) {
        if (ans[i].choicetypeId != 10) {
          ans[i].selected = false;
          ans[i].notes = null;
        }
      }
    }
    if (id == 11) {
      for (let i = 0; i < ans.length; i++) {
        if (ans[i].choicetypeId != 11) {
          ans[i].selected = false;
          ans[i].notes = null;
        }
      }
    }
    if (id == 12) {
      for (let i = 0; i < ans.length; i++) {
        if (ans[i].choicetypeId != 12) {
          ans[i].selected = false;
          ans[i].notes = null;
        }
      }
    }
    if (id == 6 || id == 39) {
      if (event) {
        if (ans[1].selected) {
          ans[3].selected = true;
          ans[3].textBoxValue = parseInt(ans[0].notes) + parseInt(ans[1].notes)
          ans[3].textBoxValue = ans[3].textBoxValue.toString()
          if (ans[3].textBoxValue == "NaN") {
            ans[3].textBoxValue = ''
          }
          $('#notes31').focus()
        }
        else {
          ans[3].selected = true;
          ans[3].textBoxValue = ans[0].notes
          $('#notes31').focus()
        }
      } else {
        if (ans[1].selected) {
          ans[3].selected = true;
          ans[3].textBoxValue = ans[1].notes
          $('#notes31').focus()
        }
        else {
          for (let i = 0; i < ans.length; i++) {
            if (ans[i].choicetypeId != 8) {
              ans[i].selected = false;
            }
          }
          ans[2].selected = true;
          ans[3].textBoxValue = "0"
        }
      }

    }
    if (id == 7 || id == 40) {
      if (event) {
        if (ans[0].selected) {
          ans[3].selected = true;
          ans[3].textBoxValue = parseInt(ans[0].notes) + parseInt(ans[1].notes)
          ans[3].textBoxValue = ans[3].textBoxValue.toString()
          if (ans[3].textBoxValue == "NaN") {
            ans[3].textBoxValue = ''
          }
          $('#notes31').focus()
        }
        else {
          ans[3].selected = true;
          ans[3].textBoxValue = ans[1].notes
          $('#notes31').focus()
        }

      } else {
        if (ans[0].selected) {
          ans[3].selected = true;
          ans[3].textBoxValue = ans[0].notes
          $('#notes31').focus()
        }
        else {
          for (let i = 0; i < ans.length; i++) {
            if (ans[i].choicetypeId != 8) {
              ans[i].selected = false;
            }
          }
          ans[2].selected = true;
          ans[3].textBoxValue = "0"
        }

      }

    }



    if (id == 10) {
      if (event) {
        ans[3].selected = true;
        $('#notes32').focus()
      } else {
        ans[3].selected = false;
        ans[3].notes = ''
      }
    }
  }


  makeNulll(event, ans, id) {
    // ////console.log(event,id,ans)


    if (id == "None") {
      if (event) {
        for (let i = 0; i < ans.length; i++) {
          if (ans[i].choiceTypeName != "None") {
            ans[i].selected = false;
          }
        }
      }

    }
    if (id != "None") {
      if (event) {
        for (let i = 0; i < ans.length; i++) {
          if (ans[i].choiceTypeName == "None") {
            ans[i].selected = false;
          }
        }
      }

    }
  }
  makeitnull(event, ans, id) {
    // ////console.log(event,id,ans)
    if (event) {
      for (let i = 0; i < ans.length; i++) {
        if (ans[i].choiceTypeName == id) {
          ans[i].selected = true;
        } else {
          ans[i].selected = false;
        }
      }
    }
  }
  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = 0;
    } catch (err) { }
  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }

  }
  // <body onload="window.print();window.close()" >${printContents}</body>

  datecheck(datevalue) {
    ////console.log("date", datevalue)
    if (datevalue == "" || datevalue == null) {
      ////console.log("in")
      this.dsdate = true;
    }
  }

  req() {
    this.clearadsave();
    this.newreq = true;
    this.Download = false;
    this.showplanneddate();
    if (this.alert) {
      this.toast.error('There are some inconsistencies in your planned details. Please update by clicking the edit icon.', '', {
        timeOut: this.timealert
      })
      this.alert = false
    }
  }

  showplanneddate() {
    this.patientservice.pacview(this.userId)
      .subscribe(pacdata => {
        ////console.log(pacdata)
        if (pacdata.length != 0) {
          this.tractionlist = pacdata.sort();
          this.length = this.tractionlist.length;
          this.pacdata.plannedAdmissionDate = this.tractionlist[this.length - 1].plannedDate;
          this.pacdata.plannedAdmissionDate = new Date(this.pacdata.plannedAdmissionDate);
          this.pacdata.plannedAdmissionDate = new Date(this.pacdata.plannedAdmissionDate);
          this.setmin = this.pacdata.plannedAdmissionDate
          let dosDate = new Date(this.pacdata.plannedAdmissionDate)
          let changeDate = dosDate.setDate(dosDate.getDate() + this.configuredate)
          this.pacdata.plannedSnfDischargeDate = new Date(changeDate);
        }

      })
  }

  down() {
    this.pacview();
    this.showplanneddate();
    this.newreq = false;
    this.Download = true;
    this.view = true;
    this.edit = false;
  }


  pacsave(data) {
    this.save = true
    this.patientservice.pacview(this.userId)
      .subscribe(pacdata => {
        this.tractionlist = pacdata.sort();
        if (this.pacdata.plannedDischargeId == this.pother) {
          this.pacdata.plannedDischargeId = '5'

        }
        if (this.pacdata.plannedDischargeId == '5') {
          let enable = _.findIndex(this.carePath.dischargehospitalList, (o: any): any => {
            return o.dischargeType == 5
          })
          this.pacdata.plannedDischargeHospitalId = this.carePath.dischargehospitalList[enable].dischargeId
        }
        if (this.otherevent) {

          this.pacdata.plannedDischargeId = '5'
        }
        data = {
          "patientPacMasterMapId": "",
          "plannedAdmissionDate": this.Datepipe.transform(this.pacdata.plannedAdmissionDate, this.dateform),
          "plannedDischargeId": this.pacdata.plannedDischargeId,
          "plannedDischargeHospitalMasterId": this.pacdata.plannedDischargeHospitalId,
          "plannedFacilityDischargeDate": this.Datepipe.transform(this.pacdata.plannedSnfDischargeDate, this.dateform),
          "plannedVisit": this.pacdata.plannedVisit

        }

        this.patientservice.savepac(this.userId, this.uid, data)
          .subscribe(data => {
            ////console.log(data)
            if (data[0].status == "Success") {
              this.toast.success(this.userService.translateText('hospital_portal.mytodos.plan_added.success'), '', {
                timeOut: this.timealert
              })
              this.clearsave();
              this.patientservice.terminatepac(this.userId)
                .subscribe(data => {
                  ////console.log(data)
                })
              this.showplanneddate();
            }
            else {
              this.toast.error(data[0].message, '', {
                timeOut: this.timealert
              })
            }

          })
      })
    // this.savedata ={
    //   "patientPacMasterMapId": "",
    //   "plannedAdmissionDate":this.Datepipe.transform(this.pacdata.plannedAdmissionDate, 'MM/dd/yyyy'),
    //   "plannedDischargeId":this.pacdata.plannedDischargeId,
    //     "plannedDischargeHospitalMasterId":this.pacdata.plannedDischargeHospitalId,
    //     "plannedFacilityDischargeDate":this.Datepipe.transform(this.pacdata.plannedSnfDischargeDate, 'MM/dd/yyyy')
    // }


    // this.patientservice.pacviews(this.userId)
    // .subscribe(datas=>{
    //   ////console.log(datas[0])
    //   if(datas[0] == "InProgress")
    //   this.patientservice.updatePacProgress(this.userId,this.savedata)
    // .subscribe(data=>{
    // ////console.log(data)
    // })

    // })
  }

  //   let index = _.findIndex(this.traction,(o:any):any=>{
  //     return o.status == "InProgress"
  //  })
  //  if(index != -1){

  // }
  clearsave() {
    this.pacdata.plannedDischargeDate = "";
    this.pacdata.plannedDischargeId = "";
    this.pacdata.plannedDischargeHospitalId = "";
    this.pacdata.plannedSnfDischargeDate = "";
    this.pother = ""
  }
  clearadsave() {
    this.pacdata.plannedDischargeId = "";
    this.pacdata.plannedDischargeHospitalId = "";
    this.pother = ""
  }
  clearedit() {
    this.showdata.plannedAdmissionDate = "";
    this.showdata.plannedDischargeId = "";
    this.showdata.plannedDischargeHospitalMasterId = "";
    this.showdata.plannedDate = "";
  }
  pacview() {
    this.patientservice.pacview(this.userId)
      .subscribe(data => {
        // ////console.log(data)
        this.tractionlist = data;
        // if(data.status){
        //   this.toast.success('Data Updated Successfully',  '', {
        //     timeOut: this.timealert})
        // }
        // else{
        //   this.toast.error('Not vaild data',  '', {
        //     timeOut: this.timealert})
        // }
      })
  }
  showedit(data, i) {
    this.ind = i
    this.view = false;
    this.edit = true;
    this.showdata = Object.assign({}, data);
    // this.showdatd =this.Datepipe.transform(this.showdata.PlannedAdmissionDate, 'MM/dd/yyyy')
    this.showdata.plannedAdmissionDate = new Date(this.showdata.plannedAdmissionDate)
    ////console.log(this.showdata.plannedDischargeHospitalMasterId, "id")
    this.pacmapid = data.patientPacMasterMapId;
    this.mindate = new Date(this.tractionlist[i].plannedAdmissionDate)
    this.counttwo3 = 0;
    if (this.pacstatus == 'UpComing' && data.plannedOtherSelectedName) {
      this.pother = data.plannedOtherSelectedName
      this.showdata.plannedDischargeId = data.plannedOtherSelectedName
    } else if (this.pacstatus != 'UpComing' && data.plannedOtherSelectedName) {
      this.carePath.pother = data.plannedOtherSelectedName
      this.showdata.plannedDischargeId = data.plannedOtherSelectedName
    }

  }
  updateview(data) {
    if (data.plannedDischargeId == this.pother || data.plannedDischargeId == this.carePath.pother) {
      data.plannedDischargeId = '5'
    }
    if (data.plannedDischargeId == '5') {
      let enable = _.findIndex(this.carePath.dischargehospitalList, (o: any): any => {
        return o.dischargeType == 5
      })
      data.plannedDischargeHospitalMasterId = this.carePath.dischargehospitalList[enable].dischargeId
    }
    this.sentdata = {
      "patientPacMasterMapId": this.pacmapid,
      "plannedAdmissionDate": this.Datepipe.transform(data.plannedAdmissionDate, this.dateform),
      "plannedDischargeHospitalMasterId": data.plannedDischargeHospitalMasterId,
      "plannedDischargeId": data.plannedDischargeId,
      "plannedFacilityDischargeDate": this.Datepipe.transform(data.plannedDate, this.dateform),
      "status": data.status,
      "plannedVisit": data.plannedVisit
    }
    this.patientservice.upadtepac(this.userId, this.uid, this.sentdata)
      .subscribe(data => {
        this.update = true
        ////console.log(data)
        if (data[0].status == "Success") {
          this.toast.success('Plan Updated Successfully', '', {
            timeOut: this.timealert
          })
          if (data.plannedDischargeId == '5' && this.pacstatus == 'UpComing') {
            data.plannedDischargeId = this.pother
          }
          else if (data.plannedDischargeId == '5' && this.pacstatus != 'UpComing') {
            data.plannedDischargeId = this.carePath.pother
          }
          this.showedit(this.tractionlist[this.ind], this.ind)
          this.patientservice.terminatepac(this.userId)
            .subscribe(data => {
              ////console.log(data)
            })
        }
        else {
          this.toast.error(data[0].message, '', {
            timeOut: this.timealert
          })
        }
      })

    if (data.status == "InProgress")
      this.patientservice.updatePacProgress(this.userId, this.sentdata)
        .subscribe(data => {
          ////console.log(data)
        })


  }
  open(selection1: TemplateRef<any>, selection4: TemplateRef<any>, id, i) {
    let self = this;
    if (i == 0 || i == (this.tractionlist.length - 1))
      this.ModelRef124 = self.Modalservice.show(selection1, { class: 'modal-sm', backdrop: 'static' })
    else {
      this.ModelRef125 = self.Modalservice.show(selection4, { class: 'modal-sm', backdrop: 'static' })
      this.alert = true
    }
    this.movable()
    this.delid = id;
    this.i = i
  }

  disqualifipat(templatedel: TemplateRef<any>, bundlePatientId) {
    this.bundleid = bundlePatientId
    this.patdisqualifi.stageId = this.user.stageId
    this.patdisqualifi.reasonId = ''
    this.changestage(this.patdisqualifi.stageId)
    this.modalRef = this.modalService.show(templatedel, { class: 'modal-lg', backdrop: "static" });
    this.movable()
  }
  close() {

    this.modalRef.hide()
  }

  deletepac(sel) {
    //  sel.plannedHspTransfer = sel.plannedHspTransfer?sel.plannedHspTransfer:0;
    sel.anonymousDischargeId = sel.anonymousDischargeId ? sel.anonymousDischargeId : 0
    this.patientservice.deletepac(this.delid, sel.anonymousDischargeId, sel.trackActualVisible, sel.userAccountId)
      .subscribe(data => {
        ////console.log(data)
        this.toast.success('Plan Deleted Successfully', '', {
          timeOut: this.timealert
        })
        //this.pacview();

      })
    //if (sel == 'selc1')
    this.ModelRef124.hide();
    // else if (sel == 'selc4')
    //  this.ModelRef125.hide();
  }

  closepop() {
    if (this.alert) {
      this.toast.error('There are some inconsistencies in your planned details. Please update by clicking the edit icon.', '', {
        timeOut: this.timealert
      })
      this.alert = false
    }
    this.ModelRef1.hide();
    this.clearsave();
    if (this.save || this.update) {
      let self = this;
      self.countone = 0;
      self.counttwo = 0;
      self.counttwo2 = 0;
      self.counttwo3 = 0;
      this.getCarepathDetails();
      this.save = false; this.update = false;
    }

  }

  popupother(id, showpopup4, temp) {
    ////console.log(id, temp)
    this.temp = temp
    let index = _.findIndex(this.temp, (o: any): any => {
      return o.dischargeId == id
    })
    if (index != -1) {
      ////console.log(this.temp[index].dischargeTo)
      if (this.temp[index].dischargeTo == "*Other" || this.temp[index].dischargeTo == "Other") {
        this.openModelpops(showpopup4)
      }
    }
  }
  popupotherpop(id, showpopup3, temp) {
    ////console.log(id, temp)
    this.temp = temp
    let index = _.findIndex(this.temp, (o: any): any => {
      return o.dischargeId == id
    })
    if (index != -1) {
      ////console.log(this.temp[index].dischargeTo)
      if (this.temp[index].dischargeTo == "*Other" || this.temp[index].dischargeTo == "Other") {
        this.openModelpops2(showpopup3)
      }
    }
  }
  openModeles(confirmnew: TemplateRef<any>, emp) {
    let self = this;
    this.modalRef = self.modalService.show(confirmnew, { class: 'modal-sm', backdrop: 'static' })
    this.movable()
    this.emp = emp
    this.enablepatient = true
  }
  openModelesphone(confirmnewphone: TemplateRef<any>, emp) {
    let self = this;
    this.modalRef = self.modalService.show(confirmnewphone, { class: 'modal-sm', backdrop: 'static' })
    this.movable()
    this.emp = emp
    this.enablepatient = true
  }
  infodetils(type) {
    //////console.log(idspass);
    //////console.log(namepass);
    this.enablepatient = false
    this.patientservice
      .getpatientemail(this.userId, this.currentUser.item.userAccountId, type)
      .subscribe(
        data => {
          if (type == 'email') {
            if (data) {
              this.toast.toastrConfig.timeOut = 3000;
              this.toast.success(this.userService.translateText('hospital_portal.disp_messages.email_sent.success'));
            }
            else {
              this.toast.toastrConfig.timeOut = 3000;
              this.toast.error(this.userService.translateText('hospital_portal.disp_messages.email_not_found.error'));
            }
          } else {
            if (data) {
              this.toast.toastrConfig.timeOut = 3000;
              this.toast.success(this.userService.translateText('hospital_portal.disp_messages.sms_sent.success'));
            }
            else {
              this.toast.toastrConfig.timeOut = 3000;
              this.toast.error(this.userService.translateText('hospital_portal.disp_messages.sms_not_found.error'));
            }
          }
          this.modalRef.hide()
        }
      );
  }
  facility(id) {

    this.patientservice.showpopother(this.currentUser.item.userAccountKey, this.pacdata.plannedDischargeId, id)
      .subscribe(data => {
        if (data.status) {
          this.userService.logAudit('savePlannedOtherFacilty', 0).subscribe(data => { })
          this.patientservice.getCarePlanDetails(this.userId, this.uid)
            .subscribe(data => {
              if (Array.isArray(data) && data.length) {
                this.pacdata.dischargehospitalList = data[0].dischargehospitalList;
              }

              let index = _.findIndex(this.pacdata.dischargehospitalList, (o: any): any => {
                return o.dischargeTo == id
              })
              if (index != -1) {
                this.pacdata.plannedDischargeHospitalId = this.pacdata.dischargehospitalList[index].dischargeId
              }

            });
        }
        this.ModelRef123.hide();


      });
  }
  editfacility(id) {
    this.patientservice.showpopother(this.currentUser.item.userAccountKey, this.showdata.plannedDischargeId, id)
      .subscribe(data => {
        if (data.status) {
          this.userService.logAudit('savePlannedOtherFacilty', 0).subscribe(data => { })
          this.patientservice.getCarePlanDetails(this.userId, this.uid)
            .subscribe(data => {
              if (Array.isArray(data) && data.length) {
                this.pacdata.dischargehospitalList = data[0].dischargehospitalList;
              }

              let index = _.findIndex(this.pacdata.dischargehospitalList, (o: any): any => {
                return o.dischargeTo == id
              })
              if (index != -1) {
                this.showdata.plannedDischargeHospitalMasterId = this.pacdata.dischargehospitalList[index].dischargeId
              }

            });
        }
        this.ModelRef12.hide();


      });
  }


  facilityacutual(datas) {

    let actualname = this.carePath.dname;

    this.patientservice.savePlan(this.currentUser.item.userAccountKey, this.facilityTempObj.anonymousDischargeId, actualname)
      .subscribe(data => {
        if (data.status) {

          /* this.patientservice.getCarePlanDetails(this.userId, this.uid)
         .subscribe(data => {
           if (Array.isArray(data) && data.length) {
             this.carePath.dischargehospitalList = data[0].dischargehospitalList;
           }

           let index = _.findIndex(this.carePath.dischargehospitalList, (o: any): any => {
             return o.dischargeTo == this.carePath.dname
           })
           if (index != -1) {



             this.carePath.actualDischargeHospitalId = this.carePath.dischargehospitalList[index].dischargeId
             this.carePath.dos = dos
             if (dos != '')
               this.SetDosStatus(dos)
             this.carePath.actualDischargeDate = actualdate
             this.carePath.dischargePhone = datas.dPhone
             let self = this;
             if (self.carePath.dischargePhone) {
               let x = self.carePath.dischargePhone.split("");
               let y = []
               let k = []
               let m = []
               for (var i = 0; i < 3; i++) {
                 y[i] = x[i]

               }
               for (var j = 3; j < 6; j++) {
                 k[j] = x[j]
               }
               for (var l = 6; l < x.length; l++) {
                 m[l] = x[l]
               }
               self.carePath.dischargePhone = '(' + y.join('') + ') ' + k.join('') + '-' + m.join('')
             }


             this.carePath.dischargeContact = datas.dContact
             this.carePath.actualDischargeTypeForOther = datas.dname
             this.carePath.dischargeContact = datas.dContact
             this.carePath.actualDischargeTypeForOther = datas.dname
             this.carePath.code = datas.dcode;
             datas.dPhone = ""
             datas.dContact = ""
             datas.dname = ""
             datas.dcode = ""
             ////console.log("id", this.carePath.actualDischargeHospitalId)
           }

         }) */
          this.userService.logAudit('savePlannedOtherFacilty', 0).subscribe(data => { })
          this.facilityTempObj.anonymousDischargeHospitalMasterId = data.dischargeHspMastId;
          this.fetchDischargeList();
          this.doCompleteEvent(this.facilityTempObj);

        }
        this.ModelRef4.hide();
      });
  }


  /** Cancel and reschedule start here */

  openCancel(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
    this.movable()
    this.enablepatient = true
  }

  openReschedule(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.movable()
  }

  reScheduleObj: any;
  cancelScheduleObj: any;



  //Cancel Plan
  cancelSchedule(mytodostatus) {
    this.enablepatient = false
    this.patientservice.cancelSurgery(this.user.patientSWFId,
      this.currentUser.item.userAccountId).subscribe(
        data => {
          this.modalRef.hide();
          this.cancelScheduleObj = data;

          this.enablepatient = true
          if (this.cancelScheduleObj.status == "true") {
            this.userService.logAudit('cancelSurgery', 0).subscribe(data => { })
            this.tempdate = '';
            //this.initFunction(mytodostatus);
            this.DOSChangeDate = "";
            this.saveBtnEnable = true;
            this.createPACEventbtn = true;
            this.getUserDetails();
            this.ngOnInit();
            this.toast.success(this.cancelScheduleObj.message, '', { timeOut: this.timealert });
          } else
            this.toast.error(this.cancelScheduleObj.message, '', { timeOut: this.timealert })
        })
  }


  //Reschedule Plan
  reScheduleDOS(reschedule, mytodostatus) {
    let dos = this.changeStringFormat2(reschedule.DOS);

    let reschedulePlan = {
      "dos": dos,
      "patientSwfId": this.user.patientSWFId,
      "reason": reschedule.reason,
      "userAccountId": this.currentUser.item.userAccountId
    }

    this.patientservice.rescheduleDOS(reschedulePlan)
      .subscribe(data => {
        this.modalRef.hide();
        this.reScheduleObj = data;

        /* alert(JSON.stringify(data)); */

        if (this.reScheduleObj.status == "true") {
          this.initFunction();
          this.toast.success(this.reScheduleObj.message, '', { timeOut: this.timealert });
        } else
          this.toast.error(this.reScheduleObj.message, '', { timeOut: this.timealert })
      })
  }

  pacsavedata(id) {
    if (id == this.pother) {
      id = '5'
    }
    this.patientservice.getvisitdetails(this.hospitalid)
      .subscribe(data => {
        this.visit = data.hospitalplannedvisitmastertable
        let index = _.findIndex(this.visit, (o: any): any => {
          return o.dischargetypeId == id
        })
        if (index != -1 && this.visit[index].plannedVisit) {
          this.calculateplanedvisit2(this.visit[index].plannedVisit)
        } else {
          this.pacdata.plannedVisit = ''
          this.enabletextpac = false
        }
      })
  }

  changedate() {
    if (this.pacdata.plannedDischargeId) {
      this.patientservice.getvisitdetails(this.hospitalid)
        .subscribe(data => {
          this.visit = data.hospitalplannedvisitmastertable
          let index = _.findIndex(this.visit, (o: any): any => {
            return o.dischargetypeId == this.pacdata.plannedDischargeId
          })
          if (index != -1 && this.visit[index].plannedVisit) {
            this.calculateplanedvisit2(this.visit[index].plannedVisit)
          } else {
            this.enabletextpac = false
          }
        })
    }
  }


  calculateplanedvisit2(visit) {
    if (this.pacdata.plannedAdmissionDate && this.pacdata.plannedSnfDischargeDate) {
      this.enabletextpac = true;
      let event = this.pacdata.plannedSnfDischargeDate
      let eventdos = this.pacdata.plannedAdmissionDate
      ////console.log("plan", event)
      ////console.log("dos", eventdos)
      if (event && eventdos) {
        var plandate = new Date(event)
        var dosdate = new Date(eventdos)
        var diff = Math.abs(plandate.getTime() - dosdate.getTime());
        var diffDays = Math.ceil((diff / (1000 * 3600 * 24)));
        ////console.log(diffDays)
        if (diffDays > 0) {
          var plannedvisits = (Math.abs((parseInt(visit) / 7) * diffDays)).toFixed()
          ////console.log(plannedvisits)
          this.pacdata.plannedVisit = plannedvisits;

        }
        else {
          this.pacdata.plannedVisit = "";
        }
      }
      else {
        this.pacdata.plannedVisit = "";
      }
    }
  }


  editpacsavedata(id) {
    this.patientservice.getvisitdetails(this.hospitalid)
      .subscribe(data => {
        this.visit = data.hospitalplannedvisitmastertable
        let index = _.findIndex(this.visit, (o: any): any => {
          return o.dischargetypeId == id
        })
        if (index != -1 && this.visit[index].plannedVisit) {
          this.editcalculateplanedvisit2(this.visit[index].plannedVisit)
        } else {
          this.showdata.plannedVisit = ""
          this.enabletextpacedit = false
        }
      })
  }

  editchangedate(data) {
    if (data == this.pother || data == this.carePath.pother) {
      data = '5'
    }
    if (data) {
      this.patientservice.getvisitdetails(this.hospitalid)
        .subscribe(data => {
          this.visit = data.hospitalplannedvisitmastertable
          let index = _.findIndex(this.visit, (o: any): any => {
            return o.dischargetypeId == data
          })
          if (index != -1 && this.visit[index].plannedVisit) {
            this.editcalculateplanedvisit2(this.visit[index].plannedVisit)
          } else {
            this.enabletextpacedit = false
          }
        })
    }
  }


  editcalculateplanedvisit2(visit) {
    if (this.showdata.plannedAdmissionDate && this.showdata.plannedDate) {
      this.enabletextpacedit = true;
      let event = this.showdata.plannedDate
      let eventdos = this.showdata.plannedAdmissionDate
      ////console.log("plan", event)
      ////console.log("dos", eventdos)
      if (event && eventdos) {
        var plandate = new Date(event)
        var dosdate = new Date(eventdos)
        var diff = Math.abs(plandate.getTime() - dosdate.getTime());
        var diffDays = Math.ceil((diff / (1000 * 3600 * 24)));
        ////console.log(diffDays)
        if (diffDays > 0) {
          var plannedvisits = (Math.abs((parseInt(visit) / 7) * diffDays)).toFixed()
          ////console.log(plannedvisits)
          this.showdata.plannedVisit = plannedvisits;

        }
        else {
          this.showdata.plannedVisit = "";
        }
      }
      else {
        this.showdata.plannedVisit = "";
      }
    }
  }
  GcpBeyond() {
    this.patientservice.GcpBe(this.userId)
      .subscribe(data => {
        this.gcpbeyond = data;
        ////console.log(this.gcpbeyond)
      })
  }

  schedulech(id) {
    if (id == '' || id == null || id == 'Invalid Date') {
      this.schedule = true
    } else {
      this.schedule = false
    }
  }

  schedulechs(id) {
    if (id == '' || id == null || id == 'Invalid Date') {
      this.schedule1 = true

    } else {
      this.schedule1 = false
    }
  }
  clo() {

    this.modalRef.hide();
    this.scheduledate = false;
    this.addnew = false;
    this.getAppoinmentsList(this.userId)
  }


  submitForm(emp) {
    ////console.log(emp);
    let self = this;
    self.patientservice.getPatientPassword(emp, self.currentUser.item.userAccountId).subscribe(data => {
      if (data.item.status == 'success') {
        self.userService.logAudit('getPassword', 0).subscribe(data => { })
        const credentials = {
          'username': data.item.uname,
          'password': data.item.pwd,
          'captcha': '',
          'mode': '',
          'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'c',
          'forcelogin': 'true',
          'officeUser': window.localStorage['officeUser'] ? window.localStorage['officeUser'] : self.currentUser.item.userAccountId,
          'switchPortal': 0
        }
        const ccdetails = {
          'ccnamefname': this.currentUser.item.firstName,
          'ccnamelname': this.currentUser.item.lastName,
          'cnusername': this.currentUser.item.email,
          'cnuseraccid': this.currentUser.item.userAccountId
        }
        if (!window.localStorage['ccdetails'])
          window.localStorage['ccdetails'] = btoa(JSON.stringify(ccdetails))
        this.loginAsPAtient(credentials, this.userId, self.currentUser.item.userAccountId)
      }
      else if (data.item.status == 'failure') {
        this.toast.toastrConfig.timeOut = 3000;
        this.toast.error(data.item.message);
      }
    })
  }

  loginAsPAtient(credentials, id, userId) {
    window.localStorage.removeItem('startdate');
    window.localStorage.removeItem('enddate');
    this.userService.attemptPatientAuth(credentials, id).subscribe(
      data => { },
      err => { }
    );
  }

  showselect() {
    this.reass = true;
  }
  loadCareList() {
    this.userService.getCareList(this.currentUser.item.userAccountKey, this.currentUser.item.userAccountId)
      .subscribe(
        data => {
          this.careList = data;
          this.lengthcn = this.careList.length
          if (this.currentUser.item.cnmappingct == 0 || this.currentUser.item.userAccountId == this.caremap) {
            this.selCare = 'ALL'
          } else {
            this.selCare = data.find(it => it.CNID == this.currentUser.item.userAccountId).CNID;
            this.currentUser.item.selectCNUserId = this.selCare;
          }
          this.selCare = ''
        }
      );
  }
  carenav(event, showassign: TemplateRef<any>) {
    this.reassign = {
      assignedTo: event,
      assignedFrom: this.patientservice.CN_id ? this.patientservice.CN_id : 0,
      patSWFId: this.userId,
      userAccId: this.currentUser.item.userAccountId,
      userAccountKey: this.currentUser.item.userAccountKey
    }

    this.modalRef1 = this.modalService.show(showassign, {
      class: 'modal-sm',
      backdrop: 'static'
    })
    this.movable()

  }
  yestoshow(mytodostatus) {
    this.reass = true;
    this.carePath.dos = ''
    this.patientservice
      .reassigncn(this.reassign)
      .subscribe(
        data => {
          if (data) {

            this.toast.toastrConfig.timeOut = 3000;
            this.toast.success(this.currentUser.item.userrole + " Reassigned successfully");
            this.userService.logAudit("Cn Reassign", 0).subscribe(data => { })
            this.initFunction();

            this.selpat = 'Reassign To'
          }

        }
      );
    this.modalRef1.hide();

  }

  notoshow() {
    this.selpat = 'Reassign To';
    this.selCare = '';
    this.modalRef1.hide();
    this.reass = false;
  }

  QualificationNoteslist() {

    this.patientservice
      .getQNotesList(this.user.bundleid)
      .subscribe(
        data => {
          this.Qnote = data.notes;

        }

      );
  }
  qstage() {
    this.patientservice
      .getStageQualificationDetails(this.currentUser.item.userGroupId)
      .subscribe(
        data => {
          this.qualification = data
          ////console.log(this.qualification)


        }

      );

  }

  reasonstage() {
    this.patientservice
      .getReasonCodeDetailsList()
      .subscribe(
        data => {
          this.reason = data;
        }

      );
  }
  statuss(value) {
    ////console.log(value)
    this.disresult = value
  }
  disqualifipatient(data) {
    let self = this
    if (this.patdisqualifi && this.bundleid) {
      if (!data.value.notes) {
        data.value.notes = ''
      }
      if (!data.value.other) {
        data.value.other = ''
      }
      let disqualifi = {
        bundlePatientId: this.bundleid,
        loginUserId: this.currentUser.item.userAccountId,
        notes: this.patdisqualifi.notes,
        qualificationId: this.patdisqualifi.qualificationId,
        reasonId: this.patdisqualifi.reasonId,
        reportToCCN: this.disresult,
        other: this.patdisqualifi.other,
        stageId: this.patdisqualifi.stageId
      }
      this.patientservice
        .postdisqualifi(disqualifi)
        .subscribe(
          data => {
            if (data) {
              this.toast.success(this.userService.translateText('hospital_portal.qualification_lst.patient_disqualified.success'), '', {
                timeOut: this.timealert
              })
              this.userService.logAudit('disQualifyPatient', 0).subscribe(data => { })
              this.close()
              // this.deletepatient(self.user.patientId, 'Patient Disqualified')
              self.nav.navigate(['/care/patientlist'],)
            }
            else {
              this.toast.error(this.userService.translateText('patient_portal.display_messages.invalid_data.error'), '', {
                timeOut: this.timealert
              })
            }
          }

        );
    }
  }
  deletepatient(patid, reason) {
    // alert(JSON.stringify(this.temppat));
    this.userService
      .getdeletepat(patid, reason, this.currentUser.item.userAccountId, '')
      .subscribe(
        data => {

        })
  }

  changestage(event) {
    if (event == 1) {
      this.patdisqualifi.qualificationId = 3
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 2) {
      this.patdisqualifi.qualificationId = 18
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 3) {
      this.patdisqualifi.qualificationId = 8
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 4) {
      this.patdisqualifi.qualificationId = 12
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 6) {
      this.patdisqualifi.qualificationId = 17
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    }

  }

  calculateplanedvisit(visit) {
    if (this.carePath.plannedAdmissionDate && this.carePath.plannedSnfDischargeDate) {
      this.enabletext = false;
      let event = this.carePath.plannedSnfDischargeDate
      let eventdos = this.carePath.plannedAdmissionDate
      ////console.log("plan", event)
      ////console.log("dos", eventdos)
      if (event && eventdos) {
        var plandate = new Date(event)
        var dosdate = new Date(eventdos)
        var diff = Math.abs(plandate.getTime() - dosdate.getTime());
        var diffDays = Math.ceil((diff / (1000 * 3600 * 24)));
        ////console.log(diffDays)
        if (diffDays > 0) {
          var plannedvisits = (Math.abs((parseInt(visit) / 7) * diffDays)).toFixed()
          ////console.log(plannedvisits)
          this.carePath.plannedVisit = plannedvisits;
          //this.carePath.actualVisit = this.actualvisits
          ////console.log(this.carePath.actualVisit)
        }
        else {
          this.carePath.plannedVisit = "";
        }
      }
      else {
        this.carePath.plannedVisit = "";
      }
    }
  }









































  /*********** NEEDED CODE**************** */

  /**** Calling on DOS Change function ****/


  configPlannedIntervalData: any;
  checkconfiguredate() {
    let self = this
    this.configuredate = 5
    this.patientservice.getPlannedDischargeDate(self.userId)
      .subscribe(data => {
        this.configPlannedIntervalData = data;
        /*  if (data.confPlannedFacilityDischargeDate) {
          this.configuredate = parseInt(data.confPlannedFacilityDischargeDate)
        } */
      })
    ////console.log(this.configuredate)
  }


  getPlannedDayInterval(dischargeTypeId) {
    if (dischargeTypeId != -1) {
      for (var item of this.configPlannedIntervalData) {
        if (item.dischargeTypeId == dischargeTypeId)
          return item.facilityDischargeDayInterval;
      }
      if (dischargeTypeId == 6 || dischargeTypeId == 9)
        return 1;
      else
        return 5;

    } else {
      if (isNaN(this.dayinterval)) {
        return 3
      }
      return this.dayinterval;
    }
  }



  DOSChangeDate: any;
  textTemplate15: any;
  SetPDosStatus(event, template15) {

    this.textTemplate15 = false;



    if (event) {
      let self = this;
      let date = this.Datepipe.transform(event, this.dateform);

      var dateStr = this.changeStringFormat2(event);
      this.DOSChangeDate = dateStr;

      if (date) {

        this.saveBtnEnable = false;
        this.createPACEventbtn = false;

        /* New Code */
        this.enablepatient = false;

        let toDate = new Date();
        toDate.setDate(toDate.getDate() - 1);

        this.getpatientdetails(self.user.patientId, date)


        let Dos = new Date(date);

        if (toDate.getTime() <= Dos.getTime()) {
          self.dosStatus = "future"
          //self.carePath.actualDischargeId = ""
          self.checkplannedDisabled(Dos);
        }
        if (toDate.getTime() > Dos.getTime()) {
          self.dosStatus = "past"
          for (var itractionObj of this.PACEventsData) {
            if (this.dosStatus == 'past' && itractionObj.hospitalStay && itractionObj.actualDischargeDate) {
              itractionObj.actualDischargeDate = ''
              itractionObj.pacFinished = false
              itractionObj.trackActualVisible = false
            }
          }
          //self.carePath.plannedDischargeId = ""
        }
        if (self.carePath.dos != self.careSPath.dos) {
          this.countone = 4
        }
        if (self.countone > 3 || !self.carePath.plannedDischargeDate) {
          if (self.carePath.dos != self.careSPath.dos) {
            self.counttwo2 = 1
          }
          self.setDOSPlannedDate(event, template15)
        }

        //this.saveBtnEnable = false;

      } else {
        self.dosStatus = 'notSelected'
      }

      if (this.PACEventsData.length <= 0)
        this.createPACEventbtn = true;

    }
    else {

      /* New Code */
      this.enablepatient = true;
      this.saveBtnEnable = true;
      this.createPACEventbtn = true;
    }
    /* if(!self.actualCategory){
      self.enableactualTom(event)
    } */


    /*  this.carePath.dos =date.toString();
        alert(this.carePath.dos);   */



    if (this.PACEventsData.length > 0) {
      this.onDOSChangePacEventValidate();
      this.onTopDOSDateChange();
    }
    var dosfuture;
    for (var item of this.PACEventsData) {
      if (item.hospitalStay) {
        item.anonymousSnfDischargeDate = new Date(item.anonymousSnfDischargeDate)
        if (item.trackActualVisible && item.pacFinished && this.carePath.dos.setHours(0, 0, 0, 0) > item.anonymousSnfDischargeDate.setHours(0, 0, 0, 0)) {
          this.textTemplate15 = true

        }
      }
    }

  }



  onChangeObj(id, templateother, planned) {
    let self = this
    self.planned = planned
    self.carePath.plannedLos = ''
    this.dispalnid = id;
    if (id) {
      self.calculatePlanedLos(self.carePath.plannedSnfDischargeDate, self.carePath.plannedAdmissionDate);
    }
    else {
      self.carePath.plannedLos = ""
    }
    if (id != '5') {
      this.carePath.pother = ''
    }
    if (id == "1" || id == "4" || id == "2" || id == "3" || id == "6" || id == "5") {


      if (this.carePath.plannedSnfDischargeDate) {
        this.planDisable = false;
        this.enableagency = false;
        this.carePath.plannedDischargeHospitalId = "";
      }
      if (id == "5") {
        this.openModelpop1(templateother, null)
      }
      if (id == '1' || id == '4') {
        let index = _.findIndex(this.carePath.dischargehospitalList, (o: any): any => {
          return (o.dischargeTo == "*Unspecified" && o.dischargeType == id)
        })
        this.carePath.plannedDischargeHospitalId = this.carePath.dischargehospitalList[index].dischargeId
      }
    }
    if (id == "7" || id == "") {

      if (this.carePath.plannedSnfDischargeDate) {
        this.planDisable = true;
        this.enableagency = true;
        if (id == "7") {
          let index = _.findIndex(this.carePath.dischargehospitalList, (o: any): any => {
            return o.dischargeType == id
          })
          if (index != -1)
            this.carePath.plannedDischargeHospitalId = this.carePath.dischargehospitalList[index].dischargeId;
        }


      }
    }
    this.patientservice.getvisitdetails(this.hospitalid)
      .subscribe(data => {
        this.visit = data.hospitalplannedvisitmastertable
        let index = _.findIndex(this.visit, (o: any): any => {
          return o.dischargetypeId == id
        })
        if (index != -1 && this.visit[index].plannedVisit) {
          this.calculateplanedvisit(this.visit[index].plannedVisit)
        } else {
          this.enabletext = true
          this.carePath.plannedVisit = ''
          this.enableactual = false
        }
      })

  }



  savePacEventAction(autoAdjustId) {
    this.autoadjustpopup(autoAdjustId);
  }



  autoadjustTemplate: any;
  deleteEmptyTemplate: any;
  endDateEmptyTemplate: any;
  preSavePACKEvent(autoadjust, deleteEmpty, endDateEmpty) {
    this.saveBtnClick = false
    if (this.dosstatus) {
      this.dosstatus = ''
      this.paramsdos = ''
    }
    if (this.textTemplate15) {
      return this.ngOnInit();
    }
    // for(var item of this.PACEventsData)
    // {
    //   item.anonymousSnfDischargeDate = new Date(item.anonymousSnfDischargeDate)
    //   if(item.pacFinished && this.carePath.dos.setHours(0,0,0,0) > item.anonymousSnfDischargeDate.setHours(0,0,0,0) && item.hospitalStay){
    //     this.createPACEventbtn = true;
    //   }
    // }
    // if(this.createPACEventbtn){
    //   this.PACEventsData = []
    // }
    if (this.PACEventsData.length == 0) {
      /*  setTimeout(() => { */

      this.dosChangeAPIService();

      /* },1000); */

    } else {
      this.deleteEmptyTemplate = deleteEmpty;
      this.autoadjustTemplate = autoadjust;
      this.endDateEmptyTemplate = endDateEmpty;
      this.tempPacEventData = JSON.parse(JSON.stringify(this.PACEventsData));
      var postEventDataTem = this.saveResultProcessing(this.tempPacEventData);
      let postEventData = this.assessments;
      postEventData[0]['dbCpDetailsList'] = postEventDataTem;
      postEventData[0]['dos'] = this.getDOSDate();
      postEventData[0]['hospitalStayStatus'] = this.getIsHosStayPlanORActu();
      postEventData[0]['pswActualDischargeDate'] = this.getDischargeDate();
      postEventData[0]['superClientId'] = window.localStorage['superClientId'] ? window.localStorage['superClientId'] : this.currentUser.item.userAccountId;
      var futuredate
      for (var itractionObj of this.PACEventsData) {
        if (!this.checkFutureDate(itractionObj)) {
          futuredate = true
          break;
        }
        else {
          futuredate = false
        }
      }
      if (!futuredate)
        this.saveAPIService(postEventData, "preSave", false);
      else {
        this.toast.error("We can't process with future date", '', {
          timeOut: this.timealert
        })

        return "";
      }

    }

  }

  isNonOp: boolean = false;
  dosChangeAPIService() {
    this.isNonOp = true;
    this.tempPacEventData = JSON.parse(JSON.stringify(this.PACEventsData));
    var postEventDataTem = this.saveResultProcessing(this.tempPacEventData);
    let postEventData = this.assessments;
    postEventData[0]['dbCpDetailsList'] = postEventDataTem;
    postEventData[0]['superClientId'] = window.localStorage['superClientId'] ? window.localStorage['superClientId'] : this.currentUser.item.userAccountId;
    this.saveAPIService(postEventData, "normal", false);
  }




  getIsHosStayPlanORActu() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay && item.status == "InProgress")
        return this.userService.translateText('hospital_portal.patientls.current.option');
      else if (item.hospitalStay && item.status == "Completed")
        return this.userService.translateText('hospital_portal.mytodos.completed.label');
    }
  }

  getDOSDate() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay) {
        var dateStr = this.changeStringFormat2(this.carePath.dos);
        return dateStr;
      }
    }
    return "";
  }

  getDischargeDate() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay && item.pacFinished) {
        var dateStr = this.changeStringFormat2(item.anonymousSnfDischargeDate);
        return dateStr;
      }
    }
    return "";
  }

  getAppliedDischargeDate() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay && item.trackActualVisible && item.pacFinished)
        return item.anonymousSnfDischargeDate;
    }
    return "";
  }

  getAppliedPlannedDischargeDate() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay)
        return item.plannedDdCpDetails.plannedSnfDischargeDate;
    }
    return "";
  }

  isDishargeCompleted() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay && item.trackActualVisible && item.pacFinished)
        return true;
    }

    return false;
  }


  openModel2(autoAdjust) {
    /* let self = this;
    this.ModelRef = self.Modalservice.show(confirm, { class: 'modal-sm small', backdrop: 'static' })
    if (this.enabledPlanned && this.carePath.plannedDischargeId == '') {
      this.patientservice.GcpBe(this.userId)
        .subscribe(data => {
          this.gcpbeyond = data[0].status;
          ////console.log(this.gcpbeyond)
          if (this.gcpbeyond == "false") {
            this.textenable = false
          } else {
            this.textenable = true
          }
        })
    }
    else {
      this.textenable = false
    }
    this.enablepatient = true */

    // this.saveAllEventList();

    /* alert("Calling Here"); */
    this.autoadjustpopup(autoAdjust);

  }

  saveModelPopUp: any;
  bottomSaveConfirmation(confirm) {
    this.saveModelPopUp = this.Modalservice.show(confirm, { class: 'modal-sm small', backdrop: 'static' });
    this.movable()
  }


  getMytodos() {
    let self = this;
    let startdate, enddate;
    startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
    this.startdate = startdate
    this.enddate = enddate
    self.patientservice.getMyTodoList(self.userId, this.currentUser.item.appRoles, this.mytodostatus, startdate, enddate, this.currentUser.item.userAccountKey, this.currentUser.item.userAccountId)
      .subscribe(data => {
        self.myTodos = data
        let index = _.findIndex(self.myTodos, (o: any): any => {
          return o.categoryName == "Generate Care Plan"
        })

        if (index != -1) {
          this.showpac = true
          if (self.myTodos[index].todoOverallCompletedStatus == 'P')
            this.gcpnew = true
          else
            this.gcpnew = false
        } else {
          this.showpac = false
        }

        let indexs = _.findIndex(self.myTodos, (o: any): any => {
          return o.categoryName == "Track Hospital Discharge"
        })

        if (indexs != -1) {
          this.showthd = true
        } else {
          this.showthd = false
        }




        self.checkplanedActual(data)
        let enable = _.findIndex(data, (o: any): any => {
          return o.categoryId == "4"
        })
        let enablepat = _.findIndex(data, (o: any): any => {
          return (o.categoryId == "10")
        })
        if (enable != -1) {
          let last: number = data[enable].toDoCarePlanSurveyList.length - 1
          this.ennable = last
          self.myTodosLast = data[enable].toDoCarePlanSurveyList[last]
          //let ennable = data[enable].toDoCarePlanSurveyList.length
          this.ennable = _.findIndex(data[enable].toDoCarePlanSurveyList, (o: any): any => {
            return o == data[enable].toDoCarePlanSurveyList[last]
          })

          data[enable].toDoCarePlanSurveyList = _.reject(data[enable].toDoCarePlanSurveyList, (o: any): any => {
            return o == data[enable].toDoCarePlanSurveyList[last]
          })



        }
        /* if(enablepat != -1){
          let last:number = data[enablepat].toDoCarePlanSurveyList.length -1
          this.ennable = last
          self.myTodosLast = data[enablepat].toDoCarePlanSurveyList[last]
          //let ennable = data[enable].toDoCarePlanSurveyList.length
          this.ennable  = _.findIndex(data[enablepat].toDoCarePlanSurveyList,(o:any):any=>{
            return o == data[enablepat].toDoCarePlanSurveyList[last]
          })

          data[enablepat].toDoCarePlanSurveyList = _.reject(data[enablepat].toDoCarePlanSurveyList,(o:any):any=>{
            return o == data[enablepat].toDoCarePlanSurveyList[last]
          })



        } */

        if (enablepat != -1) {
          let lastpat: number = data[enablepat].toDoCarePlanSurveyList.length - 1
          this.ennablepat = lastpat
          self.myTodosLastpat = data[enablepat].toDoCarePlanSurveyList[lastpat]
          //let ennable = data[enable].toDoCarePlanSurveyList.length
          this.ennablepat = _.findIndex(data[enablepat].toDoCarePlanSurveyList, (o: any): any => {
            return o == data[enablepat].toDoCarePlanSurveyList[lastpat]
          })

          data[enablepat].toDoCarePlanSurveyList = _.reject(data[enablepat].toDoCarePlanSurveyList, (o: any): any => {
            return o == data[enablepat].toDoCarePlanSurveyList[lastpat]
          })



        }
        self.myTodos = data
        // this.patientservice
        //   .getmytodolist(this.currentUser.item.userAccountId)
        //   .subscribe(
        //     data => {
        //       //this.temp_var=true;
        //       this.mytodo = data;
        //       this.currentUser.item.mytodolength = this.mytodo.length

        //     }
        //   );

        const obj = {
          "loginUaId": this.currentUser.item.userAccountId,
          "selectedCnUaId": this.patientservice.CN_id,
          "patientSwfId": '',
          "startDateRange": 'N',
          "endDateRange": 'N',
          "pracOrHsp": '',
          "todoViewMode": "",
          "loginHspOrPracId": '',
          "todoCategoryId": '',
          'raHospitalIsOverlap': "",
          'raSurgeonIsOverlap': "",
          "raSurgeonIds": '',
          "raHospitalIds": '',
        }

        this.patientservice.getCountDetailsRaTodoOverLapFilter(obj)
          .subscribe(
            data => {
              this.currentUser.item.mytodolength = data.todoCount
              this.currentUser.item.msgcount = data.messageCount;
            }
          );
      })
  }

  calculateplanedvisitNew(visit, item) {


    //alert(visit+"--------------"+JSON.stringify(item));

    if (visit == 0) {
      item.plannedDdCpDetails.plannedVisit = 0;
      item.anonymousVisit = 0;
    } else {
      if (item.plannedDdCpDetails.plannedAdmissionDate && item.plannedDdCpDetails.plannedSnfDischargeDate) {
        this.enabletext = false;
        let event = item.plannedDdCpDetails.plannedSnfDischargeDate
        let eventdos = item.plannedDdCpDetails.plannedAdmissionDate


        //////console.log("plan", event)
        //////console.log("dos", eventdos)

        if (event && eventdos) {
          var plandate = new Date(event)
          var dosdate = new Date(eventdos)
          var diff = Math.abs(plandate.getTime() - dosdate.getTime());
          var diffDays = Math.ceil((diff / (1000 * 3600 * 24)));
          //////console.log(diffDays)




          if (diffDays > 0) {
            var plannedvisits = (Math.abs((parseInt(visit) / 7) * diffDays)).toFixed()
            //////console.log(plannedvisits)
            item.plannedDdCpDetails.plannedVisit = plannedvisits;
            item.anonymousVisit = plannedvisits;
            //this.carePath.actualVisit = this.actualvisits
            //////console.log(this.carePath.actualVisit)
          }
          else {
            item.anonymousVisit.plannedVisit = "";
          }
        }
        else {
          item.anonymousVisit.plannedVisit = "";
        }
      }
    }
  }
  getpatientdetails(patientId, date) {
    let self = this;
    this.patientservice.getpatientdetails(patientId)
      .subscribe(
        data => {
          this.mindos = new Date(data[0].dob)
          let dob = this.mindos.getTime();
          let bDos = new Date(date);
          bDos.setDate(bDos.getDate() + 1)
          if (dob > bDos.getTime()) {
            self.toast.error(this.userService.translateText('hospital_portal.add_patient.dos_less_then_dob.error'), '', {
              timeOut: this.timealert
            });
            return;
          }
        })
  }
  SetDosStatus(event) {
    if (event) {
      let self = this;
      let date = this.Datepipe.transform(event, this.dateform);
      if (date) {
        let toDate = new Date();
        toDate.setDate(toDate.getDate() - 1);
        this.getpatientdetails(self.user.patientId, date)

        let Dos = new Date(date);
        if (toDate.getTime() <= Dos.getTime()) {
          self.dosStatus = "future"
        }
        if (toDate.getTime() > Dos.getTime()) {
          self.dosStatus = "past"
          //self.carePath.plannedDischargeId = ""
        }
      } else {
        self.dosStatus = 'notSelected'
      }

    }
    /* if(!self.actualCategory){
      self.enableactualTom(event)
    } */
  }


  pOtherInputDataTemplateJSON: any = {
    agencyName: ""
  }
  submitplannedother(item) {

    this.patientservice.showpopother(this.currentUser.item.userAccountKey, this.facilityTempObj.anonymousDischargeId, this.carePath.plannedDischargeTypeForOther)
      .subscribe(data => {
        if (data.status) {
          this.userService.logAudit('savePlannedOtherFacilty', 0).subscribe(data => { })
          this.ModelRef.hide();
          this.facilityTempObj.anonymousDischargeHospitalMasterId = data.dischargeHspMastId;
          if (!this.facilityTempObj.trackActualVisible)
            this.facilityTempObj.plannedDdCpDetails.plannedDischargeHospitalMasterId = data.dischargeHspMastId;
          this.fetchDischargeList();
          this.doCompleteEvent(this.facilityTempObj);
        }
        else {

          this.toast.error(this.userService.translateText('patient_portal.display_messages.something_went_wrong'), '', {
            timeOut: this.timealert
          })
          this.ModelRef.hide();

          this.carePath.plannedDischargeTypeForOther = ""
          this.doCompleteEvent(this.facilityTempObj);
        }
      });

    /* alert("Calling Here" + this.carePath.plannedDischargeTypeForOther); */


  }

  getUserDetails() {


    let self = this;
    this.patientservice
      .getuserdetails(self.userId, self.uid)
      .subscribe(
        data => {


          //alert("Calling Here" +  data[0]);

          //alert("Calling Here");
          if (Array.isArray(data) && data.length) {
            self.user = data[0]

            if (!self.user.pswIsActive) {
              self.user.patientStatus = "Deactivate";
            } else {
              window.localStorage['activepswfid'] = btoa(self.userId)
            }
            self.getPatientSWFHistory(self.user.patientId, self.userId);

            window.localStorage['patDob'] = self.user.dob
            //alert(JSON.stringify(data));
            /*  self.carePath.caseManager = self.user.caseManager;
              alert("Calling Here");
             alert(self.carePath.caseManager); */

            ////console.log("user", self.user)

            // if(window.localStorage['patientId']){
            //   window.localStorage.removeItem('patientId')
            //  }
            //window.localStorage['patientId'] = self.user.patientId;
            this.patientservice
              .getpatientdetails(self.user.patientId)
              .subscribe(
                data => {
                  //alert(JSON.stringify(data))
                  this.showwelcom = data;
                  this.mindos = new Date(data[0].dob)
                  this.showloader = true;
                })
          }

          /**  If DOS is not empty Save Button is eanblae */

          //alert(self.carePath.dos)
          if (self.user.dos != "") {
            this.saveBtnEnable = false;
            this.createPACEventbtn = false;

            /* New Code */
            this.enablepatient = false;

            //this.carePath.dos = new Date(self.user.dos)
            var tmpdateStr = this.changeStringFormat2(self.user.dos);
            this.DOSChangeDate = tmpdateStr;
          }
          else {
            this.saveBtnEnable = true;
            this.createPACEventbtn = true;

            /* New Code */
            this.enablepatient = true;
          }


          self.patientservice.getpatientinfo(self.user.patientId, self.user.patientSWFId)
            .subscribe(data => {

              if (Array.isArray(data) && data.length) {
                self.user.serviceLineLaterality = data[0].serviceLineLaterality
                self.user.mako = data[0].mako
                self.user.dob = data[0].Dob
                self.user.commercial = data[0].commercialPatient
                self.user.archived = data[0].archived
                self.user.bundleid = data[0].bundlePatientId
                self.user.stageId = data[0].stageId
                self.user.qualificationId = data[0].qualificationId
                self.user.payorName = data[0].payorName
                self.user.plans = data[0].plans
                self.user.TSS = data[0].TSS
                ////console.log(self.user.bundleid)
                if (self.user.pswClientType)
                  self.payorType = self.user.pswClientType
                else if (data[0].PayorType == 1)
                  self.payorType = 'Commercial'
                // else if (data[0].PayorType == 2 && this.currentUser.item.clientType == 'BPCIA')
                else if (data[0].PayorType == 2 && this.currentUser.item.clientType.search("BPCIA") != -1)
                  self.payorType = 'BPCI-A'
                //else if (data[0].PayorType == 2 && this.currentUser.item.clientType == 'PRO_ONLY')
                else if (data[0].PayorType == 2 && this.currentUser.item.clientType.search("PRO_ONLY") != -1 && data[0].patientCjr)
                  self.payorType = 'CJR'
                else
                  self.payorType = ''
                self.user.payor = data[0].PayorType
                self.user.archived = data[0].archived
              }
              self.QualificationNoteslist()
              self.getCarepathDetails()
            })
          self.showExportSurvey()
        })
  }


  //Patient SWF History for Deactivate
  patientHistoryList: any;
  getPatientSWFHistory(patientId, pswIsActive) {
    this.patientservice.getPatientSWFHistory(patientId, pswIsActive)
      .subscribe(data => {
        this.patientHistoryList = data;
      })
  }

  otherpacplan(carepath, planned) {

    /* let index = _.findIndex(this.otherpac, (o: any): any => {
      return o.hospitalOtherPacMapId == this.carePath.otherplannedDischargeId
    })
    if (index != -1) {
      this.carePath.otherPacMasterId = this.otherpac[index].otherPacMasterId
      this.carePath.other = this.otherpac[index].hospitalOtherPacMapName
      ////console.log(this.carePath.other)
    } */

    let telecode

    if (this.carePath.dcode)
      telecode = this.carePath.dcode.split(',')


    if (!this.careSPath.dos) {
      this.pacstatus = ''
    }

    /* let pacmasterid;
    if (this.pacstatus == 'UpComing') {
      pacmasterid = this.patientpacmasterid
    }
    else {
      pacmasterid = ''
    } */


    if (this.eventOtherTembItem.trackActualVisible) {



      this.eventOtherTembItem.anonymousOtherSelectedName = this.carePath.dname;
      this.eventOtherTembItem.anonymousOtherFreeText = this.carePath.otherPacMasterId == '4' ? this.carePath.dname : '';
      this.eventOtherTembItem.anonymousOtherPacContact = this.carePath.dContact ? this.carePath.dContact : "";
      this.eventOtherTembItem.anonymousHospitalOtherPacMapId = this.carePath.otherplannedDischargeId;
      this.eventOtherTembItem.anonymousOtherPacMasterId = this.carePath.otherPacMasterId ? this.carePath.otherPacMasterId : 0;
      this.eventOtherTembItem.anonymousOtherPacPhone = this.carePath.dPhone ? this.carePath.dPhone : "";
      this.eventOtherTembItem.anonymousOtherPacTeleCode = telecode[0];
      this.eventOtherTembItem.anonymousOtherPacTeleCountryCode = telecode[1];
      this.eventOtherTembItem.anonymousOtherPacTurnedOn = this.carePath.disablepac;




      //  this.aother = this.carePath.other
      if (this.carePath.disablepac || this.carePath.otherPacMasterId == 3)
        this.eventOtherTembItem.anonymousOtherPacTurnedOn = false
      else
        this.eventOtherTembItem.anonymousOtherPacTurnedOn = true
    }
    else {

      this.eventOtherTembItem.plannedDdCpDetails.plannedOtherSelectedName = this.carePath.dname;
      this.eventOtherTembItem.plannedDdCpDetails.plannedOtherFreeText = this.carePath.otherPacMasterId == '4' ? this.carePath.dname : '';
      this.eventOtherTembItem.plannedDdCpDetails.plannedOtherPacContact = this.carePath.dContact ? this.carePath.dContact : "";
      this.eventOtherTembItem.plannedDdCpDetails.plannedHospitalOtherPacMapId = this.carePath.otherplannedDischargeId;
      this.eventOtherTembItem.plannedDdCpDetails.plannedOtherPacMasterId = this.carePath.otherPacMasterId ? this.carePath.otherPacMasterId : 0;
      this.eventOtherTembItem.plannedDdCpDetails.plannedOtherPacPhone = this.carePath.dPhone ? this.carePath.dPhone : "";
      this.eventOtherTembItem.plannedDdCpDetails.plannedOtherPacTeleCode = telecode[0];
      this.eventOtherTembItem.plannedDdCpDetails.plannedOtherPacTeleCountryCode = telecode[1];
      this.eventOtherTembItem.plannedDdCpDetails.plannedOtherPacTurnedOn = this.carePath.disablepac;



      /*  if (this.pacstatus == 'UpComing') {
         this.pother = this.carePath.other
       } else {
         this.PACEventsData[this.selectionIndex].anonymousOtherSelectedName = this.carePath.other
       } */


      if (this.carePath.disablepac || this.carePath.otherPacMasterId == 3)
        this.eventOtherTembItem.plannedDdCpDetails.plannedOtherPacTurnedOn = false
      else
        this.eventOtherTembItem.plannedDdCpDetails.plannedOtherPacTurnedOn = true

    }

    /*  if (this.eventOtherTembItem.trackActualVisible && this.eventOtherTembItem.pacFinished)
      this.eventOtherTembItem.anonymousOtherSelectedName = this.carePath.dname;
     else
      this.eventOtherTembItem.plannedDdCpDetails.plannedOtherSelectedName = this.carePath.dname; */


    this.eventOtherTembItem.anonymousDischargeId = -2;
    this.contactDetailsEnable(this.eventOtherTembItem);



    /** 06/05/2019  Clear All Other fields Start Here **/

    this.carePath.dname = "";
    this.carePath.dContact = "";
    //this.carePath.otherplannedDischargeId;
    //this.eventOtherTembItem.patientPacMasterMapId;
    this.carePath.dPhone = "";
    if (this.currentUser.item.language != 'en_uk') {
      this.carePath.dcode = '+1,USA'

    } else if (this.currentUser.item.language == 'en_uk') {
      this.carePath.dcode = '+44,UK'
    }
    if (this.currentUser.item.clientTeleCode)
      this.carePath.dcode = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
    //this.carePath.disablepac;

    /** 06/05/2019  Clear All Other fields End Here **/


    /* this.patientservice.savepactype(data)
      .subscribe(data => {
        if (data)
        {

          this.toast.success("Other PAC Added Successfully", '', {
            timeOut: this.timealert
          })
         }else
        {
          this.eventOtherTembItem.anonymousDischargeId ="";
          this.eventOtherTembItem.anonymousDischargeHospitalMasterId ="";
        }

      }) */





    /* this.patientservice.getCarePlanDetails(this.userId, this.uid)
       .subscribe(data => {
         let self = this;
         if (data[0].dischargePhone) {
           let x = data[0].dischargePhone.split("");
           let y = []
           let k = []
           let m = []
           for (var i = 0; i < 3; i++) {
             y[i] = x[i]

           }
           for (var j = 3; j < 6; j++) {
             k[j] = x[j]
           }
           for (var l = 6; l < x.length; l++) {
             m[l] = x[l]
           }
           self.carePath.dischargePhone = '(' + y.join('') + ') ' + k.join('') + '-' + m.join('')
         }
         this.carePath.dischargeContact = data[0].dischargeContact
       }) */


    // this.carePath.dname = ""
    // this.carePath.dPhone = ""
    // this.carePath.dContact = ""
    // this.carePath.otherplannedDischargeId = ""
    // this.carePath.disablepac = ""

    /* if (this.PACEventsData[this.selectionIndex].anonymousOtherSelectedName) {
          this.PACEventsData[this.selectionIndex].anonymousDischargeId = this.PACEventsData[this.selectionIndex].anonymousOtherSelectedName;
          this.PACEventsData[this.selectionIndex].plannedDdCpDetails.plannedDischargeId = this.PACEventsData[this.selectionIndex].anonymousOtherSelectedName;
          this.carePath.pother = this.PACEventsData[this.selectionIndex].anonymousDischargeId
    } if (this.aother) {
      this.carePath.actualDischargeId = this.aother
    } if (this.pother) {
      this.pacdata.plannedDischargeId = this.pother
    }*/

    /* ////console.log('carepathother:' + this.carePath.pother)
    ////console.log('carepathaother:' + this.aother) */
    this.ModelRef.hide()
  }

  /***********   Multi PAC EVENT NEW TEMPLATE START HERE  *************/
  // PACEventsData: any[];

  //DOSDate: any = "03/03/2019";
  PACEventsData: any = [];
  // PACEventsData: any =[{
  //   "patientPacMasterMapId": 16220,
  //   "id": 1,
  //   "caseManager": "John Peterson",
  //   "dos": "03/10/2019",
  //   "status": "InProgress",
  //   "serverdata": true,
  //   "hospitalName":"Princeton Community Hospital",
  //   "anonymousDischargeDate": "",
  //   "anonymousSnfDischargeDate": "",
  //   "anonymousDischargeId": "7",
  //   "anonymousDischargeHospitalMasterId": "",
  //   "anonymousDischargePhone": "",
  //   "anonymousDischargeTeleCode": "",
  //   "anonymousDischargeTeleCountryCode": "",
  //   "anonymousDischargeLocContact": "",
  //   "anonymousLos": 3,
  //   "dischargeTo": "",
  //   "dischargeType": "",
  //   "patientDbScore": null,
  //   "dischargeTypeList": null,
  //   "dischargeTypeDetails": null,
  //   "dischargehospitalList": null,
  //   "anonymousAdmissionDate": "",
  //   "anonymousVisit": "",
  //   "anonymousOtherSelectedName": "",
  //   "anonymousDischargeTypeForOther": null,
  //   "plannedDdCpDetails": {
  //     "patientPacMasterMapId": 16220,
  //     "plannedDischargeDate": "01/28/2019",
  //     "plannedSnfDischargeDate": "02/02/2019",
  //     "plannedDischargeId": "",
  //     "plannedDischargeHospitalMasterId": "",
  //     "plannedLos": 3,
  //     "plannedAdmissionDate": "",
  //     "plannedVisit": "",
  //     "plannedOtherSelectedName": "",
  //     "plannedDischargeTypeForOther": null,
  //     "status": "Planned"
  //   },
  //   "trackActualVisible": false,
  //   "tab": true,
  //   "hospitalStay": true,
  //   "autoSortDateValid": false,
  //   "anonymousAdmissionDatemindate":null,
  //   "anonymousAdmissionDatemaxdate":null,
  //   "anonymousSnfDischargeDatemindate":null,
  //   "anonymousSnfDischargeDatemaxdate":null,
  //   "eventTypeRedAlert":false,
  //   "facilitynameRedAlert":false,
  //   "startdateRedAlert":false,
  //   "enddateRedAlert":false
  // }];

  /*  PACEventsData: any =[
          {
            "patientPacMasterMapId": 14392,
            "id": 1,
            "caseManager": "Elizabath Carolin",
            "dos": "02/28/2019",
            "status": "InProgress",
            "anonymousDischargeDate": "",
            "anonymousSnfDischargeDate": "",
            "anonymousDischargeId": 7,
            "anonymousDischargeHospitalMasterId": "",
            "anonymousDischargePhone": "",
            "anonymousDischargeTeleCode": "",
            "anonymousDischargeTeleCountryCode": "",
            "anonymousAdmissionDatemindate":new Date('2019/03/28'),
            "anonymousAdmissionDatemaxdate":new Date('2019/04/28'),
            "anonymousSnfDischargeDatemindate":new Date('2019/03/28'),
            "anonymousSnfDischargeDatemaxdate":new Date('2019/04/28'),
            "dischargeContact": "",
            "anonymousLos": 3,
            "dischargeTo": "",
            "dischargeType": "",
            "patientDbScore": null,
            "dischargeTypeDetails": null,
            "anonymousAdmissionDate": "",
            "anonymousVisit": "",
            "anonymousOtherSelectedName": "",
            "hospitalStay":true,
            "hospitalName":"Princeton Community Hospital",
            "serverdata":true,
            "plannedDdCpDetails": {
              "patientPacMasterMapId": 16678,
              "plannedDischargeDate": "03/03/2019",
              "plannedSnfDischargeDate": "03/06/2019",
              "plannedDischargeId": "1",
              "plannedDischargeHospitalId": "256",
              "plannedLos": "",
              "plannedAdmissionDate": "03/09/2019",
              "plannedVisit": "",
              "plannedOtherSelectedName": "",
              'Status': 'Planned'
            },
            "trackActualVisible": false,
            "tab": true
          }
    ] */


  /* PACEventsData: any =[{
    "patientPacMasterMapId": 12793,
    "id": 1,
    "caseManager": "John Peterson",
    "dos": "01/25/2019",
    "status": "InProgress",
    "serverdata": true,
    "hospitalName": "",
    "anonymousDischargeDate": "01/28/2019",
    "anonymousSnfDischargeDate": "",
    "anonymousDischargeId": "",
    "anonymousDischargeHospitalMasterId": "",
    "anonymousDischargePhone": "",
    "anonymousDischargeTeleCode": "",
    "anonymousDischargeTeleCountryCode": "",
    "anonymousDischargeLocContact": "",
    "anonymousLos": 0,
    "dischargeTo": "",
    "dischargeType": "",
    "patientDbScore": null,
    "dischargeTypeList": null,
    "dischargeTypeDetails": null,
    "dischargehospitalList": null,
    "anonymousAdmissionDate": "01/28/2019",
    "anonymousVisit": "",
    "anonymousOtherSelectedName": "",
    "anonymousDischargeTypeForOther": null,
    "plannedDdCpDetail": {
      "patientPacMasterMapId": 12793,
      "plannedDischargeDate": "01/28/2019",
      "plannedSnfDischargeDate": "02/02/2019",
      "plannedDischargeId": "",
      "plannedDischargeHospitalMasterId": "",
      "plannedLos": 5,
      "plannedAdmissionDate": "01/28/2019",
      "plannedVisit": "",
      "plannedOtherSelectedName": "",
      "plannedDischargeTypeForOther": null,
      "status": "Planned"
    },
    "trackActualVisible": false,
    "tab": true,
    "hospitalStay": false,
    "autoSortDateValid": false
  }] */



  configEventType: any;    //=[{vistConfig : 1},{visitConfig : 2}]
  trackAcutualCompleted: boolean = false;

  configureEventTypeFetch() {
    this.patientservice.configureEventTypeFetch(this.currentUser.item.userAccountKey)
      .subscribe(data => {

        this.configEventType = data;

        //alert(JSON.stringify(this.configEventType));
        //alert(JSON.stringify(this.configEventType));

      })
  }

  selectionItemNoOfVisit: any;
  checkConfigureEventType(eventTypeID) {

    ////console.log("----------"+JSON.stringify(this.configEventType) +"-----------"+eventTypeID);
    if (this.configEventType) {
      for (let child of this.configEventType) {
        if (child.dischargeTypeId == eventTypeID) {
          this.selectionItemNoOfVisit = child.noOfVisit;
          return true;
        }
      }
      return false;
    }
  }



  autoAdjustSelected: boolean = true;
  manualAutoAdjust(autoAdjustId) {

    if (this.autoAdjustSelected) {
      this.autoAdjustSelected = false;
      this.autoAdjustService();
      this.autoadjustpopup(autoAdjustId);
    }
    else {
      this.autoAdjustSelected = true
      // this.manualService();
    }
  }

  tempPacEventData: any = [];
  autoAdjustService() {

    this.modalRef1.hide();
    this.tempPacEventData = JSON.parse(JSON.stringify(this.PACEventsData));
    var postEventDataTem = this.saveResultProcessing(this.PACEventsData);
    let postEventData = this.assessments;
    postEventData[0]['dbCpDetailsList'] = postEventDataTem;
    postEventData[0]['dos'] = this.getDOSDate();
    postEventData[0]['hospitalStayStatus'] = this.getIsHosStayPlanORActu();
    postEventData[0]['pswActualDischargeDate'] = this.getDischargeDate();
    //this.showloader = false;
    //this.saveAPIService(postEventData,"auto");

    this.saveAPIService(postEventData, "auto", false);
  }

  autoadjustpopup(autoAdjust: TemplateRef<any>) {
    this.modalRef1 = this.modalService.show(autoAdjust, {
      class: 'modal-sm',
      backdrop: 'static'
    })
    this.movable()
  }


  openAutoadjustModal(multipacauto) {
    this.autoadjustTemplate = multipacauto;
    this.modalRef1.hide()
    //this.autoAdjustService();

    this.modalRef1 = this.modalService.show(this.autoadjustTemplate, {
      class: 'modal-lg',
      backdrop: 'static'
    })
    this.movable()
  }

  cancelAutoAdjust() {
    //this.autoAdjustSelected = true
    this.modalRef1.hide();
  }


  onTopDOSDateChange() {
    for (var item of this.PACEventsData) {
      var differDate, differrencePlannedDate
      if (item.hospitalStay) {
        item.anonymousAdmissionDate = this.carePath.dos;

        let DosDate = this.changeFormatToDate(this.carePath.dos);
        item.anonymousSnfDischargeDatemindate = this.changeToDate(DosDate);


        item.anonymousSnfDischargeDatemaxdate = null;
        if (!item.pacFinished) {
          differDate = this.getPlannedDayInterval(-1);
          differrencePlannedDate = this.addAdditionalDate(item.anonymousAdmissionDate, differDate)
          item.anonymousSnfDischargeDate = new Date(differrencePlannedDate);
        }

        /*** New Date Start Here** */
        if (this.PACEventsData.length >= 2) {
          this.PACEventsData[1].anonymousAdmissionDate = new Date(differrencePlannedDate);
          this.PACEventsData[1].plannedDdCpDetails.plannedAdmissionDate = new Date(differrencePlannedDate);
        }


        item.plannedDdCpDetails.plannedSnfDischargeDate = differrencePlannedDate;
        item.plannedDdCpDetails.plannedAdmissionDate = item.anonymousAdmissionDate;
      }




    }

  }


  onDOSChangePacEventValidate() {

    var startDate;
    if (this.getAppliedDischargeDate() == "")
      startDate = this.getAppliedPlannedDischargeDate();
    else
      startDate = this.getAppliedDischargeDate();

    /** Apply Dicharge Date */
    for (var item of this.PACEventsData) {
      if (!item.hospitalStay) {
        var admissionDate = this.findPastorFutureDate(this.changeFormatToDate(startDate), this.changeFormatToDate(item.anonymousAdmissionDate));
        var anoSnfDischargeDate = this.findPastorFutureDate(this.changeFormatToDate(startDate), this.changeFormatToDate(item.anonymousSnfDischargeDate));
        /* var plannedAdmissionDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedAdmissionDate);
        var plannedSnfDischargeDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedSnfDischargeDate); */

        if (admissionDate) {
          item.anonymousstartdateRedAlert = true;
          item.trackActualEmptyEndDate = true
        }
        else
          item.anonymousstartdateRedAlert = false;

        if (anoSnfDischargeDate) {
          item.anonymousenddateRedAlert = true;
          item.trackActualEmptyEndDate = true
        }
        else
          item.anonymousenddateRedAlert = false;


        /* if(plannedAdmissionDate)
          item.plannedDdCpDetails.plannedstartdateRedAlert =true;
        else
          item.plannedDdCpDetails.plannedstartdateRedAlert =false;

        if(plannedSnfDischargeDate)
          item.plannedDdCpDetails.plannedenddateRedAlert =true;
        else
        item.plannedDdCpDetails.plannedenddateRedAlert =false;   */
      }
    }
  }


  findPastorFutureDate(dos, argDate) {
    argDate = new Date(argDate);
    dos = new Date(dos);
    ////console.log('argDate'+argDate)
    ////console.log('dos'+dos)
    if (argDate < dos)
      return true;

    return false;
  }


  autoToManual() {
    this.PACEventsData = [];
    this.PACEventsData = this.tempPacEventData;
  }

  careplanList: any = [];
  //careplanList:any;
  dischargeMapData: any;
  fetchDischargeList() {
    //this.careplanList = this.carePath.dischargeTypeList;
    // this.initMultiPackEvent();
    this.patientservice.fetchDashboardCarePlanDischargeList(this.uid).subscribe(res => {
      this.userService.getDischargeMapByPractice(this.currentUser.item.userAccountKey).subscribe(data => {
        this.dischargeMapData = data;
        this.careplanList = res[0];
        this.careplanList.dischargeTypeList.forEach(element => {
          if (this.dischargeMapData[element.dischargeTypeName]) {
            element.dischargeTypeName = this.dischargeMapData[element.dischargeTypeName]
          }
        });
      });
    })
  }

  saveBtnEnable: boolean = true;
  createPACEventbtn: boolean = true;

  getAllEventList() {
    this.patientservice.getCarePlanDetails(this.userId, this.uid).subscribe(data => {
      this.PACEventsData = data;
      ////console.log("PACEventsData", this.PACEventsData)
      this.initMultiPackEvent();
      /* if (this.carePath.dos) {
        this.saveBtnEnable = false;
        this.carePath.dos = new Date(this.carePath.dos)
        var tmpdateStr = this.Datepipe.transform(new Date(this.carePath.dos), 'yyyy-MM-dd');
        this.DOSChangeDate = tmpdateStr;
      }
      else
        this.saveBtnEnable = true; */
    });
  }

  tst: any;
  saveAllEventList(data) {

    var postEventDataTem = this.saveResultProcessing(this.PACEventsData);
    let postEventData = this.assessments;
    postEventData[0]['dbCpDetailsList'] = postEventDataTem;
    postEventData[0]['dos'] = this.getDOSDate();
    postEventData[0]['hospitalStayStatus'] = this.getIsHosStayPlanORActu();
    postEventData[0]['pswActualDischargeDate'] = this.getDischargeDate();

    this.showloader = false;
    this.tst = postEventData;
    this.saveAPIService(postEventData, "normal", data);

  }

  saveAutoPACKEvent() {

    this.tempPacEventData.forEach(item => {
      if (item.anonymousDischargeId == 5) {
        item.anonymousDischargeId = -2
      }
    });


    var postEventDataTem = this.saveResultProcessing(this.tempPacEventData);
    let postEventData = this.assessments;
    postEventData[0]['dbCpDetailsList'] = postEventDataTem;
    postEventData[0]['dos'] = this.getDOSDate();
    postEventData[0]['hospitalStayStatus'] = this.getIsHosStayPlanORActu();
    postEventData[0]['pswActualDischargeDate'] = this.getDischargeDate();
    this.modalRef1.hide();
    this.showloader = false;
    this.isNonOp = false;

    //alert("Comes Auto Save");
    this.saveAPIService(postEventData, "normal", false);
  }


  changeDateNULLtoempty(data) {
    data[0].dbCpDetailsList.forEach(element => {
      if (element.anonymousSnfDischargeDate == 'Invalid Date' || !element.anonymousSnfDischargeDate) {
        element.anonymousSnfDischargeDate = "";
        //element.plannedDdCpDetails.forEach(it => {
        if (!element.plannedDdCpDetails.plannedSnfDischargeDate || !element.plannedDdCpDetails.plannedAdmissionDate) {
          // element.plannedDdCpDetails.plannedAdmissionDate = "";
          element.plannedDdCpDetails.plannedSnfDischargeDate = "";
        }
        //  });
      }
    });

  }

  deleteModal: BsModalRef;
  changeReadmissionToOtherEvents(data) {
    data[0].dbCpDetailsList.forEach(element => {
      if (element.anonymousDischargeId != 6) {
        element.readmissionId = element.anonymousDischargeId != 9 ? 0 : element.readmissionId;
        element.hospitalRA = false;
        element.raIdentity = "";
      }
    })
  }


  saveAPIService(data, type, alert) {
    // if(this.readmissionReasonFlag){
    //   return "";
    // }
    if (this.checkEmptyPacFields()) {
      this.deletepacvalid = false
      if (this.checkDOSDischargeEmpty()) {
        if (this.checkMultipleCurrent()) {
          if (this.onPacEventValidateWithDOS()) {

            if (this.onPacEventHospitalStayValidationDOS()) {

              if (this.fieldValidation()) {

                if (this.startDateEmptyValidation()) {

                  if (this.dischargeIDEmptyValidation()) {

                    ////console.log("data", data)
                    if (this.checkStarDateEndDate()) {
                      if (this.checkemptyStarDateEndDate()) {

                        if (this.checkReadmissionPending()) {
                          if (this.checkEDVisitPending()) {
                            if (this.checkEmptyEndDate()) {
                              //   this.changeDateformat(data[0].dbCpDetailsList);
                              this.showloader = false
                              this.changeDateNULLtoempty(data);
                              this.changeReadmissionToOtherEvents(data);
                              this.patientservice.saveCarePlan(this.userId, data, type, this.DOSChangeDate, this.selectedUserId)
                                .subscribe(data => {
                                  this.showloader = true;
                                  ////console.log("Responsedata", data)
                                  //  this.enablepatient = true;
                                  /** If DOS available  this.mytodostatus = "Current"  otherwise  this.mytodostatus = "All" */

                                  //this.initFunction(this.mytodostatus);
                                  //this.ModelRef.hide();
                                  if (type == "preSave") {
                                    if (data[0].message == 'PreSaveFailure') {

                                      this.tempPacEventData = data;
                                      for (var itractionObj of this.tempPacEventData) {
                                        this.noOfVisitFuntinality(itractionObj)
                                        this.setCalculateLOS(itractionObj)
                                      }
                                      this.hospitalReadmission(this.tempPacEventData);
                                      // this.trackActualEndDateEmpty(this.tempPacEventData);
                                      this.openModel2(this.autoadjustTemplate);

                                    } else if (data[0].error) {
                                      this.toast.error(data[0].error, '', {
                                        timeOut: this.timealert
                                      })
                                    }
                                    else {
                                      this.PACEventsData = [];
                                      this.PACEventsData = data;
                                      if (!alert)
                                        this.toast.success(this.userService.translateText('hospital_portal.disp_messages.saved.success'), '', {
                                          timeOut: this.timealert
                                        })
                                      this.userService.logAudit('saveDashboardCarePlan', 0).subscribe(data => { })
                                      this.form.onReset();
                                      this.showinvaild = false;
                                      this.trackActualEndDateEmpty(this.PACEventsData);
                                      this.changeToDischargeComplete(this.PACEventsData);
                                      this.contactsIIconEnable(this.PACEventsData);
                                      this.noOfVisitFuntinalityForAll(this.PACEventsData);
                                      this.onLoadingSetMinandMaxDate(this.PACEventsData);
                                      // this.ngOnInit();
                                      this.getreadmissionavaliable();
                                      this.getMytodos();
                                      this.getAllEventList();
                                      this.getCareplanAssesment();
                                    }
                                  }
                                  else {
                                    //this.showloader = true;
                                    if (data[0].message == 'Success') {
                                      if (!alert)
                                        this.toast.success(this.userService.translateText('hospital_portal.disp_messages.saved.success'), '', {
                                          timeOut: this.timealert
                                        })
                                      this.form.onReset();
                                      this.showinvaild = false;
                                      if (type == "normal") {
                                        if (!this.isNonOp) {
                                          this.isNonOp = false;
                                          this.PACEventsData = [];
                                          this.PACEventsData = data;
                                          this.trackActualEndDateEmpty(this.PACEventsData);
                                          this.changeToDischargeComplete(this.PACEventsData);
                                          this.contactsIIconEnable(this.PACEventsData);
                                          this.noOfVisitFuntinalityForAll(this.PACEventsData);
                                          this.onLoadingSetMinandMaxDate(this.PACEventsData);
                                        }
                                        // this.ngOnInit();
                                        this.getreadmissionavaliable();
                                        this.getMytodos();
                                        this.getAllEventList();
                                        this.getCareplanAssesment();
                                      }
                                      else {
                                        this.PACEventsData = [];
                                        this.PACEventsData = data;
                                        this.trackActualEndDateEmpty(this.PACEventsData);
                                        this.changeToDischargeComplete(this.PACEventsData);
                                        this.contactsIIconEnable(this.PACEventsData);
                                        this.noOfVisitFuntinalityForAll(this.PACEventsData);
                                        this.onLoadingSetMinandMaxDate(this.PACEventsData);
                                      }
                                    }
                                    else if (data[0].message == 'Neutral') {
                                      this.PACEventsData = [];
                                      this.PACEventsData = data;
                                      this.trackActualEndDateEmpty(this.PACEventsData);
                                      this.errorPACEventHighlight(this.PACEventsData);
                                      this.changeToDischargeComplete(this.PACEventsData);
                                      this.noOfVisitFuntinalityForAll(this.PACEventsData);
                                      this.onLoadingSetMinandMaxDate(this.PACEventsData);
                                    }
                                    else {
                                      // this.toast.error(data[0].message, 'Some fields are invalid', {
                                      //   timeOut: this.timealert
                                      // })
                                      //  this.ModelRef.hide();
                                    }
                                  }

                                })
                            }
                            else {
                              //Empty End DAte
                              this.isNonOp = false;
                              // this.toast.error('We cant process with multi ED visit Pending', '', {
                              //   timeOut: this.timealert
                              // })
                              this.modalRef1 = this.modalService.show(this.endDateEmptyTemplate, {
                                class: 'modal-sm',
                              })

                              setTimeout(() => {
                                this.modalRef1.hide();
                              }, 5000);
                            }
                          }
                          else {
                            this.isNonOp = false;
                            this.toast.error(this.userService.translateText('hospital_portal.disp_messages.we_cannot_process_multi_ed.error'), '', {
                              timeOut: this.timealert
                            })
                          }
                        }
                        else {
                          this.isNonOp = false;
                          this.toast.error(this.userService.translateText('hospital_portal.disp_messages.we_cannot_process_multi_readmiss.error'), '', {
                            timeOut: this.timealert
                          })
                        }
                      }
                      else {
                        this.isNonOp = false;
                        this.toast.error(this.userService.translateText('hospital_portal.disp_messages.cannot_process_empty.error'), '', {
                          timeOut: this.timealert
                        })
                      }
                    }
                    else {
                      this.isNonOp = false;
                      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.cannot_process_start_and_enddate.error'), '', {
                        timeOut: this.timealert
                      })

                    }
                  }
                  else {
                    this.isNonOp = false;
                    this.toast.error(this.userService.translateText('hospital_portal.disp_messages.please_fill_missing.error'), '', {
                      timeOut: this.timealert
                    })
                  }

                } else {
                  this.isNonOp = false;
                  this.toast.error(this.userService.translateText('hospital_portal.disp_messages.we_cannot_processstart_empty.error'), '', {
                    timeOut: this.timealert
                  })
                }
              } else {
                this.isNonOp = false;
                this.toast.error(this.userService.translateText('hospital_portal.disp_messages.please_fill_missing.error'), '', {
                  timeOut: this.timealert
                })
              }

            } else {
              this.isNonOp = false;
              this.toast.error(this.userService.translateText('patient_portal.display_messages.actual_discarge_date_dos'), '', {
                timeOut: this.timealert
              })
            }

          } else {

            this.isNonOp = false;
            this.toast.error(this.userService.translateText('patient_portal.display_messages.the_actual_end_date'), '', {
              timeOut: this.timealert
            })
          }
        } else {
          this.toast.error(this.userService.translateText('hospital_portal.disp_messages.cannot_process_multi_current.error'), '', {
            timeOut: this.timealert
          })
        }
      } else {
        this.toast.error(this.userService.translateText('hospital_portal.disp_messages.cannot_process_empty_dos.error'), '', {
          timeOut: this.timealert
        })

      }
    }
    else {
      this.deleteModal = this.modalService.show(this.deleteEmptyTemplate, {
        class: 'modal-sm',
        backdrop: 'static'
      })
    }
  }

  deleteEmptyPac() {

    this.PACEventsData = this.PACEventsData.filter(
      item => ((item.anonymousDischargeId && item.anonymousAdmissionDate) || item.hospitalStay))

    this.preSavePACKEvent(this.autoadjustTemplate, this.deleteEmptyTemplate, this.endDateEmptyTemplate);
    this.deleteModal.hide()

  }
  deletepacvalid: boolean = false
  checkEmptyPacFields() {

    var checkEmptyPac = this.PACEventsData.filter(
      item => ((!item.anonymousDischargeId || (!item.anonymousAdmissionDate
        || item.anonymousAdmissionDate == "Invalid Date")) && !item.hospitalStay))

    if (checkEmptyPac.length > 0 && !this.deletepacvalid) {
      this.deletepacvalid = true;
      return false;
    }

    return true;
  }

  incrementValue: number = 0;
  incValue: boolean = true;
  checkMultipleCurrent() {
    this.incrementValue = 0;
    this.incValue = true;
    for (var item of this.PACEventsData) {
      if (item.status != 'InProgress' && item.trackActualVisible && (item.anonymousSnfDischargeDate == "" || item.anonymousSnfDischargeDate == "Invalid Date") && item.anonymousDischargeId != "6" && item.anonymousDischargeId != "9") {
        this.incrementValue += 1;

        if (this.incrementValue >= 1) {
          this.incValue = false;
          item.anonymousenddateRedAlert = true;
          item.trackActualEmptyEndDate = true
        }

      }
    }
    return this.incValue;
  }


  flagStartDateEmpty: boolean = true;
  startDateEmptyValidation() {
    this.flagStartDateEmpty = true;
    for (var item of this.PACEventsData) {
      if (item.anonymousAdmissionDate == "") {
        this.flagStartDateEmpty = false;
        item.anonymousstartdateRedAlert = true;
      }
    }
    return this.flagStartDateEmpty;
  }


  flagDischargeIdEmpty: boolean = true;
  dischargeIDEmptyValidation() {
    this.flagDischargeIdEmpty = true;
    for (var item of this.PACEventsData) {
      if (item.trackActualVisible) {
        if (item.anonymousDischargeId == "" && !item.hospitalStay) {
          this.flagDischargeIdEmpty = false;
          item.anonymouseventTypeRedAlert = true;
        }
      }
    }
    return this.flagDischargeIdEmpty;
  }

  //Check Start&End Date
  checkStarDateEndDate() {
    for (var item of this.PACEventsData) {
      if (item.anonymousAdmissionDate && item.anonymousSnfDischargeDate) {
        var checkStarDateandEndDate = this.findPastorFutureDate(this.changeFormatToDate(item.anonymousAdmissionDate), this.changeFormatToDate(item.anonymousSnfDischargeDate))
        if (checkStarDateandEndDate) {
          item.anonymousstartdateRedAlert = true;
          item.anonymousenddateRedAlert = true;
          item.trackActualEmptyEndDate = true
          return false;
        }
      }
    }
    return true;
  }
  // Validation for all filed - PAC Save validation
  checkemptyStarDateEndDate() {

    for (let item of this.PACEventsData) {

      if (!item.hospitalStay)
        //if (!item.anonymousAdmissionDate || !item.anonymousSnfDischargeDate ) {
        if (!item.anonymousAdmissionDate || item.anonymousAdmissionDate == "Invalid Date") {
          item.anonymousstartdateRedAlert = true;
          item.anonymousenddateRedAlert = false;
          item.trackActualEmptyEndDate = true
          return false
        }
    }
    return true;
  }


  checkReadmissionPending() {

    var checkReAdmis = this.PACEventsData.filter(it => it.anonymousDischargeId == 6 && it.raIdentity != 'P' && it.status == "ReAdmitPending")
    var checkReAdmis1 = this.PACEventsData.filter(it => it.anonymousDischargeId == 6 && it.status == "InProgress" && it.trackActualEmptyEndDate && it.anonymousSnfDischargeDate && it.anonymousSnfDischargeDate != 'Invalid Date')

    ////console.log("ReadmissionPending", checkReAdmis);

    if (checkReAdmis.length > 0 && checkReAdmis1.length == 0) {
      return false
    }

    return true;

  }

  //Check EndDate Empty
  checkEmptyEndDate() {
    var checkReAdmis = this.PACEventsData.filter(it =>
      (!it.anonymousSnfDischargeDate || it.anonymousSnfDischargeDate == 'Invalid Date') &&
      ((it.pacFinished && it.trackActualVisible) || (!it.pacFinished && it.trackActualVisible && !it.trackActualEmptyEndDate) || (!it.pacFinished && !it.trackActualVisible)))
    //var checkReAdmis1= this.PACEventsData.filter(it => it.anonymousDischargeId==9 && it.status=="InProgress" && it.anonymousSnfDischargeDate && it.anonymousSnfDischargeDate != 'Invalid Date')

    ////console.log("ReadmissionPending", checkReAdmis);

    if (checkReAdmis.length > 0) {
      return false
    }

    return true;
  }

  //Check more than one ED Visit  Pending
  checkEDVisitPending() {

    var checkEDAdmis = this.PACEventsData.filter(it => it.anonymousDischargeId == 9 && it.raIdentity != 'P' && it.status == "EdPending")
    var checkEDAdmis1 = this.PACEventsData.filter(it => it.anonymousDischargeId == 9 && it.status == "InProgress" && it.trackActualEmptyEndDate && it.anonymousSnfDischargeDate && it.anonymousSnfDischargeDate != 'Invalid Date')

    ////console.log("ReadmissionPending", checkReAdmis);

    if (checkEDAdmis.length > 0 && checkEDAdmis1.length == 0) {
      return false
    }

    return true;

  }

  checkFutureDate(item) {
    // for(var item of this.PACEventsData)
    // {
    if (item.anonymousSnfDischargeDate && item.anonymousSnfDischargeDatemaxdate) {
      if (new Date(item.anonymousSnfDischargeDate) > item.anonymousSnfDischargeDatemaxdate && item.pacFinished) {
        item.anonymousSnfDischargeDate = "";
        item.anonymousenddateRedAlert = true;
        item.trackActualEmptyEndDate = true
        // if(item.backupStauts=='InProgress'){
        //   this.PACEventsData.forEach(element => {
        //     if(element.status=='InProgress'){
        //       element.status='UpComing'
        //     }
        //   });
        // }

        // item.status = item.backupStauts;
        // // if(item.backupStauts=='InProgress')
        // item.pacFinished = false
        // item.trackActualVisible = false;
        // item.trackActualEmptyEndDate =false;
        return false;
      }
    }
    if (item.anonymousAdmissionDate && item.anonymousAdmissionDatemaxdate) {
      if (new Date(item.anonymousAdmissionDate) > item.anonymousAdmissionDatemaxdate && item.pacFinished) {
        item.anonymousAdmissionDate = "";
        item.anonymousstartdateRedAlert = true;
        return false;
      }
    }
    // }
    return true;
  }
  checkplannedFutureDate(item, changedItem) {
    // for(var item of this.PACEventsData)
    // {
    if (item.anonymousSnfDischargeDate && item.anonymousSnfDischargeDatemaxdate && changedItem == 4) {
      if (new Date(item.anonymousSnfDischargeDate) > item.anonymousSnfDischargeDatemaxdate) {
        item.anonymousSnfDischargeDate = "";
        item.anonymousenddateRedAlert = true;
        item.trackActualEmptyEndDate = true
        // if(item.backupStauts=='InProgress'){
        //   this.PACEventsData.forEach(element => {
        //     if(element.status=='InProgress'){
        //       element.status='UpComing'
        //     }
        //   });
        // }

        // item.status = item.backupStauts;
        // // if(item.backupStauts=='InProgress')
        // item.pacFinished = false
        // item.trackActualVisible = false;
        // item.trackActualEmptyEndDate =false;
        this.saveBtnEnable = true;
        return false;
      }
    }
    if (item.anonymousAdmissionDate && item.anonymousAdmissionDatemaxdate && changedItem == 3) {
      if (new Date(item.anonymousAdmissionDate) > item.anonymousAdmissionDatemaxdate) {
        item.anonymousAdmissionDate = "";
        item.anonymousstartdateRedAlert = true;
        this.saveBtnEnable = true;
        return false;
      }
    }
    // }
    this.saveBtnEnable = false;
    return true;
  }

  countValidate: boolean = false;
  fieldValidation() {
    for (var item of this.PACEventsData) {
      if (item.anonymousDischargeId != 7 && item.anonymousDischargeId != 5 && item.anonymousDischargeId != -2 && item.anonymousDischargeId != -3) {
        if (item.anonymousDischargeId != "") {
          if (item.anonymousDischargeHospitalMasterId == "") {
            this.countValidate = true;
            item.anonymousfacilitynameRedAlert = true;
          }
        }
      }
    }

    if (this.countValidate) {
      this.countValidate = false;
      return false;
    }

    return true;
  }




  checkDOSDischargeEmpty() {
    for (var item of this.PACEventsData) {
      /* && !item.trackActualVisible && !item.pacFinished */
      if (item.hospitalStay) {
        if (item.anonymousAdmissionDate == "" || item.anonymousSnfDischargeDate == "" || item.anonymousAdmissionDate == null || item.anonymousSnfDischargeDate == null) {
          if (item.anonymousAdmissionDate == "" || item.anonymousAdmissionDate == null)
            item.anonymousstartdateRedAlert = true;
          else
            item.anonymousstartdateRedAlert = false;

          if (item.anonymousSnfDischargeDate == "" || item.anonymousSnfDischargeDate == null)
            item.anonymousenddateRedAlert = true;
          else
            item.anonymousenddateRedAlert = false;

          return false;
        }
      }

      /* if(item.hospitalStay && item.trackActualVisible  && !item.pacFinished)
      {

         if(item.anonymousAdmissionDate=="" || item.anonymousAdmissionDate==null)
         {
           item.anonymousstartdateRedAlert=true;
           return false;
         }else
           item.anonymousstartdateRedAlert=false;
      } */
    }
    return true;
  }

  onPacEventValidateWithDOS() {
    /** Apply Dicharge Date **/

    var startDate;
    if (this.getAppliedDischargeDate() == "")
      startDate = this.getAppliedPlannedDischargeDate();
    else
      startDate = this.getAppliedDischargeDate();

    for (var item of this.PACEventsData) {

      if (!item.hospitalStay && item.anonymousDischargeId) {
        if ((!item.anonymousAdmissionDate || !item.anonymousSnfDischargeDate) || (item.anonymousAdmissionDate != "null" || item.anonymousSnfDischargeDate != "null") || (item.anonymousAdmissionDate != "Invalid Date" || item.anonymousSnfDischargeDate != "Invalid Date")) {
          var admissionDate = this.findPastorFutureDate(this.changeFormatToDate(startDate), this.changeFormatToDate(item.anonymousAdmissionDate));
          var anoSnfDischargeDate = this.findPastorFutureDate(this.changeFormatToDate(startDate), this.changeFormatToDate(item.anonymousSnfDischargeDate));
        }
        /* var plannedAdmissionDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedAdmissionDate);
        var plannedSnfDischargeDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedSnfDischargeDate); */
        /* ||  plannedAdmissionDate || plannedSnfDischargeDate */


        if (admissionDate || anoSnfDischargeDate) {
          this.onDOSChangePacEventValidate();
          return false;
        }
      }


    }

    this.onDOSChangePacEventValidate();
    return true;
  }

  onPacEventHospitalStayValidationDOS() {

    for (var item of this.PACEventsData) {

      if (item.hospitalStay) {
        var admissionDate = this.findPastorFutureDate(this.changeFormatToDate(item.anonymousAdmissionDate), this.changeFormatToDate(item.anonymousSnfDischargeDate));

        // var anoSnfDischargeDate = this.findPastorFutureDate(startDate,item.anonymousSnfDischargeDate);

        /* var plannedAdmissionDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedAdmissionDate);
        var plannedSnfDischargeDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedSnfDischargeDate); */
        /* ||  plannedAdmissionDate || plannedSnfDischargeDate */

        if (admissionDate) {
          item.anonymousstartdateRedAlert = true;
          item.anonymousenddateRedAlert = true;
          item.trackActualEmptyEndDate = true
          return false;
        }
      }


    }
    return true;
  }


  errorPACEventHighlight(data) {
    for (var item of data) {
      if (item.isAutoSortDateValid) {
        item.anonymousstartdateRedAlert = true;
        item.anonymousenddateRedAlert = true;
        item.trackActualEmptyEndDate = true
      }
    }
  }

  saveResultProcessing(postEventData) {

    //alert(JSON.stringify(postEventData));
    var differDate, differrencePlannedDate
    for (var i = 0; i < postEventData.length; i++) {
      var obj = postEventData[i];

      if (i == 0 || obj.status == "InProgress") {

        obj.plannedDdCpDetails.plannedDischargeDate = this.changeStringFormat2(obj.plannedDdCpDetails.plannedAdmissionDate);

        if (obj.hospitalStay)
          obj.pswActualDischargeDate = obj.anonymousSnfDischargeDate;

      }

      if (obj.anonymousAdmissionDate != "") {
        obj.anonymousAdmissionDate = this.changeStringFormat2(obj.anonymousAdmissionDate);
      }

      if (obj.anonymousSnfDischargeDate != "") {
        obj.anonymousSnfDischargeDate = this.changeStringFormat2(obj.anonymousSnfDischargeDate);
      } else {
        if (obj.status == "InProgress" && !obj.plannedDdCpDetails.plannedSnfDischargeDate) {
          obj.pacFinished = false;
          differDate = this.getPlannedDayInterval(obj.anonymousDischargeId)
          differrencePlannedDate = this.addAdditionalDate(obj.anonymousAdmissionDate, differDate)
          obj.plannedDdCpDetails.plannedSnfDischargeDate = this.changeStringFormat2(differrencePlannedDate);
        }
      }

      if (obj.anonymousDischargeHospitalMasterId == -2)
        obj.anonymousDischargeHospitalMasterId = "";


      if (obj.anonymousDischargeHospitalMasterId == -3)
        obj.anonymousDischargeHospitalMasterId = "";


      if (obj.anonymousDischargeHospitalMasterId == -4)
        obj.anonymousDischargeHospitalMasterId = "";






      // alert(obj.anonymousOtherSelectedName)
      // alert(obj.plannedDdCpDetails.plannedOtherSelectedName)
      /*** If Not Other Clear all Other Values Here ***/
      this.clearOtherPropertyValues(obj);
      if (obj.anonymousDischargeId == -2)
        obj.anonymousDischargeId = 5;


      // alert(obj.anonymousOtherSelectedName)
      // alert(obj.plannedDdCpDetails.plannedOtherSelectedName)

      /* if(obj.trackActualEmptyEndDate)
          obj.anonymousSnfDischargeDate = ""; */

      if (obj.plannedDdCpDetails.plannedAdmissionDate != "")
        obj.plannedDdCpDetails.plannedAdmissionDate = this.changeStringFormat2(obj.plannedDdCpDetails.plannedAdmissionDate);

      if (obj.plannedDdCpDetails.plannedSnfDischargeDate != "")
        obj.plannedDdCpDetails.plannedSnfDischargeDate = this.changeStringFormat2(obj.plannedDdCpDetails.plannedSnfDischargeDate);

      if (obj.dos != "")
        obj.dos = this.changeStringFormat2(obj.dos);

      if (obj.anonymousAdmissionDate != "")
        obj.anonymousAdmissionDate = this.changeStringFormat2(obj.anonymousAdmissionDate);

      if (obj.plannedDdCpDetails.plannedAdmissionDate != "")
        obj.plannedDdCpDetails.plannedAdmissionDate = this.changeStringFormat2(obj.plannedDdCpDetails.plannedAdmissionDate);


      obj.anonymousDischargeDate = !obj.anonymousDischargeDate ? obj.anonymousDischargeDate
        : this.changeStringFormat2(obj.anonymousDischargeDate);
      if (obj.plannedDdCpDetails.plannedDischargeDate != "" && !obj.hospitalStay) {
        obj.plannedDdCpDetails.plannedDischargeDate = !obj.plannedDdCpDetails.plannedDischargeDate ? obj.plannedDdCpDetails.plannedDischargeDate
          : this.changeStringFormat2(obj.plannedDdCpDetails.plannedDischargeDate);
      }
      obj.pswActualDischargeDate = !obj.pswActualDischargeDate ? obj.pswActualDischargeDate
        : this.changeStringFormat2(obj.pswActualDischargeDate);

      if (obj.anonymousDischargeId == 6 || obj.anonymousDischargeId == 9) {


        if (!obj.anonymousSnfDischargeDate) {
          obj.pacFinished = false;
          differDate = this.getPlannedDayInterval(obj.anonymousDischargeId)
          differrencePlannedDate = this.addAdditionalDate(obj.anonymousAdmissionDate, differDate)
          obj.anonymousSnfDischargeDate = this.changeStringFormat2(differrencePlannedDate);

        }

        obj.plannedDdCpDetails.plannedDdCpDetails = ""
        obj.plannedDdCpDetails.plannedDischargeDate = "";
        obj.plannedDdCpDetails.plannedSnfDischargeDate = "";
        obj.plannedDdCpDetails.plannedDischargeId = 0;
        obj.plannedDdCpDetails.plannedDischargeHospitalMasterId = 0;
        obj.plannedDdCpDetails.plannedLos = "";
        obj.plannedDdCpDetails.plannedAdmissionDate = "";
        obj.plannedDdCpDetails.plannedVisit = "";
        obj.plannedDdCpDetails.plannedOtherSelectedName = "";
        obj.plannedDdCpDetails.plannedDischargeTypeForOther = "";
      }
      if (obj.anonymousDischargeId == 7) {
        this.careplanList.dischargehospitalList.forEach(element => {
          if (element.dischargeType == obj.anonymousDischargeId) {
            obj.anonymousDischargeHospitalMasterId = element.dischargeId;
          }
        });
      }
      if (obj.plannedDdCpDetails.plannedDischargeId == 7) {
        this.careplanList.dischargehospitalList.forEach(element => {
          if (element.dischargeType == obj.anonymousDischargeId) {
            obj.plannedDdCpDetails.plannedDischargeHospitalMasterId = element.dischargeId;
          }
        });
      }

    }

    return postEventData;

  }

  clearOtherPropertyValues(item) {
    if (item.anonymousDischargeId != -2) {
      //alert("Call");
      item.anonymousOtherSelectedName = "";
      item.anonymousOtherFreeText = "";
      item.anonymousOtherPacContact = "";
      item.anonymousHospitalOtherPacMapId = 0;
      item.anonymousOtherPacMasterId = 0;
      item.anonymousOtherPacPhone = "";
      item.anonymousOtherPacTeleCode = "";
      item.anonymousOtherPacTeleCountryCode = "";
      item.anonymousOtherPacTurnedOn = true;

      item.plannedDdCpDetails.plannedOtherSelectedName = "";
      item.plannedDdCpDetails.plannedOtherFreeText = "";
      item.plannedDdCpDetails.plannedOtherPacContact = "";
      item.plannedDdCpDetails.plannedOtherPacPhone = "";
      item.plannedDdCpDetails.plannedOtherPacTeleCode = "";
      item.plannedDdCpDetails.plannedOtherPacTeleCountryCode = "";
      item.plannedDdCpDetails.plannedHospitalOtherPacMapId = 0;
      item.plannedDdCpDetails.plannedOtherPacMasterId = 0;
      item.plannedDdCpDetails.plannedOtherPacTurnedOn = true;

    }
  }

  deleteResponseJSON: any;
  deletePACEvent(item, index, deleteHospiTrasfer: TemplateRef<any>) {
    let checkReadmit: boolean = false;


    if (item.status == 'InProgress') {

      var checkReAdmis = this.PACEventsData.filter(it =>
        it.status == "ReAdmitPending")

      if (checkReAdmis.length > 0) {
        var elementPos = this.PACEventsData.map(function (x) { return x.id; }).indexOf(checkReAdmis[0].id);

        this.PACEventsData[elementPos].status = 'InProgress';
        checkReadmit = true;

        //console.log("objectFound", objectFound)
      }

    }

    if (item.status == 'InProgress' && this.PACEventsData.length != index + 1
      && this.PACEventsData[index + 1].status != "Completed" && !checkReadmit) {

      this.PACEventsData[index + 1].status = "InProgress"

    }




    /** Delete Event without server data */
    if (!item.serverdata)
      this.PACEventsData.splice(index, 1);
    else {
      /** Delete Event server data */
      //deletepac
      //item.plannedHspTransfer = item.plannedHspTransfer?item.plannedHspTransfer:0;

      if (item.anonymousDischargeId == '8' && item.trackActualVisible) {
        this.tempHospiTransPac = item;
        this.tempIndex = index;
        this.ModelRef1 = this.Modalservice.show(deleteHospiTrasfer, { class: 'modal-sm', backdrop: 'static' })
      }
      else {
        this.deletePacData(item, index);
      }
    }

    //this.PACEventsData.removeAt(this.PACEventsData.value.findIndex(event => event.patientPacMasterMapId == 14392));
    /* this.PACEventsData.removeAt(this.images.value.findIndex(image => image.id == 502)) */
  }
  tempHospiTransPac: any;
  tempIndex: any;
  deletePacData(item, index) {
    var userAccountId = this.currentUser.item.userAccountId

    var anonymousDischargeId = item.anonymousDischargeId ? item.anonymousDischargeId : 0
    this.patientservice.deletepac(item.patientPacMasterMapId, anonymousDischargeId,
      item.trackActualVisible, userAccountId)
      .subscribe(data => {
        ////console.log(data)
        this.deleteResponseJSON = data;
        if (this.deleteResponseJSON[0].status == "Success") {
          this.toast.success(this.userService.translateText('patient_portal.display_messages.plan_deleted_success'), '', {
            timeOut: this.timealert
          })
          this.PACEventsData.splice(index, 1);
          if (item.status == 'InProgress' || ((item.anonymousDischargeId == 6 || item.anonymousDischargeId == 8) && item.status == 'Completed')) {
            this.saveAllEventList(true);
            this.ngOnInit();
          }

        } else {
          this.toast.error(this.userService.translateText('patient_portal.display_messages.something_went_wrong'), '', {
            timeOut: this.timealert
          })
        }
        //this.pacview();

      })

  }


  showTooltip: boolean = false;
  excoBtnTxt: string = this.userService.translateText('hospital_portal.summary.expand_all.button');

  toggleTooltip(PACEventsData) {

    let status = PACEventsData.filter(item => !item.tab)
    this.showTooltip = false;
    if (status.length > 0) {
      this.showTooltip = true
    }
    if (this.showTooltip)
      this.excoBtnTxt = this.userService.translateText('hospital_portal.summary.expand_all.button');
    else
      this.excoBtnTxt = this.userService.translateText('hospital_portal.summary.collapse_all.button');

    for (var i in PACEventsData) {
      var item = PACEventsData[i];
      item.tab = this.showTooltip;
    }
  }



  idIncrement: any = 0;
  singlePACEvent: any = {
    "patientPacMasterMapId": "",
    "id": 1,
    "caseManager": "John Peterson",
    "dos": "03/10/2019",
    "status": "UpComing",
    "serverdata": false,
    "hospitalName": "Princeton Community Hospital",
    "anonymousDischargeDate": "",
    "anonymousSnfDischargeDate": "",
    "anonymousDischargeId": "",
    "anonymousDischargeHospitalMasterId": "",
    "anonymousDischargePhone": "",
    "anonymousDischargeTeleCode": "",
    "anonymousDischargeTeleCountryCode": "",
    "anonymousDischargeLocContact": "",
    "actualHspTransfer": "",
    "anonymousLos": 3,
    "dischargeTo": "",
    "dischargeType": "",
    "patientDbScore": null,
    "dischargeTypeList": null,
    "dischargeTypeDetails": null,
    "dischargehospitalList": null,
    "anonymousAdmissionDate": "",
    "anonymousVisit": "",
    "anonymousOtherSelectedName": "",
    "anonymousDischargeTypeForOther": null,
    "anonymousOtherFreeText": "",
    "anonymousOtherPacContact": "",
    "anonymousHospitalOtherPacMapId": 0,
    "anonymousOtherPacPhone": "",
    "actualOtherPacMasterId": 0,
    "anonymousOtherPacTeleCode": "",
    "anonymousOtherPacTeleCountryCode": "",
    "isAnonymousOtherPacTurnedOn": "",
    "plannedDdCpDetails": {
      "plannedHospitalOtherPacMapId": 0,
      "plannedOtherPacContact": "",
      "plannedOtherPacTeleCode": "",
      "plannedOtherPacTeleCountryCode": "",
      "plannedOtherPacPhone": "",
      "plannedOtherFreeText": "",
      "plannedOtherPacMasterId": 0,
      "patientPacMasterMapId": 0,
      "plannedDischargeDate": "01/28/2019",
      "plannedSnfDischargeDate": "02/02/2019",
      "plannedDischargeId": "",
      "plannedDischargeHospitalMasterId": "",
      "plannedLos": 3,
      "plannedAdmissionDate": "",
      "plannedVisit": "",
      "plannedOtherSelectedName": "",
      "plannedDischargeTypeForOther": null,
      "status": "Planned",
      "plannedeventTypeRedAlert": false,
      "plannedfacilitynameRedAlert": false,
      "plannedstartdateRedAlert": false,
      "plannedenddateRedAlert": false
    },
    "trackActualVisible": false,
    "tab": true,
    "hospitalStay": false,
    "autoSortDateValid": false,
    "anonymousAdmissionDatemindate": null,
    "anonymousAdmissionDatemaxdate": null,
    "anonymousSnfDischargeDatemindate": null,
    "anonymousSnfDischargeDatemaxdate": null,
    "existingRaChanged": false,
    "existingReadmissionDate": "",
    "anonymouseventTypeRedAlert": false,
    "anonymousfacilitynameRedAlert": false,
    "anonymousstartdateRedAlert": false,
    "anonymousenddateRedAlert": false,
    "dischargeCompleted": true
  };


  initMultiPackEvent() {
    if (this.PACEventsData.length > 0) {
      for (var i = 0; i < this.PACEventsData.length; i++) {

        var itractionObj = this.PACEventsData[i];

        this.defaultSetAttributeForLocalPurpose(itractionObj);


        /*** H Readmission Value change to Actual */
        // this.changeHReadmissionValue(itractionObj);

        /* if (itractionObj.anonymousOtherSelectedName != '')
          itractionObj.anonymousDischargeId = itractionObj.anonymousOtherSelectedName */


        if (!itractionObj.trackActualVisible) {
          this.assignPlannedtoActual(itractionObj);
        }
        // if(itractionObj.anonymousDischargeId != itractionObj.plannedDdCpDetails.plannedDischargeId   && !itractionObj.pacFinished){
        //   var differDate = this.getPlannedDayInterval(itractionObj.anonymousDischargeId)
        //   var differrencePlannedDate = this.addAdditionalDate(itractionObj.anonymousAdmissionDate, differDate)
        //   itractionObj.anonymousSnfDischargeDate = new Date(differrencePlannedDate);
        //   itractionObj.pacFinished = false;
        //   itractionObj.trackActualEmptyEndDate = false;
        // }
        /*"anonymousAdmissionDatemindate":new Date('2019/03/28'),
          "anonymousAdmissionDatemaxdate":new Date('2019/04/28'),
          "anonymousSnfDischargeDatemindate":new Date('2019/03/28'),
          "anonymousSnfDischargeDatemaxdate":new Date('2019/04/28'),
          "anonymousDischargeDatedisable" : false,
          "anonymousSnfDischargeDate" : false,

          Default Add Above Attrubute inital

        */


        if (itractionObj.hospitalStay) {
          this.hospitalstayTrackActual(itractionObj);

          if (itractionObj.trackActualVisible)
            this.trackAcutualCompleted = true;
        }


        /** No of visit logic  */
        this.noOfVisitFuntinality(itractionObj)


        /*** GCP , Track Acturl , Follow up with pack etc ***/
        /* if(i==0)
            this.highlightFields(itractionObj,this.PACEventsData[i+1]); */


        if (itractionObj.raOtherHspName != "" || itractionObj.raOtherHspName != null) {
          if ((itractionObj.anonymousDischargeId == 6 || itractionObj.anonymousDischargeId == 9) && itractionObj.anonymousDischargeHospitalMasterId == "")
            itractionObj.anonymousDischargeHospitalMasterId = -2;
        }

        // if(itractionObj.edOtherHspName!="" || itractionObj.edOtherHspName!=null)
        // {
        //   if(itractionObj.anonymousDischargeId==9 && itractionObj.anonymousDischargeHospitalMasterId=="")
        //     itractionObj.anonymousDischargeHospitalMasterId=-4;
        // }


        if (itractionObj.anonymousHtOtherHspName != "" || itractionObj.anonymousHtOtherHspName != null) {
          if (itractionObj.anonymousDischargeId == 8 && itractionObj.anonymousDischargeHospitalMasterId == "") {
            itractionObj.anonymousDischargeHospitalMasterId = -3;
            itractionObj.htOtherHspName = itractionObj.anonymousHtOtherHspName;
          }
        }

        /** Other Name PAC Value Set -2 start here**/
        this.otherPACDefaultValueMinusTwo(itractionObj);
        /*** Set min and max date ***/
        if (itractionObj.pacFinished && !itractionObj.hospitalStay)
          this.setTrackMinandMaxDate(itractionObj);

        if (!itractionObj.pacFinished && !itractionObj.hospitalStay)
          this.setPlannedMinandMaxDate(itractionObj);




        this.hospitalStayMinMaxDate(itractionObj);




        this.contactDetailsEnable(itractionObj);

        if (this.isDishargeCompleted())
          itractionObj.dischargeCompleted = true;
        else
          itractionObj.dischargeCompleted = false;


        itractionObj.anonymousAdmissionDate = new Date(itractionObj.anonymousAdmissionDate)
        itractionObj.anonymousSnfDischargeDate = new Date(itractionObj.anonymousSnfDischargeDate)
        //if(!itractionObj.anonymousSnfDischargeDate)
        this.setCalculateLOS(itractionObj);

      }
    }
    this.trackActualEndDateEmpty(this.PACEventsData);
    this.changeToDischargeComplete(this.PACEventsData);

    if (this.PACEventsData.length > 0) {
      /*** Enddate empty and TrackActual True */
      if (itractionObj.trackActualVisible && itractionObj.pacFinished)
        itractionObj.trackActualEmptyEndDate = true;
      else if (itractionObj.trackActualVisible && !itractionObj.pacFinished)
        itractionObj.trackActualEmptyEndDate = false;

      //Readmission Flag set true and set date
      if (itractionObj.anonymousDischargeId == 6 || itractionObj.anonymousDischargeId == 9) {
        this.flagAlreadyChooseReadmission = false;
        if (itractionObj.anonymousDischargeId == 6)
          this.flagAlreadyChooseReadmission = true;

        itractionObj.existingRaChanged = true;
        itractionObj.existingReadmissionDate = this.changeStringFormat2(itractionObj.anonymousAdmissionDate);
      }
    }

    this.getdatedos()

  }


  changeHReadmissionValue(item) {
    if (item.anonymousDischargeId == 6)
      item.pacFinished = true;
  }


  /*  contactDetailsVisible(item)
   {
       if(item.anonymousDischargeId!="" && item.anonymousDischargeHospitalMasterId!="")
       {
         if(item.anonymousDischargeId==4 || item.anonymousDischargeId==2 || item.anonymousDischargeId==3)
          item.contactVisible =1;
         else if(item.anonymousDischargeId==6)
          item.contactVisible =2;
         else
           item.contactVisible =0;
       }
   } */


  /** Other Name PAC Value Set -2 start here**/
  otherPACDefaultValueMinusTwo(itractionObj) {
    if (itractionObj.anonymousOtherSelectedName != "" || itractionObj.plannedDdCpDetails.plannedOtherSelectedName != "" || itractionObj.anonymousDischargeId == 5) {
      itractionObj.anonymousDischargeId = -2;
      if (itractionObj.plannedDdCpDetails.plannedOtherFreeText) {
        itractionObj.plannedDdCpDetails.plannedOtherSelectedName = itractionObj.plannedDdCpDetails.plannedOtherFreeText
      }
      if (itractionObj.anonymousOtherFreeText) {
        itractionObj.anonymousOtherSelectedName = itractionObj.anonymousOtherFreeText
      }
    }
    /*   if(itractionObj.plannedDdCpDetails.plannedOtherSelectedName!="" || itractionObj.plannedDdCpDetails.plannedOtherSelectedName!=null)
      itractionObj.anonymousDischargeId = -2;    */
  }
  /** Other Name PAC Value Set -2 end here**/


  hospitalStayMinMaxDate(itractionObj) {

    /*** Hospital Stay Min Max Date **/
    if (itractionObj.hospitalStay) {
      let DosDate = this.changeFormatToDate(this.user.dob);
      itractionObj.anonymousAdmissionDatemindate = this.changeToDate(DosDate);
    }
    if (itractionObj.hospitalStay && !itractionObj.pacFinished) {
      let DosDate = this.changeFormatToDate(this.carePath.dos);
      itractionObj.anonymousSnfDischargeDatemindate = this.changeToDate(DosDate);
    }

    if (itractionObj.hospitalStay && itractionObj.pacFinished) {
      let DosDate = this.changeFormatToDate(this.carePath.dos);
      itractionObj.anonymousSnfDischargeDatemindate = this.changeToDate(DosDate);
      itractionObj.anonymousSnfDischargeDatemaxdate = new Date();
    }
  }



  setCalculateLOS(item) {
    /** Set LOS Difference ***/


    if (item.anonymousAdmissionDate != "" && item.anonymousSnfDischargeDate != "" && item.anonymousAdmissionDate != null && item.anonymousSnfDischargeDate != null) {
      var differVal = this.differenceTwoDate(item.anonymousAdmissionDate, item.anonymousSnfDischargeDate);
      if (isNaN(differVal))
        item.anonymousLos = 0;
      else
        item.anonymousLos = differVal;
    }
    else
      item.anonymousLos = 0;

    // alert(item.plannedDdCpDetails.plannedAdmissionDate +"-----"+ item.plannedDdCpDetails.plannedSnfDischargeDate);



    if (item.plannedDdCpDetails.plannedAdmissionDate != "" && item.plannedDdCpDetails.plannedSnfDischargeDate != "" && item.plannedDdCpDetails.plannedAdmissionDate != null && item.plannedDdCpDetails.plannedSnfDischargeDate != null) {
      item.plannedDdCpDetails.plannedAdmissionDate = new Date(item.plannedDdCpDetails.plannedAdmissionDate)
      item.plannedDdCpDetails.plannedSnfDischargeDate = new Date(item.plannedDdCpDetails.plannedSnfDischargeDate)


      var differVal1 = this.differenceTwoDate(item.plannedDdCpDetails.plannedAdmissionDate, item.plannedDdCpDetails.plannedSnfDischargeDate);

      if (isNaN(differVal1))
        item.plannedDdCpDetails.plannedLos = 0;
      else
        item.plannedDdCpDetails.plannedLos = differVal1;
    }
    else
      item.plannedDdCpDetails.plannedLos = 0;
  }


  setTrackMinandMaxDate(item) {

    /** Apply Discharge Date*/

    let minDate = this.changeFormatToDate(item.anonymousAdmissionDate);
    let DosDate = this.changeFormatToDate(this.getAppliedDischargeDate());

    item.anonymousAdmissionDatemindate = this.changeToDate(DosDate);

    /* if(item.pacFinished) */
    item.anonymousAdmissionDatemaxdate = new Date();

    item.anonymousSnfDischargeDatemindate = this.changeToDate(minDate);
    item.anonymousSnfDischargeDatemaxdate = new Date();



  }

  setPlannedMinandMaxDate(item) {

    if (this.getAppliedDischargeDate() == "") {
      let minDate1 = this.getAppliedPlannedDischargeDate();
      item.anonymousAdmissionDatemindate = this.changeToDate(minDate1);
      item.anonymousSnfDischargeDatemindate = this.changeToDate(minDate1);

    } else {
      //let Dosdate = this.changeStringFormatToDate(this.carePath.dos);
      let minDate = this.getAppliedDischargeDate();

      item.anonymousAdmissionDatemindate = this.changeToDate(minDate);
      item.anonymousSnfDischargeDatemindate = this.changeToDate(minDate);

      if (item.trackActualVisible && !item.pacFinished)
        item.anonymousAdmissionDatemaxdate = new Date();

      //item.anonymousSnfDischargeDatemindate = this.changeToDate(minDate);
      //item.anonymousSnfDischargeDatemaxdate = null;
    }
  }

  noOfVisitFuntinality(itractionObj) {


    /*** No of visit Calculation Find Configuralbe  ***/
    if (this.checkConfigureEventType(itractionObj.anonymousDischargeId)) {
      /* var visitValue = itractionObj.plannedDdCpDetails.plannedVisit;
      if (visitValue > 0) */

      if (!itractionObj.trackActualVisible) {
        if (!itractionObj.anonymousVisit)
          this.calculateplanedvisitNew(this.selectionItemNoOfVisit, itractionObj)
        itractionObj.visitshowReadonly = true;
        itractionObj.visitShown = true;
      }

      if (itractionObj.trackActualVisible) {
        itractionObj.visitshowReadonly = false;
        itractionObj.visitShown = true;
        // itractionObj.anonymousVisit = "";
      }

    }
    else {
      itractionObj.visitShown = false;
      itractionObj.visitshowReadonly = false;
    }

  }


  noOfVisitFuntinalityForAll(pacData) {
    for (var itractionObj of pacData) {
      /*** No of visit Calculation Find Configuralbe  ***/
      if (this.checkConfigureEventType(itractionObj.anonymousDischargeId)) {
        /* var visitValue = itractionObj.plannedDdCpDetails.plannedVisit;
        if (visitValue > 0) */

        if (!itractionObj.trackActualVisible) {
          if (!itractionObj.anonymousVisit)
            this.calculateplanedvisitNew(this.selectionItemNoOfVisit, itractionObj)
          itractionObj.visitshowReadonly = true;
          itractionObj.visitShown = true;
        }

        if (itractionObj.trackActualVisible) {
          itractionObj.visitshowReadonly = false;
          itractionObj.visitShown = true;
          // itractionObj.anonymousVisit = "";
        }

      }
      else {
        itractionObj.visitShown = false;
        itractionObj.visitshowReadonly = false;
      }
    }

  }



  onLoadingSetMinandMaxDate(eventData) {
    for (var itractionObj of eventData) {
      this.hospitalStayMinMaxDate(itractionObj);

      if (itractionObj.pacFinished && !itractionObj.hospitalStay)
        this.setTrackMinandMaxDate(itractionObj);

      if (!itractionObj.pacFinished && !itractionObj.hospitalStay)
        this.setPlannedMinandMaxDate(itractionObj);
    }
  }




  /*** GCP , Track Acturl , Follow up with pack etc Highlight start here  *****/

  highlightFields(itractionObj, itractionObjNext) {

    /**  Hightlight GCP */

    if (itractionObj.status == "InProgress" && !itractionObj.trackActualVisible && itractionObj.hospitalStay) {
      if (this.gcpnew && this.showpac) {
        itractionObj.anonymousenddateRedAlert = true;
        itractionObj.trackActualEmptyEndDate = true
        itractionObjNext.anonymouseventTypeRedAlert = true;
        itractionObjNext.anonymousfacilitynameRedAlert = true;
        itractionObjNext.anonymousstartdateRedAlert = true;
        //itractionObj.plannedDdCpDetailsanonymousenddateRedAlert = true;
      }
    }

    /**  Hightlight Follow with Pac */
    if (itractionObj.status == "InProgress" && itractionObj.trackActualVisible && !itractionObj.hospitalStay) {
      if (itractionObj.anonymousDischargeId == 7 || itractionObj.anonymousDischargeId == 6)
        itractionObj.anonymousenddateRedAlert = false;
      else
        itractionObj.anonymousenddateRedAlert = true;
      itractionObj.trackActualEmptyEndDate = true
    }

    /** Follow with other service **/
  }

  defaultSetAttributeForLocalPurpose(item) {
    item.anonymousAdmissionDatemindate = null;
    item.anonymousAdmissionDatemaxdate = null;

    item.anonymousSnfDischargeDatemindate = null;
    item.anonymousSnfDischargeDatemaxdate = null;
    item.anonymousDischargeDatedisable = false;
    item.anonymousSnfDischargeDatedisable = false;
    item.contactVisible = 0;
    item.dischargeCompleted = true;
    item.disableAll = false;

    /* item.anonymouseventTypeRedAlert = false;
    item.anonymousfacilitynameRedAlert = false;
    item.anonymousstartdateRedAlert = false;
    item.anonymousenddateRedAlert = false; */

    item.visitshowReadonly = false;
    item.visitShown = false;

    item.endDateStatusChange = false;
    item.trackActualEmptyEndDate = false;
    item.raUpComingClear = false;

    item.isExistingRaChanged = false
    if (item.anonymousDischargeId == 6 || item.anonymousDischargeId == 9) {
      item.isExistingRaChanged = true
    }
    // item.isExistingEdChanged = item.anonymousDischargeId==9? true: false;
    // item.existingEdDate = item.anonymousDischargeId==9? item.anonymousAdmissionDate: "";
    item.existingReadmissionDate = (item.anonymousDischargeId == 6 || item.anonymousDischargeId == 9) ? item.anonymousAdmissionDate : "";

    // if(item.status != 'Completed'){
    //   item.trackActualVisible = false
    // }
    /* item.plannedDdCpDetails.plannedeventTypeRedAlert = false,
    item.plannedDdCpDetails.plannedfacilitynameRedAlert = false,
    item.plannedDdCpDetails.plannedstartdateRedAlert = false,
    item.plannedDdCpDetails.plannedenddateRedAlert = false */
  }

  assignPlannedtoActual(item) {
    item.anonymousAdmissionDate = item.plannedDdCpDetails.plannedAdmissionDate;
    item.anonymousSnfDischargeDate = item.plannedDdCpDetails.plannedSnfDischargeDate;

    // if(!item.anonymousSnfDischargeDate && item.hospitalStay){
    //   var differDate = this.getPlannedDayInterval(-1);
    //   var differrencePlannedDate = this.addAdditionalDate(item.anonymousAdmissionDate, differDate)
    //   item.anonymousSnfDischargeDate = new Date(differrencePlannedDate);
    //   item.plannedDdCpDetails.plannedSnfDischargeDate = new Date(differrencePlannedDate);
    // }
    item.anonymousDischargeId = item.plannedDdCpDetails.plannedDischargeId;
    item.anonymousDischargeHospitalMasterId = item.plannedDdCpDetails.plannedDischargeHospitalMasterId;


    this.assignActuelORPlanned(item);
  }

  assignActuelORPlanned(item) {
    if (!item.trackActualVisible) {
      item.trackActualVisible = false;
      /* item.anonymousDischargestatus ="Planned";
      item.anonymousDischargeHospitalstatus ="Planned";
      item.anonymousDischargeDatestatus ="Planned";
      item.anonymousSnfDischargeDatestatus ="Planned"; */
    }
    if (item.trackActualVisible) {

      item.trackActualVisible = true;
      /* item.anonymousDischargestatus ="Actual";
      item.anonymousDischargeHospitalstatus ="Actual";
      item.anonymousDischargeDatestatus ="Actual";
      item.anonymousSnfDischargeDatestatus ="Actual"; */
    }
  }

  onVisit(event, item, index, changedItem) {
    if (changedItem == 5 && !item.trackActualEmptyEndDate)
      item.plannedDdCpDetails.plannedVisit = event;
  }
  selectionIndex: number;
  flagAlreadyChooseReadmission: boolean = false;
  EDVisitFlag: boolean = false;
  onROWPACModelChange(event, item, templateother, index, changedItem) {
    this.saveBtnEnable = true
    var differDate, differrencePlannedDate
    if (this.dosstatus) {
      this.dosstatus = false
      this.paramsdos = ''
    }


    if (changedItem == 1 && event == 8) {
      item.actualHspTransfer = 2
      item.plannedDdCpDetails.plannedHspTransfer = 2
    }
    else {
      item.actualHspTransfer = 1
      item.plannedDdCpDetails.plannedHspTransfer = 1
    }
    /** Remove Red Alert from field */
    if (changedItem == 1) {
      item.anonymouseventTypeRedAlert = false;
      item.anonymousstartdateRedAlert = false;
    }
    if (changedItem == 2) { item.anonymousfacilitynameRedAlert = false; }
    if (changedItem == 3) { item.anonymousstartdateRedAlert = false; }
    if (changedItem == 4) { item.anonymousenddateRedAlert = false; }


    // if(changedItem==1 && item.anonymousDischargeId!=6 && item.raIdentity){
    //   item.raIdentity = '';
    // }




    /** If change Event Type,  Remove Facility Event Value  */
    if (changedItem == 1 && !item.trackActualEmptyEndDate) {
      item.plannedDdCpDetails.plannedDischargeHospitalMasterId = "";



      /* item.visitShown = true;
      else
        item.visitShown = false; */

      if (!item.trackActualVisible && !item.hospitalStay && item.anonymousAdmissionDate && item.anonymousDischargeId != 6 && item.anonymousDischargeId != 9) {
        differDate = this.getPlannedDayInterval(item.anonymousDischargeId);
        differrencePlannedDate = this.addAdditionalDate(item.anonymousAdmissionDate, differDate)
        item.anonymousSnfDischargeDate = new Date(differrencePlannedDate);
        item.plannedDdCpDetails.plannedSnfDischargeDate = differrencePlannedDate
      }
    }

    if (item.anonymousDischargeId == 5 && changedItem == 1) {
      this.openModelpop1(templateother, item);
    }

    this.selectionIndex = index;

    /* if (changedItem == 3 && !item.trackActualVisible) {
      // this.PACEventsData[index].anonymousSnfDischargeDate
       item.anonymousSnfDischargeDate = new Date(this.addAdditionalDate(event, this.configuredate))
    } */



    if (changedItem == 1 && !item.hospitalStay) {
      item.anonymouseventTypeRedAlert = false;
      if (item.anonymousDischargeId == 7 || item.anonymousDischargeId == 5)
        item.anonymousfacilitynameRedAlert = false;
      /* else
      item.anonymousfacilitynameRedAlert=true; */
    }

    if (changedItem == 3 && !item.hospitalStay) {
      item.anonymousstartdateRedAlert = false;
    }

    //Hospital Stay discharge date change
    if (event && changedItem == 4 && item.hospitalStay) {
      /* this.PACEventsData[index + 1].trackActualVisible = true;

      this.PACEventsData[index + 1].anonymousPlanningType = "Actual";
      this.PACEventsData[index + 1].anonymousDischargeId = '';
      this.PACEventsData[index + 1].anonymousDischargeHospitalMasterId = '';
      this.PACEventsData[index + 1].anonymousSnfDischargeDate = '';
      this.PACEventsData[index + 1].anonymousLos = 0;
      this.PACEventsData[index + 1].status = "InProgress"; */







      this.changeToDischargeComplete(this.PACEventsData);
      //this.PACEventsData[index].status = 'InProgress';
    }




    /** Completed Status Change Functionality **/
    if (item.trackActualVisible && changedItem) {
      item.endDateStatusChange = true;
    }

    //get status backup when give future date validation
    if (changedItem == 4 && !item.backupStauts) {
      item.backupStauts = item.status;
    }

    /***  Without Track Actual change value assign to planned  **/
    setTimeout(() => {


      /*** No of visit show bases on  Configurable Event Type */



      /*  if(this.PACEventsData.length >=2)
      {
          if(changedItem==4 && item.hospitalStay && !this.PACEventsData[index+1].trackActualVisible)
          {
              let minDate4 = this.changeStringFormatToDate(this.getAppliedDischargeDate());
              this.PACEventsData[index+1].anonymousAdmissionDatemindate = this.changeToDate(minDate4);
              this.PACEventsData[index+1].anonymousSnfDischargeDatemindate = this.changeToDate(minDate4);
          }
      } */


      if (!this.checkplannedFutureDate(item, changedItem)) {
        if (item.hospitalStay) {
          this.toast.error(this.userService.translateText('patient_portal.display_messages.actual_discarge_date_dos'), '', {
            timeOut: this.timealert
          })
        }
        else {
          this.toast.error(this.userService.translateText('patient_portal.display_messages.the_actual_end_date'), '', {
            timeOut: this.timealert
          })
        }
        setTimeout(() => {
          this.saveBtnEnable = false
        }, 3000);
        return;
      }


      if (changedItem == 4) {
        if (!this.checkFutureDate(item)) {
          if (item.hospitalStay) {
            this.toast.error(this.userService.translateText('patient_portal.display_messages.actual_discarge_date_dos'), '', {
              timeOut: this.timealert
            })
          }
          else {
            this.toast.error(this.userService.translateText('patient_portal.display_messages.the_actual_end_date'), '', {
              timeOut: this.timealert
            })
          }
          setTimeout(() => {
            this.saveBtnEnable = false
          }, 3000);
          return "";
        }
      }


      if (this.PACEventsData.length >= 2 && this.PACEventsData.length - 1 > index && changedItem == 4 && item.hospitalStay) {
        if (!this.PACEventsData[index + 1].trackActualVisible) {
          this.PACEventsData[index + 1].anonymousAdmissionDate = new Date(event);
          this.PACEventsData[index + 1].plannedDdCpDetails.plannedAdmissionDate = new Date(event);
        }
      }

      /**** Open Readmission popup for clear confirmation  *(***/
      if (changedItem == 3 || changedItem == 1 || changedItem == 2 || changedItem == 4) {


        /***If choose readmissin all are changed actual, Again change to another event type re change to Planned start Here*****/
        if (this.flagAlreadyChooseReadmission && (item.anonymousDischargeId != 6 && item.anonymousDischargeId != 9) && item.status != 'Completed') {
          this.flagAlreadyChooseReadmission = false;
          item.trackActualVisible = false;
          item.hospitalRA = false;
          item.pacFinished = false;
          item.trackActualEmptyEndDate = false;
          item.plannedDdCpDetails.plannedAdmissionDate = item.anonymousAdmissionDate;
          item.plannedDdCpDetails.plannedSnfDischargeDate = item.anonymousSnfDischargeDate
          // item.anonymousDischargeHospitalMasterId = "";
          // item.anonymousAdmissionDatemaxdate = "";
          // item.anonymousSnfDischargeDatemaxdate = "";
          //item.anonymousAdmissionDate = "";
          //item.anonymousDischargeId = "";
          // item.anonymousSnfDischargeDate = "";
          // item.anonymousAdmissionDateFm="";
          // item.anonymousSnfDischargeDateFm="";
          item.anonymousVisit = "";
          item.anonymousLos = 0;
          //null min max date

          item.status = "UpComing";
          this.changeCurrentState();
        }

        if (item.edvisitFlag && changedItem == 1 && item.anonymousDischargeId != 9 && item.status != 'Completed') {

          item.edvisitFlag = false;
          item.trackActualVisible = false;
          item.pacFinished = false;
          item.trackActualEmptyEndDate = false;
          item.plannedDdCpDetails.plannedAdmissionDate = item.anonymousAdmissionDate;
          item.plannedDdCpDetails.plannedSnfDischargeDate = item.anonymousSnfDischargeDate;
          item.anonymousVisit = "";
          item.anonymousLos = 0;
          item.status = "UpComing";
          this.changeCurrentState();
        }

        if ((item.anonymousDischargeId == 6 || item.anonymousDischargeId == 9) && changedItem == 3) {
          if (this.isUpdateReadmitDateFromPatient(item, index))
            this.openReadmissionPopUp(item, index);
        }


        if ((item.anonymousDischargeId == 6 || item.anonymousDischargeId == 9) && changedItem == 1)
          this.isUpdateReadmitDateFromPatient(item, index)


        if (item.anonymousDischargeId == 6 && changedItem == 1)
          item.anonymousSnfDischargeDate = "";


        if (item.anonymousDischargeId == 6) {
          if (this.isDishargeCompleted()) {
            if (changedItem == 4 && !item.trackActualVisible) {
              this.flagAlreadyChooseReadmission = true;
              // item.trackActualVisible = true;
              item.hospitalRA = true;
              // item.pacFinished = true;
              // item.trackActualEmptyEndDate = true;
            }
            else if ((changedItem == 1) && !item.pacFinished) {

              this.flagAlreadyChooseReadmission = true;
              item.trackActualVisible = true;
              item.hospitalRA = true;
              // item.pacFinished = true;
              item.trackActualEmptyEndDate = true;
              if (!item.plannedDdCpDetails.plannedDischargeId || !item.plannedDdCpDetails.plannedDischargeHospitalMasterId) {
                item.plannedDdCpDetails.plannedDdCpDetails = ""
                item.plannedDdCpDetails.plannedDischargeDate = "";
                item.plannedDdCpDetails.plannedSnfDischargeDate = "";
                item.plannedDdCpDetails.plannedDischargeId = 0;
                item.plannedDdCpDetails.plannedDischargeHospitalMasterId = 0;
                item.plannedDdCpDetails.plannedLos = "";
                item.plannedDdCpDetails.plannedAdmissionDate = "";
                item.plannedDdCpDetails.plannedVisit = "";
                item.plannedDdCpDetails.plannedOtherSelectedName = "";
                item.plannedDdCpDetails.plannedDischargeTypeForOther = "";
              }
            }
            if (changedItem == 3 && !item.trackActualVisible) {

              differDate = this.getPlannedDayInterval(item.anonymousDischargeId)
              differrencePlannedDate = this.addAdditionalDate(item.anonymousAdmissionDate, differDate)
              item.anonymousSnfDischargeDate = new Date(differrencePlannedDate);
              item.pacFinished = false;
              item.trackActualEmptyEndDate = false;
            }


            /* if(item.pacFinished) */
            this.readmissionDateMinMax(item);

            //  set max date

          } else {
            item.anonymousDischargeId = "";
            item.anonymousDischargeHospitalMasterId = "";
            if (item.backupStauts) {
              item.status = item.backupStauts;
            }
            this.toast.error(this.userService.translateText('patient_portal.display_messages.we_cant_assign_readmission'), '', {
              timeOut: this.timealert
            })
          }
          //this.setTrackMinandMaxDate(item);
        }



        // ED Visit
        if (changedItem == 1 && item.anonymousDischargeId == 9) {
          if (this.isDishargeCompleted()) {
            if (changedItem == 1 && !item.pacFinished) {
              item.edvisitFlag = true;
              item.anonymousSnfDischargeDate = "";
              item.trackActualVisible = true;
              // item.pacFinished = true;
              item.trackActualEmptyEndDate = true;
              if (!item.plannedDdCpDetails.plannedDischargeId || !item.plannedDdCpDetails.plannedDischargeHospitalMasterId) {
                item.plannedDdCpDetails.plannedDdCpDetails = ""
                item.plannedDdCpDetails.plannedDischargeDate = "";
                item.plannedDdCpDetails.plannedSnfDischargeDate = "";
                item.plannedDdCpDetails.plannedDischargeId = 0;
                item.plannedDdCpDetails.plannedDischargeHospitalMasterId = 0;
                item.plannedDdCpDetails.plannedLos = "";
                item.plannedDdCpDetails.plannedAdmissionDate = "";
                item.plannedDdCpDetails.plannedVisit = "";
                item.plannedDdCpDetails.plannedOtherSelectedName = "";
                item.plannedDdCpDetails.plannedDischargeTypeForOther = "";
              }
              if (!item.backupStauts && item.status != "ReAdmitPending") {
                item.backupStauts = item.status;
              }
            }
          }
          else {

            item.anonymousDischargeId = "";
            item.anonymousDischargeHospitalMasterId = "";
            if (item.backupStauts) {
              item.status = item.backupStauts;
            }
            this.toast.error(this.userService.translateText('patient_portal.display_messages.cant_assign_ED_without_dishcarge.error'), '', {
              timeOut: this.timealert
            })
          }


          /* if(item.pacFinished) */
          this.readmissionDateMinMax(item);
        }





        /***If choose readmissin all are changed actual, Again change to another event type re change to Planned start Here*****/


        if (changedItem == 4 && (item.anonymousDischargeId == 6 || item.anonymousDischargeId == 9) && (item.anonymousSnfDischargeDate && item.anonymousSnfDischargeDate != 'Invalid Date'))
          this.readmissionDetails(this.readmissionReasonPopup, item, index);

      }

      /*  if(item.anonymousDischargeId==4 || item.anonymousDischargeId==2 || item.anonymousDischargeId==3 || item.anonymousDischargeId==3)
       { */
      if (changedItem == 1) {
        item.anonymousDischargeHospitalMasterId = "";
        item.raOtherHspName = "";
      }
      /*  } */


      this.contactDetailsEnable(item);

      /* if(item.anonymousDischargeId!="" )
      {
        if(item.anonymousDischargeId==4 || item.anonymousDischargeId==2 || item.anonymousDischargeId==3)
          item.contactVisible =1;
        else if(item.anonymousDischargeId==6)
          item.contactVisible =2;
        else
          item.contactVisible =0;
      } */



      this.changedPlannedValue(item, changedItem);

      /**** If change Start Date or End Date Calculate the LOS Value  ****/
      if (changedItem == 3 || changedItem == 4) {

        var differenceDate = this.differenceTwoDate(this.changeFormatToDate(item.anonymousAdmissionDate), this.changeFormatToDate(item.anonymousSnfDischargeDate));
        item.anonymousLos = differenceDate;

        if (!item.trackActualVisible)
          item.plannedDdCpDetails.plannedLos = differenceDate;

        if (item.trackActualVisible && !item.pacFinished && changedItem == 4 && item.trackActualEmptyEndDate) {
          item.trackActualEmptyEndDate = true;
          item.pacFinished = true;
        }

        if (item.trackActualVisible && !item.pacFinished && changedItem == 4)
          item.plannedDdCpDetails.plannedSnfDischargeDate = item.anonymousSnfDischargeDate;

        /*** If change     Start Date,  set mindate for End Date ***/


        if (changedItem == 3) {
          var changedFormat = this.changeFormatToDate(item.anonymousAdmissionDate);
          //this.Datepipe.transform(item.anonymousDischargeDate, 'MM/dd/yyyy');
          item.anonymousSnfDischargeDatemindate = this.changeToDate(changedFormat);


          if (item.hospitalStay) {
            var dobDiff = this.findPastorFutureDate(this.changeFormatToDate(this.user.dob), this.changeFormatToDate(item.anonymousAdmissionDate));
            if (dobDiff) {
              this.toast.error(this.userService.translateText('patient_portal.display_messages.dos_can_track_after_dob.error'), '', {
                timeOut: this.timealert
              })
              this.saveBtnEnable = true
              item.anonymousstartdateRedAlert = true;
              return false;
            }
            else if (item.anonymousAdmissionDate)
              this.carePath.dos = item.anonymousAdmissionDate;
            if (!item.pacFinished)
              this.onTopDOSDateChange();
            this.hospitalStayMinMaxDate(item);
            /**** Comes Hererer */
          }
        }

        this.onDOSChangePacEventValidate();

        /*** Highlight THD ****/
        if (changedItem == 4 && item.hospitalStay && item.trackActualVisible && this.PACEventsData.length >= 2) {
          /* this.PACEventsData[index+1].anonymousstartdateRedAlert=true; */
          item.anonymousenddateRedAlert = false

          /* this.PACEventsData[index+1].anonymouseventTypeRedAlert=true;
          this.PACEventsData[index+1].anonymousfacilitynameRedAlert=true; */

          let minDate3 = this.changeFormatToDate(this.getAppliedDischargeDate());
          this.PACEventsData[index + 1].anonymousAdmissionDatemindate = this.changeToDate(minDate3);

          let minDate2 = this.PACEventsData[index + 1].anonymousAdmissionDate;
          this.PACEventsData[index + 1].anonymousSnfDischargeDatemindate = this.changeToDate(minDate2);

          if (!this.PACEventsData[index + 1].trackActualVisible) {
            this.PACEventsData[index + 1].anonymousAdmissionDatemaxdate = null;
            this.PACEventsData[index + 1].anonymousSnfDischargeDatemaxdate = null;
          }
        }
      }

      if (changedItem == 4 && item.hospitalStay && item.trackActualVisible && item.pacFinished) {
        item.status = "Completed";
        this.changeToDischargeComplete(this.PACEventsData);
      }


      if (changedItem == 3 && item.hospitalStay)
        this.onPacEventHospitalStayValidationDOS()



      // if(changedItem==4 && item.trackActualVisible && item.visitShown){
      //   item.anonymousVisit = "";
      // }
      this.doCompleteEvent(item);
      this.findCurrentState();


      //Planned Start Date Change End automatically chnage
      if ((changedItem == 3 || changedItem == 1) && !item.pacFinished && item.anonymousSnfDischargeDate && item.anonymousDischargeId) {
        differDate = this.getPlannedDayInterval(item.anonymousDischargeId);
        differrencePlannedDate = this.addAdditionalDate(item.anonymousAdmissionDate, differDate)
        item.anonymousSnfDischargeDate = new Date(differrencePlannedDate);
        item.plannedDdCpDetails.plannedSnfDischargeDate = differrencePlannedDate
        item.anonymousenddateRedAlert = false
      }

      if (changedItem == 1) {
        item.anonymousVisit = "";
      }

      this.setCalculateLOS(item);


      this.noOfVisitFuntinality(item);

      // if(changedItem==4){
      //   if(item.anonymousSnfDischargeDate > item.anonymousSnfDischargeDatemaxdate){
      //     alert("Call")
      //     item.anonymousSnfDischargeDate = null;
      //   }
      // }
      // this.checkempty12(event,item)
      // if(changedItem==3 && item.anonymousDischargeId==6){
      //   if(!this.isFindReadmitDuplicateDate(item,index)){
      //     item.anonymousAdmissionDate = "";
      //     item.anonymousstartdateRedAlert = true
      //     this.toast.error("Already readmission scheduled in this date", '', {
      //       timeOut: this.timealert
      //     })
      //   }
      // if(changedItem==4)  {
      //   if(item.anonymousSnfDischargeDate && item.anonymousAdmissionDate){
      //     if(new Date(item.anonymousSnfDischargeDate) > new Date(item.anonymousAdmissionDate)){
      //       item.trackActualEmptyEndDate =false;
      //     }
      //   }
      // }
      // }
    }, 100);

    //Clear Other Property value
    if (changedItem == 1) {
      this.clearOtherPropertyValues(item);
    }

    if (this.saveBtnEnable && this.saveBtnClick) {
      this.saveBtnClick = !this.saveBtnClick
      this.saveBtnEnable = !this.saveBtnEnable
      this.triggerBtnClick();
    }

  }
  saveBtnClick: boolean = false
  @ViewChild('btnSave') btnSave: ElementRef;
  triggerBtnClick() {
    let el: HTMLElement = this.btnSave.nativeElement;
    el.click();
  }
  @HostListener('document:click', ['$event'])
  btnClick(event) {
    let self = this
    //Commented as this point is not taken now
    $(document).on('click', 'a', function (e) {
      if (event.target.class == 'save_btnss') {
        self.saveBtnClick = true
      }
    })
  }

  changeToDischargeComplete(data) {
    if (this.isDishargeCompleted()) {
      for (var item of data) {
        item.dischargeCompleted = true;
      }
    }
  }

  readmissionDateMinMax(item) {
    let minDate3 = this.changeFormatToDate(this.getAppliedDischargeDate());
    item.anonymousAdmissionDatemindate = this.changeToDate(minDate3);

    let minDate2 = this.changeFormatToDate(item.anonymousAdmissionDate);
    item.anonymousSnfDischargeDatemindate = this.changeToDate(minDate2);


    // item.anonymousAdmissionDatemaxdate = new Date();
    // alert("Set Max Date" + item.anonymousAdmissionDatemaxdate)

    item.anonymousAdmissionDatemaxdate = new Date();
    item.anonymousSnfDischargeDatemaxdate = new Date();
  }


  readmissionPopup: any;
  readmissionTemObj: any;
  openReadmissionPopUp(item, index) {
    // if(this.isUpdateReadmitDateFromPatient(item,index))
    {
      this.readmissionTemObj = item;
      if (this.findUpcoming()) {
        this.readmissionPopup = this.modalService.show(this.readmissionTemplatepopup, {
          class: 'modal-sm',
          backdrop: 'static'
        })
        this.movable()
      }
    }
  }

  isReadmissionAvailable: any;
  isUpdateReadmitDateFromPatient(item, index) {
    if (this.isFindReadmitDuplicateDate(item, index) && this.isFindEdvisitDuplicateDate(item, index)) {
      var readmissionDateStr;
      if (item.anonymousAdmissionDate == '' || item.anonymousAdmissionDate == null || item.anonymousAdmissionDate == 'Invalid Date') {
        readmissionDateStr = ""
      }
      else {
        item.anonymousAdmissionDate = new Date(item.anonymousAdmissionDate)
        readmissionDateStr = this.changeStringFormat2(item.anonymousAdmissionDate)
      }
      /*** Check Is Readmission Date is Same Date in server */
      let fulldata = {
        "hospitalId": item.anonymousDischargeHospitalMasterId,
        "otherHospitalName": "",
        "otherReason": "",
        "patientReadmissionId": item.readmissionId,
        "readmissionDateStr": readmissionDateStr,
        "reason": "",
        "visitType": ""
      }
      this.userService.cheReadm(this.user.patientSWFId, fulldata).subscribe(
        (data) => {

          this.isReadmissionAvailable = data;
          if (this.isReadmissionAvailable.isSameReadmission) {
            item.anonymousDischargeId = "";
            item.anonymousstartdateRedAlert = true
            this.toast.error(this.userService.translateText('patient_portal.display_messages.already_scheduled_date.error'), '', {
              timeOut: this.timealert
            })
            return false
          }
        });

    } else {
      item.anonymousDischargeId = "";
      item.anonymousstartdateRedAlert = true
      this.toast.error(this.userService.translateText('patient_portal.display_messages.already_scheduled_date.error'), '', {
        timeOut: this.timealert
      })
      return false
    }
    if (!item.backupStauts) {
      item.backupStauts = item.status;
    }
    if (item.anonymousDischargeId == 6)
      item.status = "ReAdmitPending"
    else if (item.anonymousDischargeId == 9)
      item.status = "EdPending"

    return true
  }

  isFindEdvisitDuplicateDate(item, index) {
    for (var i = 0; i < this.PACEventsData.length; i++) {
      if (this.PACEventsData[i].anonymousDischargeId == 9 && i != index) {
        let date1 = new Date(this.changeFormatToDate(item.anonymousAdmissionDate));
        let date2 = new Date(this.changeFormatToDate(this.PACEventsData[i].anonymousAdmissionDate));
        var count = this.differenceTwoDate(date1, date2);
        if (count == 0)
          return false;
      }
    }
    return true;
  }


  isFindReadmitDuplicateDate(item, index) {
    for (var i = 0; i < this.PACEventsData.length; i++) {
      if (this.PACEventsData[i].anonymousDischargeId == 6 && i != index) {
        let date3 = new Date(this.changeFormatToDate(item.anonymousAdmissionDate));
        let date4 = new Date(this.changeFormatToDate(this.PACEventsData[i].anonymousAdmissionDate));
        var counter = this.differenceTwoDate(date3, date4);

        if (counter == 0)
          return false;
      }
    }
    return true;
  }


  findUpcoming() {
    for (var item of this.PACEventsData) {
      if (item.status == "UpComing" && item.anonymousDischargeId != 6)
        return true;
    }
    return false;
  }

  readmissionTemplatepopup: any;
  readmissionReasonPopup: any;
  readmissionReasonFlag: boolean = true;
  readmissionTemplate(template, template1) {
    this.readmissionReasonFlag = false;
    this.readmissionTemplatepopup = template;
    this.readmissionReasonPopup = template1;
  }
  cancelReadmissionPopup() {
    this.readmissionPopup.hide()
  }
  clearReadmissionValue() {
    this.readmissionTemObj.raUpComingClear = true;
    this.clearAllUpcomingData();
    this.readmissionPopup.hide()
  }

  clearAllUpcomingData() {
    for (var i = this.PACEventsData.length - 1; i >= 0; i--) {
      if (this.PACEventsData[i].status == "UpComing" && this.PACEventsData[i].anonymousDischargeId != 6)
        this.PACEventsData.splice(i, 1);
    }

  }

  loadStatus(status) {
    if(status == "Completed") return this.userService.translateText('hospital_portal.mytodos.completed.label')
    if(status == "Actual") return this.userService.translateText('hospital_portal.summary.actual.label')
    return status;
  }

  raBackupStatus: any;
  doCompleteEvent(item) {

    /*  alert(item.anonymousDischargeId); */

    if (item.trackActualVisible) {
      if (item.anonymousSnfDischargeDate != "" && item.anonymousSnfDischargeDate != "Invalid Date" && item.anonymousAdmissionDate != "" && item.anonymousDischargeId != "" && item.anonymousDischargeHospitalMasterId != "" && item.anonymousDischargeId != 7 && item.anonymousDischargeId != 5) {
        this.raBackupStatus = item.status;

        if (item.trackActualVisible && item.trackActualEmptyEndDate && item.pacFinished)
          item.status = "Completed";

        if (item.hospitalStay)
          this.trackAcutualCompleted = true;
      }

      /***Home Out Service and Other */
      if (item.anonymousSnfDischargeDate != "" && item.anonymousAdmissionDate != "" && item.anonymousDischargeId != "") {
        if (item.anonymousDischargeId == 7 || item.anonymousDischargeId == 5 || item.anonymousDischargeId == -2) {
          if (item.trackActualVisible && item.trackActualEmptyEndDate && item.pacFinished)
            item.status = "Completed";

          if (item.hospitalStay)
            this.trackAcutualCompleted = true;
        }
      }
    }
  }


  facilityTempObj: any;
  onChangeO(id, showpopup, showpopup2, temp, item, type) {
    ////console.log(temp)
    this.temp = temp
    this.facilityTempObj = item;
    let index = _.findIndex(this.temp, (o: any): any => {
      return o.dischargeId == id
    })

    // if(item.anonymousDischargeId){
    //   item.plannedDdCpDetails.plannedDischargeId =
    // }


    if (index != -1) {
      ////console.log(this.temp[index].dischargeTo)
      if (this.temp[index].dischargeTo == "*Other" || this.temp[index].dischargeTo == "Other") {
        if (!item.trackActualVisible)
          this.openModelpop(showpopup, item)
        else
          this.openModelpop2(showpopup2, item)

      }



      setTimeout(() => {
        this.changedPlannedValue(item, type);
        if (this.temp[index].dischargeTo != "*Other" || this.temp[index].dischargeTo != "Other")
          this.doCompleteEvent(item);
        this.contactDetailsEnable(item);
      }, 100);
    }

    if (type == 2 && !item.hospitalStay) {
      item.anonymousfacilitynameRedAlert = false;
    }
    //this.changedPlannedValue(item);
  }


  /** Contact I Icon Enable  and Disable start Here */
  contactDetailsEnable(item) {
    if (item.anonymousDischargeId != "" && item.anonymousDischargeHospitalMasterId != "") {
      if (item.anonymousDischargeId == 4 || item.anonymousDischargeId == 2 || item.anonymousDischargeId == 3)
        item.contactVisible = 1;
      else if (item.anonymousDischargeId == 6 || item.anonymousDischargeId == 9)
        item.contactVisible = 2;
      else
        item.contactVisible = 0;
    } else
      item.contactVisible = 0;
  }

  contactsIIconEnable(data) {

    for (var item of data) {
      if (item.anonymousDischargeId == 4 || item.anonymousDischargeId == 2 || item.anonymousDischargeId == 3 || item.anonymousDischargeId == 6) {
        if (item.anonymousDischargeId != "" && item.anonymousDischargeHospitalMasterId != "") {
          if (item.anonymousDischargeId == 4 || item.anonymousDischargeId == 2 || item.anonymousDischargeId == 3)
            item.contactVisible = 1;
          else if (item.anonymousDischargeId == 6 || item.anonymousDischargeId == 9)
            item.contactVisible = 2;
          else
            item.contactVisible = 0;
        }
      }


    }
  }


  templateother: any;
  facilityContact: any;

  templateOtherPopupObj: any;
  facilityOtherPopupObj: any;
  oTherContactDetails(templateother, showpopup2, item, i) {
    this.templateother = templateother;
    this.facilityContact = showpopup2;

    /*  if(item.anonymousDischargeId==-2)
      this.ModelRef = this.Modalservice.show(this.templateother , { class: 'modal-md small', backdrop: 'static' }) */


    /* if(item.anonymousDischargeHospitalMasterId==-2)
      this.facilityOtherPopupObj = this.Modalservice.show(this.facilityContact , { class: 'modal-md small', backdrop: 'static' }) */

  }

  /** Contact I Icon Enable and Disable End Here */



  openModelpop2(showpopup2: TemplateRef<any>, item) {
    let self = this;
    this.tempobj1 = item
    this.ModelRef4 = self.Modalservice.show(showpopup2, { class: 'modal-md', backdrop: 'static' })
    this.movable()
  }

  changedPlannedValue(item, type) {
    if (!item.trackActualVisible) {
      if (type == 3)
        item.plannedDdCpDetails.plannedAdmissionDate = item.anonymousAdmissionDate;
      else if (type == 4 && item.anonymousSnfDischargeDate)
        item.plannedDdCpDetails.plannedSnfDischargeDate = item.anonymousSnfDischargeDate;
      else if (type == 1)
        item.plannedDdCpDetails.plannedDischargeId = item.anonymousDischargeId;
      else if (type == 2)
        item.plannedDdCpDetails.plannedDischargeHospitalMasterId = item.anonymousDischargeHospitalMasterId;


    }
    this.assignActuelORPlanned(item);
  }

  pacEventBtnDisable: boolean = false;
  addPACEvent() {
    let tempCopyObj = JSON.parse(JSON.stringify(this.singlePACEvent))

    if (this.isDishargeCompleted())
      tempCopyObj.dischargeCompleted = true;
    else
      tempCopyObj.dischargeCompleted = false;

    var chekVal = this.checkCurrentOrUpcoming();
    if (chekVal)
      tempCopyObj.status = "UpComing";
    else
      tempCopyObj.status = "InProgress";


    tempCopyObj.id = this.PACEventsData.length + 1;
    var tmpLastObject = this.PACEventsData[this.PACEventsData.length - 1];




    // this.Datepipe.transform(addConfigureDate, 'MM/dd/yyyy');


    if (tmpLastObject?.anonymousSnfDischargeDate == "") {
      tempCopyObj.anonymousAdmissionDate = new Date(tmpLastObject.plannedDdCpDetails.plannedSnfDischargeDate);
      tempCopyObj.plannedDdCpDetails.plannedAdmissionDate = tmpLastObject.plannedDdCpDetails.plannedSnfDischargeDate;
      tempCopyObj.plannedDdCpDetails.plannedSnfDischargeDate = "";
    }
    else {
      tempCopyObj.anonymousAdmissionDate = tmpLastObject?.anonymousSnfDischargeDate;
      tempCopyObj.plannedDdCpDetails.plannedAdmissionDate = tmpLastObject?.anonymousSnfDischargeDate;
      tempCopyObj.plannedDdCpDetails.plannedSnfDischargeDate = "";
    }


    this.addAdditionalDate(tempCopyObj.anonymousAdmissionDate, this.configuredate);


    tempCopyObj.anonymousLos = "0";
    tempCopyObj.plannedDdCpDetails.plannedLos = "0";


    this.PACEventsData.push(tempCopyObj);


    /*** Set min and Max Date for new event  star Date and End Date ***/

    this.setPlannedMinandMaxDate(tempCopyObj);

    /* let minDate = this.changeStringFormatToDate(this.DOSDate);
     tempCopyObj.anonymousAdmissionDatemindate = this.changeToDate(minDate);
     let minDateForEndDate = this.changeStringFormatToDate(tempCopyObj.anonymousAdmissionDate);
     tempCopyObj.anonymousSnfDischargeDatemindate = this.changeToDate(minDateForEndDate);*/


    /* } else {
      this.toast.error("Invalidate Event", '', {
        timeOut: this.timealert
      })
    } */


  }


  checkCurrentOrUpcoming() {
    for (var item of this.PACEventsData) {
      if (item.status == "InProgress" || item.status == "UpComing")
        return true;
    }
    return false;
  }



  changeStringFormatToDate(dateString) {

    var changedFormat;
    try {
      changedFormat = this.Datepipe.transform(dateString, 'MM/dd/yyyy');
    } catch (Exception) {
      return changedFormat;
    }
    return changedFormat;
  }
  changeFormatToDate(dateString) {
    if (dateString != '' && dateString != null && dateString != 'Invalid Date') {
      var changedFormat;
      if (this.currentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
        var splitDate1 = dateString.split('/');
        if (splitDate1.length > 1) {
          var day1 = splitDate1[0];
          var month1 = splitDate1[1];
          var year1 = splitDate1[2];
          changedFormat = month1 + "/" + day1 + "/" + year1;
          return changedFormat
        } else {
          var date: any = dateString
          return new Date(date)
        }
      } else {
        return new Date(dateString)
      }
    }
  }

  changeStringFormat2(dateString) {
    var dStartDate
    var changedFormat = '';

    var date: any = new Date(dateString)
    if (date != '' && date != null && date != 'Invalid Date') {
      changedFormat = this.Datepipe.transform(dateString, 'yyyy-MM-dd');
    } else if (date == 'Invalid Date' && dateString != 'Invalid Date' && dateString != undefined) {
      if (this.currentUser.item.language == 'en_uk') {
        if (dateString) {
          var splitDate1 = dateString.split('/');
          var day1 = splitDate1[0];
          var month1 = splitDate1[1];
          var year1 = splitDate1[2];
          dStartDate = month1 + "/" + day1 + "/" + year1;
        }
      }
      if (dStartDate) {
        changedFormat = this.Datepipe.transform(dStartDate, 'yyyy-MM-dd');
      }
    }
    return changedFormat
  }



  changeToDate(dateValue) {
    return new Date(dateValue);
  }

  differenceTwoDate(StratDate, endDate) {
    var oneDay = 24 * 60 * 60 * 1000;

    /* let date1 = new Date(new Date(item.anonymousAdmissionDate).setHours(0, 0, 0, 0));
    let date2 = new Date(new Date(this.PACEventsData[i].anonymousAdmissionDate).setHours(0, 0, 0, 0)); */
    let date1 = new Date(this.changeFormatToDate(StratDate))
    let date2 = new Date(this.changeFormatToDate(endDate))
    var firstDate = new Date(date1.setHours(0, 0, 0, 0));
    var secondDate = new Date(date2.setHours(0, 0, 0, 0));
    var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
    return diffDays;
  }

  diffdate: Date;
  addAdditionalDate(StratDate, addDateVal) {
    if (StratDate == "")
      return "";
    var date = this.changeFormatToDate(StratDate)
    if (date && date != "Invalid Date") {
      this.diffdate = new Date(date.setHours(0, 0, 0, 0));
      //console.log(this.diffdate)
      this.diffdate.setDate(this.diffdate.getDate() + Number(addDateVal));
    }
    return this.diffdate;
  }


  test: any;
  disableADDPACEvent() {

    if (this.PACEventsData.length > 0) {


      var tempFirstObj = this.PACEventsData[this.PACEventsData.length - 1];

      if (this.PACEventsData.length == 2) {

        if (tempFirstObj.anonymousAdmissionDate == "" || tempFirstObj.anonymousSnfDischargeDate == "")
          return false;
        else
          return true
      }

      if (this.PACEventsData.length > 2) {

        if (tempFirstObj.anonymousDischargeId != "") {

          if (tempFirstObj.anonymousDischargeId == 7) {
            if (tempFirstObj.anonymousAdmissionDate == "" || tempFirstObj.anonymousSnfDischargeDate == "")
              return false;
            else
              return true;
          } else {
            if (tempFirstObj.anonymousAdmissionDate == "" || tempFirstObj.anonymousSnfDischargeDate == "" || tempFirstObj.anonymousDischargeId == "" || tempFirstObj.anonymousDischargeHospitalMasterId == "")
              return false;
            else
              return true;
          }
        } else
          return false;
        //if(tempFirstObj.anonymousAdmissionDate=="" || tempFirstObj.anonymousSnfDischargeDate=="" ||)

      }


      /* if(tempFirstObj.hospitalStay)
      {
        if(tempFirstObj.anonymousAdmissionDate=="" || tempFirstObj.anonymousSnfDischargeDate=="")
          return false;

      }else
      {
         if(tempFirstObj.anonymousAdmissionDate=="" || tempFirstObj.anonymousSnfDischargeDate=="" || tempFirstObj.anonymousDischargeId=="" || tempFirstObj.anonymousDischargeHospitalMasterId=="")
           return false;
      } */


      return true;
    }
    return true;
  }

  /**** If Hospital Stay, Set Min Data and Max Date ****/
  hospitalstayTrackActual(item) {

    if (item.hospitalStay && item.trackActualVisible) {
      //item.anonymousSnfDischargeDate = "";

      //let today = this.Datepipe.transform(new Date(), 'MM/DD/YYYY');

      let minDate = this.changeFormatToDate(item.plannedDdCpDetails.plannedAdmissionDate);

      //this.Datepipe.transform(, 'MM/dd/yyyy');

      item.anonymousSnfDischargeDatemindate = new Date(minDate);
      item.anonymousSnfDischargeDatemaxdate = new Date();

    }

    if (item.hospitalStay && !item.trackActualVisible) {
      let minDate = this.changeFormatToDate(item.anonymousAdmissionDate);
      //this.Datepipe.transform(item.anonymousDischargeDate, 'MM/dd/yyyy');
      item.anonymousSnfDischargeDatemindate = new Date(minDate);
      item.anonymousSnfDischargeDatemaxdate = null;

      item.plannedDdCpDetails.plannedLos = item.anonymousLos;
    }

    if (item.hospitalStay)
      item.anonymousDischargeDatedisable = true;
  }

  public autoAdjust = { "autoAdjustBtn": true }
  public deleteEmpty = { "deleteEmpty": true }

  autoAdjustPACEvent() {
    //alert("Auto Fill PAC Functionality Comes here" + this.autoAdjust.autoAdjustBtn);
  }

  //test:any;
  manualPACEvent() {
    //this.test = JSON.stringify(this.PACEventsData);
  }

  trackActual(item) {


    if (item.anonymousDischargeId && item.anonymousDischargeHospitalMasterId && item.plannedDdCpDetails.plannedAdmissionDate && !item.plannedDdCpDetails.plannedSnfDischargeDate) {
      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.please_fill_missing.error'), '', {
        timeOut: this.timealert
      })
      item.anonymousenddateRedAlert = true;
      return;
    }


    /*** We cant give Track actual if DOS in future date*****/
    var differVal = this.findPastorFutureDate(this.carePath.dos, new Date().toDateString());

    if (differVal) {
      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.track_actual_dos.error'), '', {
        timeOut: this.timealert
      })
      return;
    }


    //Checking empty factility name berfore going actual
    // if(item.anonymousDischargeId && !item.anonymousDischargeHospitalMasterId && !item.hospitalStay){
    //   this.toast.error('Please fill in missing field in your care plan', '', {
    //     timeOut: this.timealert
    //   })
    //   item.anonymousfacilitynameRedAlert = true;
    //   return;
    // }




    /*** We cant enter actual with out  Hospital stay  discharge date*****/
    var firstItem = this.getFirstItem();
    if (!item.hospitalStay) {
      if (!firstItem.trackActualVisible || !firstItem.anonymousSnfDischargeDate) {
        this.toast.error(this.userService.translateText('hospital_portal.disp_messages.process_without_enter.error'), '', {
          timeOut: this.timealert
        })
        return;
      }
    }

    /**  Hightlight THD */
    if (!item.trackActualVisible && item.hospitalStay) {

      if (this.showthd) {
        item.anonymousenddateRedAlert = true;
        item.trackActualEmptyEndDate = true
      }
    }


    if (item.hospitalStay)
      this.hospitalstayTrackActual(item);


    if (item.hospitalStay)
      item.anonymousSnfDischargeDate = "";

    /**** If Click Track List Clear End Date ***/
    if (item.hospitalStay && !item.trackActualVisible) {
      item.anonymousSnfDischargeDate = "";
      /** Apply Discharge Date*/
      let minDate = this.changeFormatToDate(this.carePath.dos);
      item.anonymousSnfDischargeDatemindate = this.changeToDate(minDate);
      item.anonymousSnfDischargeDatemaxdate = new Date();
    }



    if (!item.hospitalStay && !item.trackActualVisible)
      item.anonymousSnfDischargeDate = "";

    item.trackActualVisible = true;
    item.trackActualEmptyEndDate = true;

    if (!item.hospitalStay && item.trackActualVisible && item.trackActualEmptyEndDate)
      item.anonymousSnfDischargeDate = "";



    if (!item.hospitalStay && item.anonymousDischargeId == -2) {

      item.anonymousOtherSelectedName = item.anonymousOtherSelectedName ? item.anonymousOtherSelectedName : item.plannedDdCpDetails.plannedOtherSelectedName;
      item.anonymousOtherFreeText = item.plannedDdCpDetails.plannedOtherFreeText;
      item.anonymousOtherPacContact = item.plannedDdCpDetails.plannedOtherPacContact;
      item.anonymousHospitalOtherPacMapId = item.anonymousHospitalOtherPacMapId ? item.anonymousHospitalOtherPacMapId : item.plannedDdCpDetails.plannedHospitalOtherPacMapId;
      item.anonymousOtherPacMasterId = item.plannedDdCpDetails.plannedOtherPacMasterId;
      item.anonymousOtherPacPhone = item.plannedDdCpDetails.plannedOtherPacPhone;
      item.anonymousOtherPacTeleCode = item.plannedDdCpDetails.plannedOtherPacTeleCode;
      item.anonymousOtherPacTeleCountryCode = item.plannedDdCpDetails.plannedOtherPacTeleCountryCode;
      item.anonymousOtherPacTurnedOn = true;
      if (item.plannedDdCpDetails.plannedOtherPacMasterId == 3 || this.carePath.disablepac)
        item.anonymousOtherPacTurnedOn = false
    }

    //  if(!item.hospitalStay && item.anonymousDischargeId==-3){

    //   //item.anonymousOtherSelectedName =  item.anonymousOtherSelectedName ?item.anonymousOtherSelectedName :item.plannedDdCpDetails.plannedOtherSelectedName;
    //  // item.anonymousOtherFreeText = item.plannedDdCpDetails.plannedOtherFreeText;
    //  // item.anonymousOtherPacContact = item.plannedDdCpDetails.plannedOtherPacContact;
    //   item.anonymousHospitalOtherPacMapId = item.anonymousHospitalOtherPacMapId ?item.anonymousHospitalOtherPacMapId :item.plannedDdCpDetails.plannedHospitalOtherPacMapId;
    //   item.anonymousOtherPacMasterId = item.plannedDdCpDetails.plannedOtherPacMasterId;
    //   item.anonymousOtherPacPhone = item.plannedDdCpDetails.plannedOtherPacPhone;
    //   item.anonymousOtherPacTeleCode = item.plannedDdCpDetails.plannedOtherPacTeleCode;
    //   item.anonymousOtherPacTeleCountryCode = item.plannedDdCpDetails.plannedOtherPacTeleCountryCode;
    //   //item.anonymousOtherPacTurnedOn = item.plannedDdCpDetails.plannedOtherPacMasterId==3 || this.carePath.disablepac ? false:true;


    //  }



    /***  Set Min and Max date for Track Actual End */
    this.notHospitalStayMinMaxDate(item)

    //  item.status ="InProgress";

    this.hospitalStayMinMaxDate(item);
    this.assignActuelORPlanned(item)


    //  //Checking empty factility name berfore going actual
    if (item.anonymousDischargeId != "7") {
      if ((!item.anonymousDischargeId || !item.anonymousDischargeHospitalMasterId || !item.anonymousAdmissionDate) && !item.hospitalStay) {
        //  this.toast.error('Please fill in missing field in your care plan', '', {
        //     timeOut: this.timealert
        //   })
        //   item.anonymousfacilitynameRedAlert = true;
        //   return;
        item.plannedDdCpDetails.plannedDischargeId = "";
        item.plannedDdCpDetails.plannedDischargeHospitalMasterId = "";
        item.plannedDdCpDetails.plannedAdmissionDate = "";
        item.plannedDdCpDetails.plannedSnfDischargeDate = "";
        item.plannedDdCpDetails.plannedLos = "";

      }
    }



  }


  notHospitalStayMinMaxDate(item) {
    /***  Set Min and Max date for Track Actual End */
    if (item.trackActualVisible && !item.hospitalStay) {

      /** Apply Discharge Date*/

      let minDate = this.changeFormatToDate(this.getAppliedDischargeDate());

      item.anonymousAdmissionDatemindate = this.changeToDate(minDate);
      item.anonymousAdmissionDatemaxdate = new Date();

      if (item.anonymousAdmissionDate != "") {
        let minDate1 = this.changeFormatToDate(item.anonymousAdmissionDate);
        item.anonymousSnfDischargeDatemindate = this.changeToDate(minDate1);
      }
      item.anonymousSnfDischargeDatemaxdate = new Date();
    }
  }

  getFirstItem() {
    if (this.PACEventsData.length > 0)
      return this.PACEventsData[0];
    else
      return null;
  }
  newfun(e) {
    this.showdatenew = e;
    ////console.log(this.showdatenew)

  }


  hospitalReadmission(currentData) {
    for (var item of currentData) {
      if (item.anonymousDischargeId == 6 || item.anonymousDischargeId == 9) {
        // this.flagAlreadyChooseReadmission = true;
        item.existingRaChanged = true;
        item.existingReadmissionDate = this.changeStringFormat2(item.anonymousAdmissionDate);
      }
    }
  }




  trackActualEndDateEmpty(currentData) {
    for (var item of currentData) {


      //Readmission Flag set true and set date
      if (item.anonymousDischargeId == 6 || item.anonymousDischargeId == 9) {
        // this.flagAlreadyChooseReadmission = true;
        item.existingRaChanged = true;
        item.existingReadmissionDate = this.changeStringFormat2(item.anonymousAdmissionDate);
      }

      // this.changeHReadmissionValue(item);

      if (item.trackActualVisible && item.pacFinished)
        item.trackActualEmptyEndDate = true;
      else if (item.trackActualVisible && !item.pacFinished) {
        item.trackActualEmptyEndDate = false;
        item.anonymousSnfDischargeDatemaxdate = null;

        /* alert(item.plannedDdCpDetails.plannedSnfDischargeDate); */

        if (item.plannedDdCpDetails.plannedSnfDischargeDate != "")
          item.anonymousSnfDischargeDate = this.changeFormatToDate(item.plannedDdCpDetails.plannedSnfDischargeDate);
      }
      else
        item.trackActualEmptyEndDate = false;

      /*  if(item.trackActualVisible && item.anonymousSnfDischargeDate=="")
            item.trackActualEmptyEndDate = true; */




      if (item.raOtherHspName != "" || item.raOtherHspName != null) {
        if (item.anonymousDischargeId == 6 && item.anonymousDischargeHospitalMasterId == "")
          item.anonymousDischargeHospitalMasterId = -2;
      }

      /** Other Name PAC Value Set -2 start here**/
      this.otherPACDefaultValueMinusTwo(item);


    }
  }

  isCurrent: boolean = false;
  findCurrentState() {
    this.isCurrent = false;
    for (var item of this.PACEventsData) {
      if (item.status == "InProgress")
        this.isCurrent = true;
    }

    this.changeCurrentState();
  }

  isNewCurrentState: boolean = false;
  changeCurrentState() {

    this.isNewCurrentState = false;
    if (!this.isCurrent) {
      for (var item of this.PACEventsData) {
        if (!this.isNewCurrentState) {
          if (item.status != this.userService.translateText('hospital_portal.mytodos.completed.label') && item.status != "Completed") {
            item.status = "InProgress";
            this.isNewCurrentState = true;
          }

        }
      }
    }
  }





  /** Contact Information Start Here **/

  currentContactItem: any;
  addContactDetails(contactDetails, item, index) {

    this.currentContactItem = item;
    this.getContactList(item);

    this.modalRef1 = this.modalService.show(contactDetails, {
      class: 'modal-lg',
      backdrop: 'static'
    })
    this.movable()
  }

  readmissionDetails(readmissions, item, index) {
    this.readmissionTemObj = item;
    this.readmissionReasonFlag = false;
    // this.getReadmisionDetails(item)

    // this.reason = item.raReason;
    this.reason = item.raReason ? item.raReason : '';
    this.tempReason = this.reason;
    this.otherReason = item.raOtherReason ? item.raOtherReason : '';
    this.modalRef1 = this.modalService.show(readmissions, {
      class: 'modal-md',
      keyboard: false,
      backdrop: 'static'
    })
    this.movable()
  }

  saveReadmission() {
    this.readmissionTemObj.raReason = this.reason;
    this.readmissionTemObj.raOtherReason = this.otherReason;
    this.tempReason = this.reason;

    /* alert(JSON.stringify(this.readmissionTemObj)); */

    ////console.log(JSON.stringify(this.readmissionTemObj))

    //this.saveReadmissionAPIService();
    this.modalRef1.hide();
  }
  tempReason: string = "";
  cancelReadmission() {
    if (this.tempReason == "") {
      this.readmissionTemObj.anonymousSnfDischargeDate = "";
      this.readmissionTemObj.status = this.raBackupStatus;
      this.readmissionTemObj.raReason = "";
    }
  }

  ContactDetailsLst: any;
  getContactList(item) {
    this.userService.fetchDischargeLocationContacts(this.hospitalid, this.user.patientSWFId, item.anonymousDischargeId, item.anonymousDischargeHospitalMasterId)
      .subscribe(data => {
        this.ContactDetailsLst = data;
        if (this.ContactDetailsLst.length == 0) {
          this.ContactDetailsLst.push({
            "code": '',
            "dischargeLocPhone": '',
            'dischargeLocContact': '',
            'selectedContact': false
          })
        }
        else {
          // var lastIndex = this.ContactDetailsLst[this.ContactDetailsLst.length - 1]
          // lastIndex.selectedContact =true;

          this.ContactDetailsLst.forEach(item => {
            if (item.dischargeTeleCode || item.dischargeTeleCountryCode)
              item.code = item.dischargeTeleCode + ',' + item.dischargeTeleCountryCode///
          });
        }
      })
  }


  selectContact(i) {
    // alert(event);
    this.ContactDetailsLst.forEach(item => {
      item.selectedContact = false;
    });

    this.ContactDetailsLst[i].selectedContact = true;
    // this.ContactDetailsLst[i].selectedContact = true;
  }

  temptakeSingleContact: any;
  saveContactDetails(saveType) {
    let takeSingleContact: any;
    let splittelecode: any;
    ////console.log(JSON.stringify(this.ContactDetailsLst))
    // if(saveType=='single'){
    takeSingleContact = this.ContactDetailsLst.find(i => !i.dischargeLocContact || !i.dischargeLocPhone || !i.code);
    ////console.log("takeSingleContact",takeSingleContact)
    //if(takeSingleContact!=undefined){

    if (takeSingleContact) {
      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.fill_selected_contact.error'))
      return false;
    }

    let selectRAdio = this.ContactDetailsLst.find(i => i.selectedContact);
    // takeSingleContact = this.ContactDetailsLst.find(i => i.selectedContact==true);
    //}
    ////console.log("selectRAdio", selectRAdio);
    if (selectRAdio == undefined) {
      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.choose_contact_to_add.error'))
      return false;
    }



    this.ContactDetailsLst.forEach(item => {
      splittelecode = item.code.split(',');

      item.dischargeHspMasterId = this.currentContactItem.anonymousDischargeHospitalMasterId
      item.dischargeTo = this.currentContactItem.anonymousDischargeHospitalMasterId
      item.patientSwfId = this.user.patientSWFId
      item.dischargeType = this.currentContactItem.anonymousDischargeId
      item.dischargeTeleCode = splittelecode[0]
      item.dischargeTeleCountryCode = splittelecode[1]
    });

    ////console.log("this.ContactDetailsLst",this.ContactDetailsLst)
    var tempObjt;
    //  = {
    //   "dischargeHspMasterId": this.currentContactItem.anonymousDischargeHospitalMasterId,
    //   "dischargeLocContact": takeSingleContact.dischargeLocContact,
    //   "dischargeLocPhone": takeSingleContact.dischargeLocPhone,
    //   "dischargeTeleCode": splittelecode[0],
    //   "dischargeTeleCountryCode": splittelecode[1],
    //   "dischargeTo":  this.currentContactItem.anonymousDischargeHospitalMasterId,
    //   "dischargeType": this.currentContactItem.anonymousDischargeId,
    //   "patientSwfId": this.user.patientSWFId,
    //   "contactId": takeSingleContact.contactId?takeSingleContact.contactId:0,
    //   "tableName": takeSingleContact.tableName?takeSingleContact.tableName:''
    // };

    if (this.ContactDetailsLst.length == 1) {
      this.saveDischargeLocationContacts('single', this.ContactDetailsLst)

    }
    else {
      this.temptakeSingleContact = tempObjt;
      this.openConactCheck(saveType);
    }


  }

  modalcontactCheck: BsModalRef;
  openConactCheck(saveType) {
    this.modalcontactCheck = this.modalService.show(saveType, {
      class: 'modal-ku',
      backdrop: 'static'
    })
    this.movable()
  }
  //this

  saveDischargeLocationContacts(saveType, tempObjt) {

    this.userService.saveDischargeLocationContacts(saveType, tempObjt)
      .subscribe(data => {
        if (this.modalcontactCheck != undefined) { this.modalcontactCheck.hide(); }
        this.modalRef1.hide()
        if (data.status == "success") {
          this.userService.logAudit("saveDischargeLocationContacts", 0).subscribe(data => { })
          this.toast.success(this.userService.translateText('patient_portal.display_messages.saved_successfully'), '', {
            timeOut: this.timealert
          })
        }
      })
  }


  addContact() {
    var contactDetails = {
      "code": '',
      "dischargeLocPhone": '',
      'dischargeLocContact': '',
      'selectedContact': false,
      "contactId": 0,
      "tableName": ''
    };
    var lastIndex = this.ContactDetailsLst[this.ContactDetailsLst.length - 1]
    //alert(JSON.stringify(index))

    // let tempCopyObjContact = JSON.parse(JSON.stringify(contactDetails))
    if (lastIndex.dischargeLocPhone && lastIndex.code && lastIndex.dischargeLocContact) {
      this.ContactDetailsLst.push(contactDetails);
    }
    else {
      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.fill_last_contact.error'))
    }

  }

  /*** Readmission SAVE and Fetch Service Start Here ****/
  reAdmissionDetail: any;
  /* test1:any; */
  getReadmisionDetails(item) {
    /* alert(JSON.stringify(item)); */
    /* this.test1 = JSON.stringify(item); */
    if (item.readmissionId != 0) {
      // this.userService.fetchReadmissionDetails(this.user.patientSWFId, item.readmissionId)
      //   .subscribe(data => {
      //     this.reAdmissionDetail = data;
      //     /*  alert(JSON.stringify(this.reAdmissionDetail)); */
      //     this.reason = this.reAdmissionDetail[0].reason;
      //     this.otherReason = this.reAdmissionDetail[0].otherReason;

      //   })
    }
  }

  resultSaveReadmission: any;
  otherReason: any;
  saveReadmissionAPIService() {
    var saveReadmissionData = { patientSwfId: "", readmissionId: "", reason: "", otherReason: "", hospitalId: "", otherHospitalName: "", readmissionDate: "" };
    saveReadmissionData.patientSwfId = this.user.patientSWFId;
    saveReadmissionData.readmissionId = this.readmissionTemObj.readmissionId;
    saveReadmissionData.reason = this.reason;
    saveReadmissionData.otherReason = this.otherReason;
    saveReadmissionData.hospitalId = this.currentUser.item.userAccountKey;
    saveReadmissionData.otherHospitalName = "";
    var strTemp = this.changeStringFormat2(this.readmissionTemObj.anonymousAdmissionDate);
    saveReadmissionData.readmissionDate = strTemp;

    // this.userService.saveReadmissionDetails(saveReadmissionData)
    //   .subscribe(data => {
    //     this.resultSaveReadmission = data;
    //     if (this.resultSaveReadmission.status == "success") {
    //       this.userService.logAudit("savePatientDbReadmission", 0).subscribe(data => { })
    //       /*  this.toast.success("Successfully Saved", '', {
    //          timeOut: this.timealert
    //        }) */
    //     }

    //   })
  }
  /* otherHSPReadmissionTemp:any;
  otherReadmissionHSPPopup(otherhospital)
  {
      this.otherHSPReadmissionTemp=otherhospital;
  } */


  otherHospitalName: any;
  showOtherHospitalNamePopup(otherhospital, item) {
    this.readmissionTemObj = item;
    if ((item.anonymousDischargeId == 6 || item.anonymousDischargeId == 8 || item.anonymousDischargeId == 9) && item.anonymousDischargeHospitalMasterId == 'Other') {

      this.modalRef1 = this.modalService.show(otherhospital, {
        class: 'modal-md',
        keyboard: false,
        backdrop: 'static'
      })
      this.movable()
    }
  }
  cancelOtherHSPReadmission() {
    this.readmissionTemObj.anonymousDischargeHospitalMasterId = "";
    this.modalRef1.hide();
  }

  saveOtherHSPReadmission() {
    if (this.readmissionTemObj.anonymousDischargeId == "6" || this.readmissionTemObj.anonymousDischargeId == "9") {
      this.readmissionTemObj.raOtherHspName = this.otherHospitalName;
      this.readmissionTemObj.anonymousDischargeHospitalMasterId = -2;
    }
    else if (this.readmissionTemObj.anonymousDischargeId == "8") {
      if (!this.readmissionTemObj.trackActualVisible) {
        this.readmissionTemObj.plannedDdCpDetails.plannedHtOtherHspName = this.otherHospitalName
        this.readmissionTemObj.htOtherHspName = this.otherHospitalName
        this.readmissionTemObj.anonymousDischargeHospitalMasterId = -3;
        this.readmissionTemObj.plannedDdCpDetails.plannedDischargeHospitalMasterId = ""
        this.readmissionTemObj.anonymousHtOtherHspName = this.otherHospitalName
      }
      else {
        this.readmissionTemObj.anonymousHtOtherHspName = this.otherHospitalName
        this.readmissionTemObj.htOtherHspName = this.otherHospitalName
        this.readmissionTemObj.anonymousDischargeHospitalMasterId = -3;
      }
    }
    // else if(this.readmissionTemObj.anonymousDischargeId=="9"){
    //   this.readmissionTemObj.edOtherHspName= this.otherHospitalName;
    //   this.readmissionTemObj.anonymousDischargeHospitalMasterId = -4;
    // }

    this.modalRef1.hide();
    this.otherHospitalName = "";
  }
  showapp() {

    this.userService
      .showappointment(this.currentUser.item.userAccountKey)
      .subscribe(
        data => {
          this.showbutton = data[0].isCustomAppmntConfigured
          ////console.log( this.showbutton)
        })
  }

  /*** Readmission SAVE and Fetch Service End Here ****/




  /*
    readmission(readmission,item,index){
      this.getContactList();

      this.modalRef1 = this.modalService.show(readmission, {
        class: 'modal-md',
        backdrop: 'static'
      })
  } */



  /***********   Multi PAC EVENT NEW TEMPLATE END HERE  *************/
  printpagenew(): void {
    window.open(this.pdfUrl, '_blank', 'top=0,left=0,height=100%,width=auto');
  }

  checkAppEmpty(i) {

    let self = this;
    if (this.patientAppoinmentList.length > 1) {
      if (self.patientAppoinmentList[i].appointmentDate == '' || self.patientAppoinmentList[i].appointmentDate == null) {
        return true
      }
      else {
        return false
      }
    }
  }


  lstReason: any = [
    {
      label: this.userService.translateText('hospital_portal.patientls.pain_in_the_surgical_site.label'),
      value: 'Pain in the surgical site'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.infection.label'),
      value: 'Infection'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.joint_dislocation.label'),
      value: 'Joint Dislocation'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.heme.label'),
      value: 'Heme'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.wound_dehiscence.label'),
      value: 'Wound Dehiscence'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.fracture.label'),
      value: 'Fracture'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.pe.label'),
      value: 'PE'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.dysrhythmias.label'),
      value: 'Dysrhythmias'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.dvt.label'),
      value: 'DVT'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.pneumonia.label'),
      value: 'Pneumonia'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.mi.label'),
      value: 'MI'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.constipation.label'),
      value: 'Constipation'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.fall.label'),
      value: 'Fall'
    },
    {
      label: this.userService.translateText('hospital_portal.patientls.other.label'),
      value: 'Other'
    }
  ];  



  checkphonelength(e) {
    this.carePath.dPhone = "";
    let telecode = e.split(',')
    let codecoun = telecode[1]
    this.userService.phonebycountrycode(codecoun)
      .subscribe(
        data => {
          this.setlength = data.Length;
          this.maxlen = data.Length + this.currentUser.item.length;
          if (this.setmask.length != this.maxlen) {
            this.setmask = ''
            this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
          } else {
            this.setmask = this.currentUser.item.phoneFormat.split('#').join('0')
          }
        }
      );
  }

  checkphonelength2(e) {
    this.carePath.dPhone = "";
    let telecode = e.split(',')
    let codecoun = telecode[1]
    this.userService.phonebycountrycode(codecoun)
      .subscribe(
        data => {
          this.setlength2 = data.Length;
          this.maxlen2 = data.Length + this.currentUser.item.length;
          if (this.setmask2 && this.setmask2.length != this.maxlen2) {
            this.setmask2 = ''
            this.setmask2 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
          } else {
            this.setmask2 = this.currentUser.item.phoneFormat.split('#').join('0')
          }
        }
      );
  }

  checkphonelength3(e, i) {
    this.ContactDetailsLst[i].dischargeLocPhone = "";
    let telecode = e.split(',')
    let codecoun = telecode[0]
    this.userService.phonebycountrycode(codecoun)
      .subscribe(
        data => {
          let self = this;
          self.setlength3 = data.Length;
          self.maxlen3 = data.Length + self.currentUser.item.length;
          if (self.setmask3.length != self.maxlen3) {
            self.setmask3 = ''
            self.setmask3 = self.currentUser.item.phoneFormat.split('#').join('0').concat('0')
          } else {
            self.setmask3 = self.currentUser.item.phoneFormat.split('#').join('0')
          }
        }
      );
  }

  checkingPhoneNumberLength(e, i) {
    this.setlength3 === undefined ? this.checkphonelength3(e.code, i) : ''
    this.setmask3
    this.maxlen3
    this.currentUser
    if (e.dischargeLocPhone.length >= this.setlength3 || e.dischargeLocPhone.length == 10) {


      this.contactSaveBtn = false
    }
    else {

      this.contactSaveBtn = true
    }

  }

  checkphonlength(e) {
    let telecode = e.split(',')
    let codecoun = telecode[0]
    this.userService.phonebycountrycode(codecoun)
      .subscribe(
        data => {
          this.setlength3 = data.Length;
          this.maxlen3 = data.Length + this.currentUser.item.length;
        }
      );
  }
  getdate(date) {
    try {
      if (this.currentUser.item && date) {
        if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
          return this.Datepipe.transform(date, environment.dateForm);
        } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
          return this.Datepipe.transform(date, 'dd/MM/yyyy');
        } else {
          return ''
        }
      } else {
        return ''
      }
    } catch (Exception) {
      return ''
    }

  }
  getdatetime(date) {
    if (this.currentUser.item)
      if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
        return this.Datepipe.transform(date, 'MM/dd/yyyy hh:mm a');
      } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
        return this.Datepipe.transform(date, 'dd/MM/yyyy hh:mm a');
      }
  }
  getdatetime1(date) {
    date = new Date(date);
    if (typeof date != 'string' && (date != '') && date != null && date != 'Invalid Date') {

      return this.Datepipe.transform(date, 'hh:mm a');
    }
    else {
      return "";
    }
  }

  getPlannedInterval() {
    this.patientservice.getHospitalPlannedDischargeDateInterval(this.hospitalid, this.userId)
      .subscribe(data => {
        this.dayinterval = data.plannedDischargeDayValue;
      })
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }

  mask: any;
  eyemask() {
    var sd = document.getElementById("change-arrow");

    if (this.mask) {
      this.mask = false;
      sd.setAttribute("class", "fa fa-caret-right");

    } else {
      this.mask = true;
      sd.setAttribute("class", "fa fa-caret-down");
    }
  };
  mask1: any;
  eyemask1() {
    var sd = document.getElementById("change-arrow1");

    if (this.mask1) {
      this.mask1 = false;
      sd.setAttribute("class", "fa fa-caret-right");

    } else {
      this.mask1 = true;
      sd.setAttribute("class", "fa fa-caret-down");
    }
  };

  getdatedos() {
    if (this.dosstatus) {
      var splitDate1 = this.params.dos.split('-');
      if (splitDate1.length > 0) {
        var year1 = splitDate1[0];
        var month1 = splitDate1[1];
        var day1 = splitDate1[2];
        var dos = month1 + "/" + day1 + "/" + year1;
        this.carePath.dos = new Date(dos)
      }

      if (this.PACEventsData.length > 0) {
        this.onDOSChangePacEventValidate();
        this.onTopDOSDateChange();
      }
      this.preSavePACKEvent(this.autoAdjust, this.deleteEmpty, this.endDateEmptyTemplate)
    }
  }


  hospitalList: any;
  getEpisodeAppointmenthospitallist(patSwfid) {
    this.patientservice
      .getEpisodeAppointmenthospitallist(this.currentUser.item.userAccountId, patSwfid)
      .subscribe(
        data => {
          // this.temp_var = true;
          this.hospitalList = data.aaData;

          this.hospitalList.forEach(item => { item.otherAppmntHspMasterName == null ? item.otherAppmntHspMasterName = "" : item.otherAppmntHspMasterName })
          //console.log("this.hospitalList",this.hospitalList)
        }
      );
  }


  validTime: boolean = true;
  isValid(event: boolean, item, index): void {
    item.validTime = event;
    if (!item.validTime && !item.appointmentTime && item.appointmentDate && item.appointmenttimechange) {
      item.validTime = false
      //item.appointmentTime = void 0;
      setTimeout(() => {
        item.validTime = false;
      }, 10)



      this.toast.error(this.userService.translateText('hospital_portal.appointments.please_choose_valid_time.error'), '', {
        timeOut: this.timealert
      });

    }
    else {
      //item.appointmentTime = void 0;
      setTimeout(() => {
        item.validTime = true;
      }, 10)

    }
    // if(item.appointmentDate && item.selectHospital && !event){
    //   setTimeout(() => {
    //     item.appointmentTime = void 0;
    //   //  this.validTime
    //   }, 10);
    // }
    item.appointmenttimechange = true;
    this.validTmecheck(item)
  }

  validTmecheck(app) {
    let index = _.findIndex(this.patientAppoinmentList, (o: any): any => {
      return !o.validTime
    })

    if (index == -1) {
      this.validTime = true
    }
    else {
      this.validTime = false
    }

  }

  appointTimeChange(event, item) {
    let checkTime, checkmin: any;
    //console.log(event, "Appointmentchange")
    if (event) {
      checkTime = event.getHours();
      checkmin = event.getHours();
      if (checkTime < 7 || checkTime > 19 || (checkTime == 19 && checkmin > 0)) {


        setTimeout(() => {
          item.appointmentTime = void 0;
        }, 10);

        this.toast.error(this.userService.translateText('hospital_portal.appointments.please_choose_appointment_time.error'), '', {
          timeOut: this.timealert
        });
        // this.patientAppoinmentList[i].appointmentTime.setMinutes(null);
        // this.patientAppoinmentList[i].appointmentTime.setSeconds(null);
        //  try{
        //  item.appointmentTime.getDate(new Date())
        //}
        // catch(e){

        // }
        // item.setMinutes(null);
        // item.setSeconds(null);

      }
    }
  }


  changeHospi(appoinmentDetails, event) {
    //console.log(appoinmentDetails,"Appointment List")

    //console.log(event,"Event")

    if (event && event != -2) {
      let hospiList = this.hospitalList.filter(it =>
        it.name.toLowerCase() == event.toLowerCase());
      let mapList = this.hospitalList.filter(it =>
        it.otherAppmntHspMasterName.toLowerCase() == event.toLowerCase());

      //console.log(hospiList, "hospiList")
      setTimeout(() => {
        if (hospiList.length >= 1) {
          appoinmentDetails.hospitalId = hospiList[0].hospitalId;
          // appoinmentDetails.hospitalName = hospiList[0].name;
          appoinmentDetails.otherAppmntHspMasterId = "";
          appoinmentDetails.otherAppmntHspMasterName = "";
          appoinmentDetails.selectHospital = hospiList[0].name;
        }
        else if (mapList.length >= 1) {
          appoinmentDetails.hospitalId = "";
          appoinmentDetails.hospitalName = "";
          appoinmentDetails.otherAppmntHspMasterId = mapList[0].otherAppmntHspMasterId;
          // appoinmentDetails.otherAppmntHspMasterName = mapList[0].otherAppmntHspMasterName;
          appoinmentDetails.selectHospital = mapList[0].otherAppmntHspMasterName;
        }
        else {
          appoinmentDetails.hospitalName = "";
          appoinmentDetails.hospitalId = "";
          appoinmentDetails.otherAppmntHspMasterId = "";
          appoinmentDetails.otherAppmntHspMasterName = event
        }
      }, 10)

    }

    // if(event==-2){
    //   setTimeout(()=>{
    //      appoinmentDetails.hospitalName = "";
    //       appoinmentDetails.otherAppmntHspMasterId = "";
    //      appoinmentDetails.otherAppmntHspMasterName = "";
    //      appoinmentDetails.hospitalId = event;
    //     // appoinmentDetails.otherAppmntHspMasterName = element.selectOtherHospital
    //   },10)
    // }


  }


  checkIfOtherAppmntNameAlreadyExists(app, event) {
    this.patientservice.checkIfOtherAppmntNameAlreadyExists(this.currentUser.item.userAccountKey, event)
      .subscribe(data => {

        if (data.status == "true") {
          app.selectOtherHospital = "";
          app.otherAppmntHspMasterName = app.selectOtherHospital
          this.toast.error(this.userService.translateText('hospital_portal.appointments.appointment_hospital_already_exists.error'), '', {
            timeOut: this.timealert
          })
        }
        else {
          app.otherAppmntHspMasterName = app.selectOtherHospital
        }
      })
  }

  invalidEmailRedirect() {

  }

  getmask(setmask, code) {
    this.userService.phonebycountrycode(code)
      .subscribe(
        data => {
          let maxlen1 = data.Length + this.currentUser.item.length;
          if (setmask.length != maxlen1) {
            setmask = ''
            return this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
          } else {
            return this.currentUser.item.phoneFormat.split('#').join('0')
          }
        }
      );
  }

  redirecttodasboard(app) {
    console.log(app, "app")
    this.showloader = false
    // if(app.pswIsActive) {
    let tempvar = { patSWFId: app.patSwfid }
    window.localStorage['activepswfid'] = btoa(JSON.stringify(tempvar))
    this.userService.setTempVar(tempvar)
    this.nav.navigate([`care/patientsummary`]);
    setTimeout(() => {
      //location.reload();
      this.ngOnInit();
      this.showloader = true
    }, 100);

    // }

  }

  backFn() {
    if (window.localStorage['activepswfid']) {
      let tempvar = JSON.parse(atob(window.localStorage['activepswfid']))
      this.userService.setTempVar(tempvar)
      this.nav.navigateByUrl(`care/patientsummary`)
      setTimeout(() => {
        //location.reload();
        this.ngOnInit();
        this.showloader = true
      }, 100);
    } else {
      this.nav.navigateByUrl(`care/patientlist`)
    }
  }

  markAsDirty() {
    this.form.control.markAsDirty()
  }

  getSurgeryCenter() {
    if (this.currentUser.item && this.currentUser.item.clientType.search("SC") != -1)
      return false;
    else
      return true
  }

  navToPatDetails(user, status) {
    let patDetails = {
      'patientId': user.patientId,
      'patientSWFId': user.patientSWFId,
      'patstatus': user.patientStatus,
      'status': status
    }
    window.localStorage['patDetails'] = btoa(JSON.stringify(patDetails))
    this.nav.navigateByUrl(`/care/patientdetails`)
  }
  invalidMobileRedirect() {
    if (this.user.patientStatus != 'Deactivate') {
      if ((!this.disabled && !this.surdis) && (!this.user.patPhoneValid && this.user)) {
        this.navToPatDetails(this.user, false)
      }
      if ((!this.disabled && this.surdis) && (!this.user.patPhoneValid && this.user)) {
        this.navToPatDetails(this.user, true)
      }
      if ((this.disabled && !this.surdis) && (!this.user.patPhoneValid && this.user)) {
        this.navToPatDetails(this.user, true)
      }
      if ((this.disabled && this.surdis) && (!this.user.patPhoneValid && this.user)) {
        this.navToPatDetails(this.user, false)
      }
    }
  }

  //Image Upload in message tab
  croppedImage: string;
  cropperReady: boolean;
  imageChangedEvent: any;
  upimage: any;
  document(template: TemplateRef<any>) {
    this.croppedImage = '';
    this.modalRef = this.modalService.show(template, {
      class: 'modal-lg wide',
      backdrop: 'static'
    })
    showMarkerArea();
  }
  public pad: any = {

  };
  clearall() {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.pad.note = '';
    this.upimage = ''
    window.localStorage.removeItem('imgEditor')
  }
  getDownloadData() {
    let data: any = {
      'dataMode': 'real',
      'preview': false,
      'docType': 'PDF',
      'vtype': 'design',
      'formType': 'inprogress',
      'watermark': false,
      'assignedId': '',
      'productId': this.userId,
      'userId': this.currentUser.item.userAccountId,
      lang: this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    window.open(this.downloadUrl + data);
  }
  getdownloadContact(type) {
    let data: any = {
      'type': type,
      'patientSwfId': this.userId,
      'lang': this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    window.open(this.apiurl + '/pages/downloadContactsReport.xhtml?dvalue=' + data);
  }
  downloadBundleHis() {
    let data: any = {
      'type': this.messages,
      'bundlePatientId': this.user.bundleid,
      'preview': false,
      'loginUserId': this.uid,
      lang: this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    window.open(this.apiurl + '/pages/downloadBundleHistory.xhtml?dvalue=' + data);
  }

  openSurveyModal(template: TemplateRef<any>) {
    this.ModelRef = this.modalService.show(template, { class: 'modal-lg', backdrop: 'static' })
  }

  showExportSurveyData: any = {}
  showExportSurvey() {
    var patientSwfId = { "patientSwfId": this.user.patientSWFId }
    this.userService.showExportSurvey(patientSwfId).subscribe(data => { this.showExportSurveyData = data })
  }
}
